import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import { PayloadType } from '@xpo-ltl/sdk-common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class DockOperationsApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation sets the default door plan profile provided to Active (Current). Only one door plan profile per SIC and shift can be active at one time.  The existing active door plan profile will be deleted.
     * <br/>		Either doorPlanProfileId OR sicCd, shiftCd, and profileName must be provided.  If doorPlanProfileId is provided along with SIC and shift, then doorPlanProfileId will be used and the other fields will be ignored.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid doorPlanProfileId is provided which exists and is for the default door plan.
     * <br/>Post-conditions: The default door plan profile is used to update the existing active door plan for the same SIC and shift.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid sicCd, shiftCd, and profileName are provided for the existing default door plan.
     * <br/>Post-conditions: The default door plan profile is used to update the existing active door plan for the same SIC and shift.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: The input provided is invalid.
     * <br/>Post-conditions: A validation error will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    activateDoorPlanProfile(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/activations'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation backsynchs the data for the current active door plan profile and transforms and backsynchs to legacy tables LOC_DOOR_PLAN% and SCO_DOOR_ASGMNT in DB2.
     * <br/>	Either doorPlanProfileId OR sicCd and shiftCd must be provided.  The doorPlanProfileId must be for an ACTIVE (CURRENT) profile.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid doorPlanProfileId is provided, which exists and is for the active door plan.
     * <br/>Post-conditions: The active door plan profile is backsynched to legacy tables in DB2.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid sicCd and shiftCd are provided for the existing active door plan.
     * <br/>Post-conditions: The active door plan profile for the input SIC and shift is used to backsynch to legacy tables in DB2.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: The doorPlanProfileId is invalid.
     * <br/>Post-conditions: A status code 404 - No data found is returned.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-conditions: The doorPlanProfileId is valid, but the profile type is DEFAULT.
     * <br/>Post-conditions: A status code 400 - Bad request is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    backsynchDoorPlanProfileToDb2(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/db2-backsynchronization'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates an active door plan for the service center and shift based on the door plan information provided.
     * <br/>
     * <br/>Mandatory input: Either lane (moveToSicCd and closeToSicCd combination) or 1 destinationSicCd must be provided along with doorNbr.
     * <br/>	The input sicCd, moveToSicCd, closeToSicCd, and destinationSicCd must be valid active and linehaul SICs.
     * <br/>	If lane (moveToSicCd and closeToSicCd) is provided along with the doorNbr, then a list of destinationSicCds for the moveToSicCd and closeToSicCd combination will be derived from the Freightflow Network path and will be populated in the door plan table.
     * <br/>	If 1 destinationSicCd is provided along with doorNbr, then closeToSicCd will be set the same as destinationSicCd and moveToSicCd will be derived as the very first move leg from the input SIC to destinationSicCd.
     * <br/>	If moveToSicCd along with 1 or more destinationSicCds are provided, then the common farthest load leg will be used to derive the closeToSicCd.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC and shift are provided.  The doorNbr must be a valid doorNbr at the SIC provided and mandatory input is supplied as mentioned above.  The service center must be an active linehaul SIC.  The SIC can be a host SIC or a zone with a physical service center.
     * <br/>Post-conditions: The door plan is created for input door and lane.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid SIC and shift are provided. The doorNbr is not a valid door at the SIC provided.
     * <br/>Post-condition: A status code of 404 will be returned with the following error message: Input Door not found at the SIC.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A valid SIC and shift are provided. The doorNbr is already assigned to another door plan.
     * <br/>Post-conditions: A status code of 400 will be returned with the following error message: Door is already assigned to another lane.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-conditions: A valid SIC and shift are provided. The destinationSicCd is not a valid SIC.
     * <br/>Post-conditions: A status code of 400 will be returned with the following  error message: Destination SIC is not a valid or active linehaul SIC.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createActiveDoorPlanForSic(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/active-door-plans'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates a door plan for a given door and door plan profile and then returns a list of all the door plans.
     * <br/>
     * <br/>Validations:
     * <br/>	- moveToSicCd and closeToSicCd are optional and if provided then they must be a valid linehaul active SIC and also valid for the destinationSicCds.
     * <br/>	- At least one doorPlanDestination must be provided.  Either the doorPlanDestinationSicCode, destinationPostalCd, legacyCisCustomerNbr, or customerLocationFuncId must be provided and valid.  The doorPlanDestination's destinationSicCode must be a valid and active linehaul SIC.
     * <br/>	- The doorPlanProfileId provided must be for an active profile.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorPlan for one or more doors are provided.  The moveToSicCd and closeToSicCd are not provided, but the destinationSicCode is. The destinationSicCode doesn't have a Priority 1 door already created under the profile.
     * <br/>Post-conditions: A Priority 1 door plan for the destination is created.  The moveToSicCd and closeToSicCd are derived.  All door plans for the profile provided are returned.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorPlan for one or more doors are provided.  The moveToSicCd and closeToSicCd are not provided, but the destinationSicCode is. destinationSicCode has a Priority 1 door already created under the profile.
     * <br/>Post-conditions: If the Priority 1 door plan already exists for the destination SIC code, then the destination is removed from the existing Priority 1 door.  The existing door plan is updated by deriving a new close-to SIC code and the destination is removed.  A new Priority 1 door plan for the destination provided is created.  The moveToSicCd and closeToSicCd are derived.  All door plans for the profile provided are returned in the response.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorPlan for one or more doors are provided.  The moveToSicCd and closeToSicCd are not provided, but more than one destinationSicCode is.  All destinations have the same moveToSicCd as per the freight flow network path.
     * <br/>Post-conditions: A Priority 1 door plan for all the destinations is created.  The moveToSicCd and closeToSicCd are derived.  All door plans for the input profile are returned in the response.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorPlan for one or more doors are provided.  The moveToSicCd and closeToSicCd are not provided, but more than one destinationSicCodes are. Some destinations have a different moveToSicCd.
     * <br/>Post-conditions: A Status 400 error is returned including the following message: Destinations supplied have different Move To SIC codes.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createDoorPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation adds destinations to an existing active door plan profile and a given door number.  The door plan profile must be of type Active. The door number must have a door plan already created. At least one destinationSicCode must be suppplied.
     * <br/>Validations:
     * <br/>	- The destinationSicCode must be an active linehaul SIC.
     * <br/>	- The move to SIC code of the host destination SIC must be the same as an existing door plan firstLoadPointSicCd. If it isn't, then the destination can't be added to the door and an error message will be returned.
     * <br/>	- If the destinationSicCode is a host SIC, then add all of its satellite and zone locations as well.
     * <br/>	- If the door numbr provided is a Priority 1 door plan and a priority 1 door plan already exists for the destinationSicCode provided, then that destination along with its satellite and zone locations are removed from the existing door and addded to the new door.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorNbr are provided.  The doorNbr has an associated door plan.  At least one door plan destination SIC code is provided and the door plan destination SIC code has the same moveToSic as the existing door plan.
     * <br/>Post-conditions: The destinations are added to the existing door plan associated with the profile and door number provided.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorNbr are provided.  The doorNbr does not have an associated door plan.  At least one door plan destination SIC code is provided and the door plan destination SIC code has the same moveToSic as the existing door plan
     * <br/>Post-conditions:  A Status 400 - Bad Request error is returned with the following message: Input door nbr does not have a door plan.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A valid doorPlanProfileId and doorNbr are provided.  At least one door plan destination SIC code is provided and invalid.  It also has the same moveToSic as the existing door plan.
     * <br/>Post-conditions: A Status 400 - Bad Request error is returned with the following message: Input destination SIC code is not a valid linehaul SIC.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createDoorPlanDestinations(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/doors/{doorNbr}/destinations'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates a door plan profile for a given service center and shift. The service center must be an active linehaul SIC. The SIC can be a host SIC or a zone with a physical service center. If the door plans are not provided, then only the Door Plan Profile is created. If profileTypeCd is not supplied, then a DEFAULT profile will be created.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC and shift are entered and the profile doesn't exist for the input profileName and profileType combination.
     * <br/>Post-conditions: A door plan profile for the input SIC, shift, profileName, and profileType is created.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: The profile type code is not supplied and the DEFAULT door plan profile already exists for the provided SIC, shift, and profileName.
     * <br/>Post-conditions: A new record is not created and the existing DEFAULT door plan profile details are returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A door plan profile for the matching SIC, shift, and profile type exists, but the profileName is different.
     * <br/>Post-conditions: The existing door plan profile is deleted and a new door plan profile is created.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createDoorPlanProfile(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/door-plan-profiles'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation derives the most efficient load lanes (move-to and close-to SIC combinations) to effectively create the loads and save the results to the Lane Summary tables.  It will read the list of shipments that are included in the Dock Plan (SIC and shift).  At least one planDate must be provided. If more than one plan date is supplied, then the load lanes will be derived based on the average weight and cube of the shipments as of the plan dates provided.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid sicCd, shiftCd, and planDate are provided. The sicCd must be a valid linehaul SIC.
     * <br/>Post-condition: The load lanes are saved based on the shipments in the dock plan as of the planDate provided.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: One or more planDates are provided along with a valid and active linehaul sicCd and shiftCd.
     * <br/>Post-condition: The load lanes, based on the shipments in all of the plans, are derived by averaging the shipment weight and cube.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid SIC and shift are provided, but no door plan exists for the planDate provided.
     * <br/>Post-condition: A 404 - Not Found error message is returned.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createLoadLanesByDockPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/load-lanes'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates a weekly default door plan for the service center and shift provided. The service center must be an active linehaul SIC. The SIC can be a host SIC or a zone with a physical service center. If the door plans are not provided, then only the Door Plan Profile is created. If profileTypeCd is not supplied, then a DEFAULT profile will be created.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC and shift are entered and the profile doesn't exist for the input profileName and profileType combination. Optionally, weekDayCd can be provided.
     * <br/>Post-conditions: A door plan profile for the SIC, shift, profileName, and profileType is created. If weekDayCd is provided, then only create the door plan profile for that day.  Otherwise create it for all days.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: The profile type code is not supplied and the DEFAULT door plan profile already exists for the provided SIC, shift, and profileName.
     * <br/>Post-conditions: A new record is not created and the existing DEFAULT door plan profile details are returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A door plan profile for the matching SIC, shift, and profile type exists, but the profileName is different.
     * <br/>Post-conditions: The existing door plan profile is deleted and a new door plan profile is created.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createWeeklyDefaultDoorPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/weekly-door-plans'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation deletes an existing door plan based on the profile ID and door number provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid doorPlanProfileId and doorNbr are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan is deleted.
     * <br/>2. If not found, then a 404 - Not Found error message is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteDoorPlan(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/{doorNbr}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation deletes an existing door plan profile based on the profile ID.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A door plan profile ID must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan profile is deleted.
     * <br/>2. If the door plan profile doesn't exist, then a 404 - Not Found error message is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteDoorPlanProfile(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation derives the most efficient load lanes (move-to and close-to sic code combinations) to effectively create the loads. The operation will read the list of shipments that are included in the Dock Plan (SIC, shift). At least one planDate must be provided. If more than one plan date is supplied, then the load lanes will be derived based on the average weight and cube of the shipments as of the plan dates provided.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: Mandatory data is provided: sicCd, shiftCd and 1 planDate. The sicCd must be a valid linehaul SIC.
     * <br/>Post-condition: Load lanes are returned based on the shipments in the dock plan as of the planDate provided.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: One or more planDates are provided along with a valid and active linehaul sicCd and shiftCd.
     * <br/>Post-condition: Load lanes based on the shipments in all of the plans are derived by averaging the shipment weight and cube.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid SIC and shift are provided, but no door plan exists for the planDate provided.
     * <br/>Post-condition: A 404 - Not Found error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deriveLoadLanesByDockPlan(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/load-lanes'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will retrieve the Door Plan profile of profile type CURRENT for the shift and SIC provided. Each SIC and shift will only have one active profile.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the active door plan profile information is returned.
     * <br/>2. If the door plan profile doesn't exist, then a 404 - Not Found error message is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getActiveDoorPlan(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/door-plan-profiles/active'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a list of destinations grouped together by their load lanes (moveToSic and closeToSic) along with the freight flow path.  The information about the list of shipments included in the dock plan for each lane is returned.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd, shiftCd, moveToSicCd, and closeToSicCd are provided. The moveToSicCd and closeToSicCd have at least one destination in the freight flow path.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of destinations along with the freight flow path is returned in the response.
     * <br/>2. If the moveToSicCd and closeToSicCd combindation was invalid, then a 404 - Not Found error is returned with an empty list.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDestinationsByLoadLane(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/move-to-sics/{moveToSicCd}/close-to-sics/{closeToSicCd}/destinations'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the door plan profile and all door plans associated with it based on the profile ID provided.  The door plan profile  must be valid.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Door plan profile exists for the input doorPlanProfileId.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan profile and associated door plans are returned.
     * <br/>2. If a door plan profile doesn't exist for the profile ID provided, then a 404 - Not Found status code is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDoorPlanById(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves one or more door plans that can be merged with the door provided. For the SIC, shift, and doorNbr provided, the standard freight flow path from the SIC to all the destinations of the door is retrieved. Other door plans that follow the same standard freight flow path are identified and returned.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC, shift and doorNbr must be provided.The input doorNbr has a door plan and 1 or more door plans are found that can be merged with input door.
     * <br/>Post-conditions: A status code of 200 is returned along with fromDoorPlan (input door) and mergeToDoorPlans.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid SIC, shift, and doorNbr must be provided.  The doorNbr does not have a door plan.
     * <br/>Post-conditions: A status code of 400 is returned along with the following message: Input Door does not have a door plan.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A valid SIC, shift, and doorNbr must be provided. The doorNbr has a door plan, but no mergeToDoorPlans are found.
     * <br/>Post-conditions: A status code of 404 is returned aloing with the following message: No Door plans found that can be merged with input door.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDoorPlanMergeOptions(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/door-plans/{doorNbr}/merge-options'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the door plan profile details for a given SIC, shift, and profile type. The SIC must be an active linehaul SIC.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The door plan profile must exist for the SIC, shift, and profile type.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan profile information is returned.
     * <br/>2. If the door plan profile doesn't exist, then a 404 - Not Found error message is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDoorPlanProfile(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/door-plan-profiles/{profileTypeCd}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the Lane Summary data for a given plan SIC and shift. If the optional date is not supplied, then the current date will be used. There could be multiple runs per day for the plan SIC and shift, so the most recent run data will be returned.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid plan SIC and shift are provided and there is lane summary data for the current date.
     * <br/>Post-condition: The Lane summary data will be returned along with a status code of 200.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: An invalid plan SIC is provided.
     * <br/>Post-condition: A status code of 400 - Bad Request is returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid plan SIC is provided, but there is no data for the shift and date.
     * <br/>Post-condition: A status code of 404 - Not Found is returned.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getLoadLaneSummaryByPlanSicAndShift(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/load-lane-summary'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists the dock shipment summaries for the list of shipments that are included in the dock plan (SIC and shift).
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of dock shipment summaries for destinations will be returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDockShipmentSummaries(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/dock-shipment-summaries'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists destinations that are marked as Headload for a given door plan profile and door number.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid doorPlanProfileId along with doorNbr is supplied and the door has destinations marked as headload.
     * <br/>Post-condition: The list of headload destinations are returned.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid doorPlanProfileId along with doorNbr is supplied and the door does not have destinations marked as headload.
     * <br/>Post-condition: A 404 - Not Found is returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: doorPlanProfileId is invalid OR the profile is not active.
     * <br/>Post-condition: A 400 (bad data) is returned.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDoorPlanHeadloadDestinations(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/{doorNbr}/headload-destinations'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists Door Plan Profiles for a given SIC.
     * <br/>
     * <br/>Mandatory input: sicCd
     * <br/>Optional input:
     * <br/>	- shiftCd: Must be a valid shift (Outbound, NightFAC, Inbound or DayReship).
     * <br/>	- profileTypeCd: Must be either CURRENT or DEFAUL if provided.
     * <br/>	- listInfo.levelOfDetail - If provided and value = 'full', then the response will include the associated door plans and door plan destinations for the profile.  If levelOfDetails is not provided or the value is not = 'full', then only the doorPlanProfile list will be returned.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. The sicCd must be a valid linehaul and active SIC.
     * <br/>2. At least one door plan must exist for that SIC.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan profile information is returned along with a status code of 200.
     * <br/>2. If the sicCd doesn't have any Door Plan Profiles set up, then a 404 - Not Found status code is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDoorPlanProfiles(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/door-plan-profiles'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists the door plan recommendations for a door plan profile based on the profile ID provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid doorPlanProfileId is provided and the associated door plan profile exists.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan recommendations for the door plan profile are returned.
     * <br/>2. If a door plan profile doesn't exist for the profile ID provided, then a 404 - Not Found status code is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDoorPlanRecommendations(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/recommendations'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation derives and returns the headload destination for each door plan for a given SIC and shift (door plan profile).
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid door plan profile ID is supplied for an active profile (SIC and shift).
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the headload destination is returned for each door plan.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listHeadloadDestinationsByDoorPlanProfile(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/headload-destinations'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation reads the list of shipments that are included in the dock plan (SIC and shift) and determines the most efficient shipments to load as a head-load for one or more doors.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd and shiftCd are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If doorNbr is provided, then all head-load shipments for that door will be identified.
     * <br/>2. If proNbr is provided, then all doors that are candidates as head-load for that shipment will be returned.
     * <br/>3. If neither doorNbr nor proNbr are provided, then all doors and shipments at the location will be evaluated.
     * <br/>4. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listHeadLoadShipments(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/head-load-shipments'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists target door plans based on the destinations and door plan profile ID provided. For each destination, a list of target door plans are returned from the door plan profile ID to which the destination can be added. A maximum of 100 destinations can be supplied.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid door plan profile ID and at least one destination SIC are provided.
     * <br/>Post-condition: A status code of 200 is returned along with a priority 1 door plan for each destination SIC.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: An invalid door plan profile ID and at least one destination SIC are provided.
     * <br/>Post-condition: A status code of 400 - Bad Request is returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listTargetDoorPlansForDestinations(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/target-door-plans'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation repairs the door plans in a door plan profile based on the profile ID provided.  The repair involves fixing the door plans when freight flow changes occur to keep the data consistent; typically only an issue with the static door plan.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid doorPlanProfileId is provided and the associated door plan profile exists.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plans for the door plan profile are repaired.
     * <br/>2. If a door plan profile doesn't exist for the profile ID provided, then a 404 - Not Found status code is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    repairDoorPlanProfile(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/repair'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation reverts door plans, that are associated with the doorPlanProfileId and doorNbrs provided, to the default plan for the SIC and shift.
     * <br/>		if revertAllDoorsInd is set to true then doorNbrs are not required and all doors in the active door plan profile will be reverted to default. If revertAllDoorsInd is not supplied or false
     * <br/>		then minimum 1 doorNbr is required.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. The current active door plan for the door plan profile ID and doorNbr(s) provided exist.
     * <br/>2. Optionally, the default door plan for the door exists.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If both pre-conditions are true, then the door plans on the current active profile for the doors provided are updated to the default door plan.
     * <br/>2. If only the first pre-condition is true, then the current active door plans for the profile and doors are deleted.
     * <br/>3. If neither of the pre-conditions are true, then a 404 - Not Found error is returned.
     * <br/>4. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    revertDoorPlans(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/default-reverts'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates an existing door plan based on the profile ID and door number provided. The door plan must be an active one.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid door plan profile ID and doorNbr are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan is updated based on the payload provided.
     * <br/>2. If the door plan isn't found, then a 404 - Not Found error message is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateDoorPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/{doorNbr}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates the door plan destinations' headload indicator to Y or N depending upon the input.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid doorPlanProfileId and doorNbr are provided along with a list of destinations for that door.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan destinations are updated with the headload destination indicator based on the input value.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateDoorPlanHeadloadDestinations(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/{doorNbr}/headload-destinations'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation performs the Copy, Move, Swap, and Merge functions for from and to door plans for the active door plan profile provided.
     * <br/>- Copy: Copies the active door plan from from-door to to-door. Sets the priority of the to-door plan to 2.
     * <br/>- Move: Copies the active door plan from from-door to to-door. Deletes the door plan of the from-door.
     * <br/>- Swap: Replaces the active door plans of from and to doors
     * <br/>- Merge: Merges the active door plan of from-door into the door plan of the to-door.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The door plan for the fromDoorNbr must exist and the doorPlanProfileId must be for the active profile.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the action specified is performed for the active plan profile.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateDoorPlansByAction(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-plan-profiles/{doorPlanProfileId}/door-plans/{fromDoorNbr}/{toDoorNbr}/{doorPlanActionCd}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * For the SIC, shift, and door provided, this operation will return details related to the door information including: trailer at the door, loaded shipment count, remaining to load count, and route or door plan info.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and door number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If there is a trailer at the door, then trailer details are returned.
     * <br/>2. If the door doesn't exist, an error will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDoorDetails(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/doors/{doorNbr}/shifts/{shiftCd}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * For the SIC, shift, and door provided, this operation will return door setup details for the dock door.
     * <br/>
     * <br/>Mandatory Input: SIC, door number, and shift code.
     * <br/>
     * <br/>Optional Input: dock location type (door or bay) and detail indicator (true or false). If not supplied, then false is assumed and only minimum information is returned.
     * <br/>If detail indicator is false, then only the dock door setup (minimum) information is returned.
     * <br/>If detail indicator is true, then dock door detailed information (remaining shipments count, remaining shipments cube, remaining shipments weight, loaded shipment count, etc.) is returned.
     * <br/>The dock location type is not required when detail indicator is false. In this case the dock location is assumed to be the door. If the detail indicator is true, then the dock location type can be specified. Valid values are door or bay (dock location).
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and door number must be provided. The optional parameterdetailInd is either set to false or not supplied.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, door setup detail, trailerNbr, trailerStatus, loadDestinationSic, currentPlan, and profile ID will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDoorSetupDetails(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/dock-doors/{doorNbr}/shifts/{shiftCd}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists the door preferences for a given SIC, shift, and profile type. The dock door preferences include information such as stepSaverExcludeInd, loadUnloadInd, trapInd, etc. The list can be filtered by providing a door preference type.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and profile type must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If at least one door preference exists for the input criteria, then a status code of 200 will be returned along with the information.
     * <br/>2. If no results were found, then a status code of 404 will be returned.
     * <br/>3. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDockDoorPreferences(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/profiles/{profileTypeCd}/door-preferences'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists all the doors with a door plan for the SIC and shift provided. If there is a trailer at the door, then the trailer load information is returned.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the door plan information is returned. If the door also has a trailer assigned, then the trailer load details are returned.
     * <br/>2. If the door doesn't exist, a 404 - Not Found error will be returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDoorsForDockWalk(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/dock-walk-doors'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists all the doors for a lane based on the SIC and shift provided. The lane could be the destination SIC, postal code, or next load point SIC.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. One of the following must be provided: nextSicCd, postalCd, destSicCd, or routeId.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid SIC, shift, and nextSicCd are provided. At least one door plan exists for the nextSicCd.
     * <br/>Post-condition: Door information for the lane (nextSicCd) is listed.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid SIC, shift, and routeId are provided. At least one door plan exists for the route.
     * <br/>Post-condition: Door information for the route is listed.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid SIC, shift, and destSicCd are provided. At least one door plan exists for the destSicCd.
     * <br/>Post-condition: Door information for the destSicCd is listed.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: A valid SIC, shift, and postalCd are provided. At least one door plan exists for the SIC associated with postal code provided.
     * <br/>Post-condition: Door information for the postal code is listed.
     * <br/>
     * <br/>Use Case 5
     * <br/>Pre-condition: A valid SIC and shift are supplied. No door plan exists for the nextSicCd or destSicCd provided.
     * <br/>Post-condition: A 404 - Not Found error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDoorsForLane(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/lane-doors'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation maintains dock door preferences.
     * <br/>Mandatory input: Either doorPreferenceId OR a valid sicCd, shiftCd, profileTypeCd, and doorNbr are provided.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid doorPreferenceId is provided along with the data that will be updated (stepSaverExcludeInd and/or trapDoorInd and/or loadUnloadInd).
     * <br/>Post-condition: If sucessful, then the door preference associated with the identifier provided is updated.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid sicCd, shiftCd, profileTypeCd, and doorNbr is provided along with the data that will be updated (stepSaverExcludeInd and/or trapDoorInd and/or loadUnloadInd).
     * <br/>Post-conditions:
     * <br/>1. If the door preference exists for the mandatory input, then it will be updated with the data provided.
     * <br/>2. If the door preference doesn't exist, then a new record will be created.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    maintainDockDoorPreferences(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/door-preferences'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Creates a new dock location record for a given service center. The service center must be an active linehaul service center.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Dock location detail and a valid service center are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If succesful, then the dock location record is created.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createDockLocation(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-locations'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation deletes a dock location for a valid dock location instance ID that is provided. If there are any shipments associated with the dock location, then the dock location can't be deleted.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid dock location instance ID is provided and no shipments are associated with the dock location.
     * <br/>Post-condition: The dock location for the input provided is deleted.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: An invalid dock location instance ID is supplied.
     * <br/>Post-condition: A status code of 404 Not found is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteDockLocation(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-locations/{dockInstId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation retrieves a dock location for a valid dock location instance ID that is provided.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid dock location instance ID is provided.
     * <br/>Post-condition: Dock location details are returned.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: An invalid dock location instance ID is supplied
     * <br/>Post-condition: A status code of 404 Not found is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDockLocation(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-locations/{dockInstId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will return a list of all the dock locations for the SIC provided. The SIC must be active and a linehaul SIC.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid SIC and no optional parameters are provided.
     * <br/>Post-condition: A list of all the dock locations at the SIC is retrieved. A status code of 200 is returned.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid SIC and dock name are provided.
     * <br/>Post-condition: A dock location with matching dock name is returned, if one exists. Otherwise a 404 - Not found is returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listDockLocations(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-locations'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists all the shipments that are loaded onto a dock location. The input can be either a docklocationInstId in a SIC or dock location name.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>2. Either a valid dockName or dockInstId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If there are shipments loaded onto the dock location, then the list of shipments will be returned. Status Code 200.
     * <br/>2. If either the dockName or dockInstId is not valid, then a status code of 400 will be returned.
     * <br/>3. If no shipments are found in the dock location, then a status code of 404 will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listShipmentsInDockLocation(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/dock-location-shipments'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates an existing dock location by updating the remarks for the dock instance ID provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid dockInstId is supplied along with the remarks to be updated.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then remarks for the dock location are updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * <br/>2.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateDockLocationRemarks(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-locations/{dockInstId}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation assigns or reassigns shipments to a new route or existing route. The assignment or reassignment The route to which the shipments are assigned or reassigned can be a delivery or planning route. This service can also update the route information (release indicator, door number, DRDT, dock location, closest door number) if routeDetailsUpdatedInd is true. The planning route can not have the release indicator set to true. The route category can be OPER (Delivery) for delivery route or SPCL for planning route. If the shipments are currently assigned to a route, then fromRouteInstanceId must be populated. If the shipments will be assigned to an existing route, then the assignToRoute.routeInstId must be populated.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: When assigning shipments to a new route, fromRouteInstId is not supplied and assignToRoute.routeInstId is 0 but other route details like routePrefix, routeSuffix, routeDate, categoryCd  are provided. At least 1 assignedShipments is provided along with either the shipmentInstId or proNumber.
     * <br/>Post-conditions: A new route is created and all the shipments are assigned to the new route. A status code of 200 is returned along with route details.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: When assigning shipments to an existing route, route details don't need to be updated. fromRouteInstId is not provided, assignToRoute.routeInstId is not 0, and routeDetailsUpdatedInd is set to false.
     * <br/>Post-conditions: The shipments are assigned to the route provided. A status code of 200 is returned along with route details.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: When assigning shipments to an existing route, route details (route prefix, route suffix, deliveryRouteDepartTime, categoryCd etc) need to be updated. fromRouteInstId is not provided, assignToRoute.routeInstId is not 0, and routeDetailsUpdatedInd is set to true.
     * <br/>Post-conditions: Route details are updated based on the input data and shipments are assigned to the route provided. A status code of 200 is returned along with route details.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-conditions: When reassigning shipments from an existing route to either a new route or an existing route, fromRouteInstId is provided and greater than 0. assignToRoute.routeInstId is provided (for the existing route) or other route details are provided (if it's needed to create a new route).
     * <br/>Post-conditions: Shipments are reassigned from the existing fromRouteInstId to the new route based on data in assignToRoute. A status code of 200 is returned along with route details.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    assignShipmentsToRoute(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/routes/shipment-assignments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation bulk updates from dock operations a list of Handling Units if they exist or bulk creates them if they do not.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The information for each Handling Unit provided must be valid.
     * <br/>2. The parent PRO of the handling units should be billed.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the handling units are upserted in bulk.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    bulkUpsertHandlingUnitsFromDock(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/docks/handling-units/bulk-upsertion'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation accepts the unique five character LTL employee ID, SIC, and shift. It returns their current Dock Engineered Standard (DES) % from SMART.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid employee ID, SIC, and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the employee has a current DES% in SMART, then it is returned.
     * <br/>2. Otherwise, an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCurrentDockEngineeredStandard(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/employees/{employeeId}/des'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation accepts the unique five character LTL employee ID, SIC, and shift. It returns their current motor moves per hour (MMPH) from SMART if the shift code is a dock shift or the hostling moves per hour if the shift code is H - Hostling.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid employee ID and SIC must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the employee has current motor moves per hour in SMART or hostling moves if shiftCd is Hostling, then they are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCurrentMotorMovesPerHour(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/employees/{employeeId}/motor-moves-per-hour'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns shipment information at the dock.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and PRO number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then details about the shipment at the dock will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDockShipmentDetails(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shipments/{proNbr}/details'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation gets the Dock Shipment Load information for each requested PRO number.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. At least one valid PRO number is provided along with the SIC and shift.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the DockShipmentLoad information will be returned along with a status code of 200.
     * <br/>2. If there are any data validation errors, then those will be returned.
     * <br/>3. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDockShipmentLoads(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/shipments/dock-shipment-loads'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the basic employee information for a Dock  worker based on their scanned Kronos Badge Number.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid Kronos badge number is supplied.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the employee details based on the input Kronos Badge number is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getEmployeeDetailsByBadgeNbr(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/employees/{badgeNumber}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the loading details for a Handling Unit PRO number.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: The PRO number is a parent PRO.
     * <br/>Post-condition: A response status of 400 will be returned
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: The PRO number is a Handling Unit PRO and loading details exist.
     * <br/>Post-condition: The loading details for the Handling Unit PRO will be returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: The necessary input isn't provided or is invalid.
     * <br/>Post-condition: An appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getHandlingUnitProLoad(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/handling-units/{proNbr}/load'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation gets the next best loading action for a shipment given its SIC and shift.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid shipment instance ID, SIC, and shift.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a ranked list of trailers onto which the shipment should be loaded will be returned.
     * <br/>2. If an available trailer doesn't exist, then an exception will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getNextBestLoadingActionForShipment(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/directed-loadings/shipments/{shipmentInstId}/next-best-action'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation gets the next best loading action for a trailer given its SIC and shift.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid trailer ID, SIC, and shift.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a ranked list of shipments to be loaded next onto the provided trailer will be returned.
     * <br/>2. If an available shipment doesn't exist, then an exception will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getNextBestLoadingActionForTrailer(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/directed-loadings/trailers/{trailerId}/next-best-action'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a rendered PDF report for the requested SIC and report type.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd and reportTypeCd are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then one or more PDF files for the report will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getPdfReport(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/pdf-reports/{reportTypeCd}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation returns the billing details for a PRO.  The respective Handling Units along with their location will be returned within FBDSDocument.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid proNbr must be provided. The PRO must be billed and have handling units.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the billing details of the PRO along with its Handling Units and their current location are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getProFbdsDocWithCurrentLocation(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shipments/{proNbr}/fbds-documents'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * When a handling unit tracking PRO is scanned, this operation will return the details about the Parent PRO along with the loading information of the PRO. The PRO can be loaded to a Dock location or a Door(trailer). This operation will also record the PRO scan in the OPS Pro Movement History table.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and PRO number must be provided.
     * <br/>2. getReweighInd is optional, but if supplied, the service will check if the PRO should be reweighed.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, the PRO details and load to information for the PRO will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getProLoadDetails(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/loading-details/{proNbr}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the xdock location details for a list of PRO numbers at a specific SIC.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd, shiftCd, and at least one proNbr must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the associated xdock location details for the shipments are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getProXdockLocations(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/xdock-locations'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns information about the route and associated trailer along with the list of shipments.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid route instance ID is provided.
     * <br/>2. The route has a trailer assigned to it and there are shipments assigned to the route.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, the route details including the trailer information and list of shipments are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getRouteManifest(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{requestingSicCd}/shifts/{shiftCd}/route-manifests/{routeInstId}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get Smart Token to make Query Call
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getSmartApiToken(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/smart-api/token'), {}, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation accepts a SIC and door number. If there is a trailer at the door, then it returns details for the trailer.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and door number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If there is a trailer at the door, then trailer details are returned.
     * <br/>2. If there is no trailer at the door, then an empty response is returned.
     * <br/>3. If the door doesn't exist, an error will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getTrailerDetailsByDoor(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/doors/{doorNbr}/trailer-details'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the trailer load details for the equipment ID provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1.  A valid equipmentId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then trailer load details for the equipmentId will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getTrailerLoadByEquipmentId(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment/{equipmentId}/trailer-load'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists drivers' availability status from SMART if drivers have a job type of either 'Night Linehaul' or 'PM Flex'.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid siteCode and planDate must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the driver has a Job Type of either 'Night Linehaul' or 'PM Flex' in SMART, then the drivers' availability status is listed.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listAvailabilityForDrivers(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/drivers-availability/sites/{siteCd}/drivers'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists all the routes that are required for Cross Dock Operation. The following routes will be returned for the SIC provided:
     * <br/>	1. New Delivery Routes (Route Status = New and Category Code = OPER)
     * <br/>	2. Planning Routes (Category Code = SPCL)
     * <br/>	3. Dispatched Dock Pickup Route (Category Code = DOCK and Status = DISP)
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd is provided which has associated routes.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 200 and the associated routes are returned.
     * <br/>2. If the sicCd provided was invalid, then a status code of 404 - Not Found is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listCrossDockRoutes(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/cross-dock-routes'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists active shipment events for the PRO, SIC, shift (use blank if not supplied), and the event date (use the current date if not supplied) provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid proNbr and sicCd must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of active shipments, operations, and admin events are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listShipmentDockHistory(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shipments/{proNbr}/dock-history'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation loads a scanned handling unit (tracking PRO) to either a trailer at the door or a dock location based on the input data.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd, shiftCd, and either a door number or a dock location must be supplied.
     * <br/>2. The trailer at the door must be in the appropriate status for loading a PRO.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the scanned PRO is loaded onto the trailer at the door or dock location.
     * <br/>2. Otherwise an appropriate error messagge is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loadPro(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/loaded-shipments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation upserts headload information for the shipments for a given trailer. It returns a list of headload shipments on the trailer or information for shipments that are no longer headload.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>2. Either a valid equipmentId or trailerNbr must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If there are headload shipments loaded onto the trailer, then the list of shipments will be returned including the proNbr and a headload indicator that is set to true if the shipment has been marked as headload.
     * <br/>2. If neither the equipmentId nor trailerNbr is provided or valid if provided, then a status code of 400 will be returned.
     * <br/>3. If no shipments are found in the trailer, then a status code of 404 will be returned.
     * <br/>4. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    maintainHeadloads(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/headloads'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation submits a request in Mainframe to print the Dock Copy.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid parentProNbr or trackingProNbr along with the reportTypeCd, printer number, SIC, and shift are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the report request is submitted so it can be printed on the specified printer.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    printDockCopy(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/dock-copies'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation will submit a request in Mainframe to print manifest reports.  The following manifest types can be printed:
     * <br/>	1. Linehaul Strip Manifest
     * <br/>	2. Linehaul Load Manifest
     * <br/>	3. Inbound Strip Manifest
     * <br/>	4. Inbound Load and Route Manifest
     * <br/>	5. Linehaul Closed Load Manifest
     * <br/>	6. Dock Manifest
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid manifest report type is provided along with the printer number, SIC, and shift.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the report request is submitted so it can be printed on the specified printer.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    printManifestReports(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/manifest-reports'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation records the logon and logout attempts of a user to a device and an application.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC is entered and the employee ID and device ID are supplied. The input device ID doesn't match the existing device the user is logged on. Input logonInd is set to true.
     * <br/>Post-conditions: The user will be logged off from the existing device and then a record is created in the Employee Device table to note the user logon to the new device.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: The user requested to logoff from the existing device and application. logoutInd is set to true.
     * <br/>Post-condition: The user will be logged out of the current device and application.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    recordDeviceLogonAndLogout(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/device-logons'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation will record a dock exception for a shipment. The exceptions include: AllShort or Overage piece count or damaged pieces count is updated.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid SIC and shift are entered and the shipment is marked as AllShort.
     * <br/>Post-conditions: If the shipment is still at the trailer, then it will be deleted from the Ops Loaded Shipment table and if the shipment is at a dock location then it will be deleted from the dock location.
     * <br/>A Shipment exception record is created in the Shipment component.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: Only FoodPoisonCode is updated.
     * <br/>Post-condition: The Shipment API will be called to update the food poison code.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: The input Over piece count or short piece count or damaged piece count is supplied.
     * <br/>Post-condition: The Shipment exception is created.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    recordShipmentDockException(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/shipment-exceptions'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation records a split movement for the Handling Units of the parent PRO numbers provided if the Handling Units were not loaded in the same trailer as the parent PRO. The user who authorized the split along with the date and time when it was authorized will be recorded in the same split movement.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. At least one valid parent PRO number must be provided.
     * <br/>2. The user along with the date and time when it was authorized must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the split movement for the Handling Units of the PRO numbers will be created.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    splitNonLoadedHandlingUnits(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/docks/shipments/handling-units/split-movements'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates the handling unit exemption indicator and reason for the shipment in the operations interface table, which determines whether the shipment is exempt for handling units and the reason why.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid proNbr must be provided.
     * <br/>2. The associated shipment can not have any handling units.
     * <br/>3. The request must have a valid reason for marking the shipment as handling unit exempt.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the shipment is marked handling unit exempt and a valid reason code is set.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateHandlingUnitExemption(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-shipments/{proNbr}/handling-unit-exemption'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation updates the dimensions of a shipment on a dock.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid proNbr, capturedByUserId, requestingSicCd, dimensionTypeCd, and list of dimensions is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the shipment dimensions are updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateShipmentDimensionsFromDock(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/docks/shipments/{proNbr}/dimensions'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation creates or updates the shipment skeleton for one that is on a dock.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid shipment skeleton is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the shipment skeleton is created or updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertShipmentSkeletonFromDock(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/docks/shipment-skeletons'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation deletes a handling unit from the current dock location it is currently staged on or current equipment it is currently loaded on.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid child PRO number is provided.
     * <br/>2. A valid dock instance ID or equipment ID is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the loaded handling unit is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteLoadedHandlingUnitAsAdmin(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-handling-units/{childProNbr}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation deletes a shipment from the current dock location it is currently staged on or current equipment it is currently loaded on.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid PRO number is provided.
     * <br/>2. A valid dock instance ID or equipment ID is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the loaded shipment is deleted.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteLoadedShipmentAsAdmin(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-shipments/{proNbr}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation returns the loaded shipment as well as the loaded handling units on a dock location or on a piece of equipment.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid parent PRO is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the shipment along with the handling units on a trailer or dock are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getShipmentOnTrailerOrDock(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-shipments/{proNbr}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists handling units that are either on a dock or a piece of equipment.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. At least one child PRO is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of handling units is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listHandlingUnitsOnTrailerOrDock(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-handling-units'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation performs an upsert of a loaded handling unit. If the request is to load it on a dock location or a piece of equipment, then there should not be any existing rows at any other dock location or equipment. A delete must be requested for that location prior to the creation. Updating will allow particular fields to be updated when loaded to a piece of equipment.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid child PRO that exists is provided.
     * <br/>2. A valid parent PRO that exists must be provided.
     * <br/>3. A valid dock instance ID or equipment ID must be provided.
     * <br/>4. A valid request for the create or update must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the handling unit is loaded on a dock location or a piece of equipment is created or updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertLoadedHandlingUnitAsAdmin(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-handling-units'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation performs an upsert of a loaded shipment. If the request is to load it on a dock location or a piece of equipment, then there should not be any existing rows at any other dock location or equipment.  A delete must be requested for that location prior to the creation. Updating will allow particular fields to be updated when loaded to a piece of equipment.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid parent PRO that exists must be provided.
     * <br/>2. A valid dock instance ID or equipment ID must be provided.
     * <br/>3. A valid request for the create or update must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the shipment is loaded on a dock location or a piece of equipment is created or updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    upsertLoadedShipmentAsAdmin(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/loaded-shipments'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation adds a list of trailers to the requested cross dock plan.  The cross dock plan is defined by the SIC code, shift code, and plan date supplied.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and plan date must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of trailers are included in the cross dock plan.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    addTrailersToCrossDockPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/plan-dates/{planDate}/cross-dock-plan-trailers'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation assigns a trailer to a door at the service center dock.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid trailer equipment (equipmentId or equipment prefix and suffix) is provided along with a valid door number.
     * <br/>2. The equipment current SIC is the same as the SIC provided as input.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer is assigned to the door number provided at the SIC.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    assignTrailerToDoor(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/trailer-door-assignments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation assigns a trailer to a door at the service center dock. And this API is specially for Dock Manager application
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid trailer equipment (equipmentId or equipment prefix and suffix) is provided along with a valid door number.
     * <br/>2. The equipment current SIC is the same as the SIC provided as input.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer is assigned to the door number provided at the SIC.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    assignTrailerToDoorForDockManager(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/dock-manager/service-centers/{sicCd}/trailer-door-assignments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation performs a bulk update of the trailer load status, door and/or remarks. When updating the trailer load status, if the new trailer load status change is not allowed, an error message will be returned. Trailer remarks can be updated to blanks.
     * <br/>
     * <br/>Mandatory Input: SIC and trailer equipment ID.
     * <br/>The equipment ID must be for a straight truck or trailer.
     * <br/>
     * <br/>Optional Input: shiftCd, newTrailerStatus,doorNbr, trailerRemarks, eventTimestamp, and overheadStatusOverrideInd.
     * <br/>If eventTimestamp is not supplied, then the current date and time will be used.
     * <br/>When the current trailer status is Overhead and the new trailer status is an invalid status change from the previous status, then the status update is only allowed when overheadStatusOverrideInd is set to true.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid trailer equipmentId along with newTrailerStatus, doorNbr, and trailerRemarks is provided. An update to newTrailerStatus is allowed.
     * <br/>Post-condition: The trailer load is updated with the input provided.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid trailer equipmentId along with doorNbr and trailerRemarks is provided.
     * <br/>Post-condition: The trailer load is updated with doorNbr and trailerRemarks.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid trailer equipment ID along with either one of the following is provided: newTrailerStatus, doorNbr, or trailerRemarks.
     * <br/>Post-condition: A trailer load is updated with the input provided.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: A valid trailer equipmentId is supplied along with newTrailerStatus. However status change is not allowed.
     * <br/>Post-condition: A 400 - bad request error message is returned. Message: Trailer load status update not allowed.
     * <br/>
     * <br/>Use Case 5
     * <br/>Pre-condition: A valid trailer equipmentId is supplied along with newTrailerStatus, but trailer is associated with an Ops Schedule.
     * <br/>Post-condition: A 400 - bad request error message is returned. Message: Trailer is associated with a Schedule.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    bulkUpdateTrailerLoadStatusDoorRemarks(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/trailer-loads/status-door-remarks'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates the city trailer load status to City Close for Delivery.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid sicCd, shiftCd, and trailerNbr must be provided.
     * <br/>2. The trailer load for the trailer number provided must be in the appropriate status before it can be closed.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer load status is set to CityClosedForDelivery.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    closeCityTrailer(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer-loads/{trailerNbr}/city-trailer-closure'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates the trailer load status to Close.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. The trailer load for the input trailer number must be in appropriate status before it can be closed.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer load status is set to Closed.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    closeLinehaulTrailer(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer-loads/{trailerNbr}/linehaul-trailer-close'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation analyzes the photo of the trailer taken at the time of close and sends it through the Google Machine Language learning model.  The results of the Model are recorded in the table EQP_EVENT_PHOTO_ANALYSIS.
     * <br/>One of the following options must be provided:
     * <br/>	- closeEventId
     * <br/>	- combination of equipmentId, closeSicCd,and closeShiftCd
     * <br/>	- dmsDocId
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid closeEventId for the trailer close full photo is provided. The trailer has guaranteed or premium shipments loaded.
     * <br/>Post-conditions: The Event information from EQP_EVENT is retrieved for the closeEventId and validation is performed to ensure that the Event is for CLOS type and PICF subtype. Trailer details are retrieved based on the equipmentId and if the trailer has guaranteed and premuim shipments loaded.  Then the DMS doc ID is retrieved and the image is pulled from DMS and passed through to the Google Machine Language Learning model.  The model results are stored in the table and returned in the response.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid closeEventId for the trailer close full photo is provided. The trailer does not have any guaranteed or premium shipments loaded.
     * <br/>Post-conditions: The following message is returned, 'Trailer does not qualify for photo analysis. No Guaranteed or Premium shipments loaded.'
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-conditions: A valid dmsDocId for the close trailer photo is provided. The trailer closed has guaranteed or premium shipments loaded.
     * <br/>Post-conditions: The Event information from EQP_EVENT is retrieved for the dmsDocId and validation is performed to ensue that the Event is for the CLOS type and PICF subtype. Trailer details are retrieved based on the equipmentId and if the trailer has guaranteed and premuim shipments loaded.  Then the DMS doc ID is retrieved and the image is pulled from DMS and passed through to the Google Machine Language Learning model.  The model results are stored in the table and returned in the response.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-conditions: A valid equipmentId along with closeSicCd and closeShiftCd is provided.  The trailer has guaranteed or premium shipments loaded.
     * <br/>Post-conditions: For the equipmentId, closeSicCd and closeShiftCd combination provided, the Event information from EQP_EVENT is retrieved and validation is performed to ensure that the Event is for the CLOS type and PICF subtype. Trailer details are retrieved based on the equipmentId and if the trailer has guaranteed and premuim shipments loaded.  Then the DMS doc ID is retrieved and the image is pulled from DMS and passed through to the Google Machine Language Learning model.  The model results are stored in the table and returned in the response.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    closeLinehaulTrailerPhotoAnalysis(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailer-photo-analysis'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation updates a trailer status and/or door number based on the given parameters. This is part of the Complete Load and Unload functionality from Handheld.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd, shiftCd, and equipmentNbr must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the requested trailer is in status 'UNLD', 'LDDK', or 'CLDK' an error will be returned.
     * <br/>2. If the sicCd is not valid, then an error will be returned.
     * <br/>3. If is valid sicCd, shiftCd and trailer is in the correct status it will return success true.
     * <br/>4. If trailer status doesn't correspond to a valid transition status it will return an error.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    completeTrailerLoadUnload(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer-loads'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation will return the trailer close options that include the load destination of the trailer and trailer routing based on the list of shipments that are loaded on the trailer at the current SIC and shift.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and list of shipments (shipment destination SIC code) that are loaded on the trailer must be provided. If the shipment is diverted, then the divertSicCd of the shipment is supplied. If the shipment was misloaded, then the misload indicator is set to true.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. if successful, then one or more trailer close options will be returned. The options will be sorted based on the best option.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deriveTrailerCloseOptions(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{requestingSicCd}/shifts/{shiftCd}/trailer-close-options'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation will update the diversion information for shipments in a dock plan.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift, list of shipments (at least one) associated with the dock plan, and their diversion information is required.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, the the list of shipments that are in the dock plan are updated with the diversion information.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    divertShipmentsInDockPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/planned-shipments/diversion'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation returns information about the trailer and the associated route (for city trailers) along with the list of shipments that are loaded onto that trailer.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid trailerNbr is provided that has shipments loaded onto it. For City trailers a route may be associated with this trailer.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successul, then the trailer information and list of shipments along with the associated route are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getTrailerManifest(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{requestingSicCd}/trailer-manifests'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * For the SIC and shift provided, this operation will return a list of trailers to break along with their door information.  It will also get the head load information and if the trailer is not assigned to a door, then it will get the door and sector from Step Saver. If the trailer status is UNLD, then it will return the DSR Name and time of the last unloaded shipment from the trailer.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of trailers to break along with other information is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listBreakTrailers(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/break-trailers'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a list of trailers that are used for cross dock trailer planning purposes. The trailers included in this list are considered to be trailers that are in Arrived status, trailers that are Enroute to the requested service center, or trailers that are considered to be Overhead. Trailers that are excluded from the cross dock plan are also included in the result set.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and plan date must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of trailers that matched the filter criteria are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listCrossDockTrailers(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/plan-dates/{planDate}/cross-dock-trailers'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will return a list of shipments that remains to be loaded.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>1. A valid laneSicCd, doorNbr, or routeInstId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of shipments that are remaining to be loaded for the input lane SIC, door, or route will be returned depending upon which optional input was provided.
     * <br/>2. If the lane SIC, route, or door number are invalid, then a 400 status will be returned.
     * <br/>3. If no shipments are found in the plan, then a status code of 404 will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listRemainingToLoadShipments(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/remaining-to-load-shipments'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will return a list of reship freight trailers, for the SIC and shift provided, that are included or excluded from the X-Dock plan. A list of trailers will be displayed with information like trailer number, load destination, action to be taken on the trailer, current status, and location.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of reship freight trailers is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listReshipFreightTrailers(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/reship-trailers'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will return a list of all the XDock shipments that are included in a dock plan. The list can be filtered by shipment type: Reship, Pickup, Strand or Dock.
     * <br/>Other optional filter criteria include: one or more (up to three) xdock progress codes (Not Stripped, Stripped, TConned), destination sic code of shipments, sector number of door or FAC, and door number.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC and shift must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of Xdock shipments is returned along with a status code of 200.
     * <br/>2. If the XDock plan is not valid, then a status code of 400 will be returned.
     * <br/>3. If no shipments are found in the plan, then a status code of 404 will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listShipmentsInDockPlan(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/planned-shipments'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a list of loaded shipments, handling units, and pickup requests.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid trailer number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of shipments, handling units, and pickup requests are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listShipmentsByTrailerNbr(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailers/{trailerNbr}/shipments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation returns a list of suggested doors based on the SIC, shift, and route provided.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A sicCd, which is a valid linehaul and active SIC, must be provided.
     * <br/>2. The shiftCd provided must be for a valid shift.
     * <br/>3. Either a valid routeInstId or routePrefix, trailerTypeCd, and lifgateInd must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of suggested doors is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listSuggestedDoors(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/suggested-doors'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation overrides the accuracy check for either a trailer or shipment based on the input data.
     * <br/>
     * <br/>Mandatory Input: The SIC and shift are required.
     * <br/>Optional Input: Either the trailer or shipment number is supplied to override the accuracy check for the trailer or shipment.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid Dimensions Check Trailer record exists for the trailer number and the request is to override the accuracy check.
     * <br/>Post-conditions: The Dimensions Check Trailer record is updated and the override indicator is set to Y along with the employee ID of the supervisor who authorized it.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: A valid shipment number is supplied and the shipment is loaded onto the input trailer.
     * <br/>Post-conditions: The accuracy check for the shipment is overriden.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: An invalid trailer equipment ID is provided.
     * <br/>Post-condition: A 404 - Not Found status code is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    overrideTrailerShipmentAccuracyCheck(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/accuracy-check-overrides'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation will remove one or more trailers that are included in a Dock Plan (SIC, shift, and plan date).
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC and shift must be provided along with at least one trailer ID.
     * <br/>2. The plan date is optional.  If it isn't provided, then the current date will be used.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If all trailers are successfully removed from the dock plan, then a success status code will be returned.
     * <br/>2. If any of the input trailers are not part of the dock plan, then a 400 status code will be returned.
     * <br/>3. If there is an error in removing one or more trailers from the plan, then the response will indicate the trailer equipment ID along with the error message.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    removeTrailersFromDockPlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/planning-trailers-removal'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation removes a list of trailers from the predefined route plan. All of the shipments which are already planned for a delivery route will be unassigned from it.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, shift, and plan date must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of trailers are removed from the route plan for the SIC, shift, and date.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    removeTrailersFromRoutePlan(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/plan-dates/{planDate}/trailer-route-plan-removal'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation performs a transfer of all trailer contents - Loaded Shipments, Headload, Placards, other equipment - from a given trailer number to either a dock location or another trailer at a given door number.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition:
     * <br/>1. A valid sicCd, shiftCd, fromTrailerNbr and either a door number (doorNbr) or a dock location (dockName) must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the scanned PRO is loaded onto the trailer at the door or dock location.
     * <br/>2. Otherwise an appropriate error message is returned.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition:
     * <br/>1. The transfer-from-trailer status is not one of UnloadingAtDock or LoadingAtDock or CityLoadingAtDock or Appointment or Trap.
     * <br/>
     * <br/>Post-condition:
     * <br/>1. The transfer failed and an error message will be returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    transferTrailerContents(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer-contents'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation either assigns or unassigns a DSR from breaking a trailer.
     * <br/>
     * <br/>Mandatory Input: Equipment ID of the trailer and DSR Employee ID.
     * <br/>Optional Input: Trailer equipment prefix and suffix. Either the assignment startDateTime OR assignment endDateTime is provided.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid trailer equipment ID along with DSR employee ID and startDateTime are provided.
     * <br/>Post-condition: The DSR is assigned to break the trailer with the equipment ID.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid trailer equipment ID along with DSR employee ID and endDateTime are provided.
     * <br/>Post-condition: The DSR is unassigned from breaking the trailer with the equipment ID.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: An invalid trailer equipment ID is provided.
     * <br/>Post-condition: A 404 - not found status code is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateTrailerDsrAssignment(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/trailer-loads/{equipmentId}/dsr-assignments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates a list of loaded shipments with the headload indicator appropriately. It returns a list of headload shipments on the trailer or information for shipments that are no longer headload.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC, shift, and trailer number must be provided.
     * <br/>2. The list of shipments must be loaded on trailer.
     * <br/>3. The full list of loaded shipments must be passed in.
     * <br/>4. Each shipment must have a valid PRO number and have the headload indicator set as true or false.
     * <br/>5. Each shipment must be unique.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If there are headload shipments loaded onto the trailer, then the list of shipments will be returned including the proNbr and a headload indicator that is set to true if the shipment has been marked as headload.  HeadLoadDetail will be returned as part of the response as well.
     * <br/>2. If shipments on board the trailer are not actually loaded in the requested trailer, then the following error message will be displayed: Shipments requested are not on board the trailer.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateTrailerHeadloadShipments(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer/{trailerNbr}/headload-shipments'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates the load deck count for a given trailer. The load deck count of the trailer will be incremented by the input value provided.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid SIC, shift, and door number must be provided.
     * <br/>2. The trailer load record for the trailer at the door number provided must exist.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the load deck count in the Ops trailer load is incremented by the input value.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateTrailerLoadDeckCount(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/shifts/{shiftCd}/trailer-loads/{doorNbr}/load-decks'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation will create a new Foreign Equipment for each item on the list of foreign equipment supplied. A Foreign Equipment is an Equipment (usually Trailer or Dolly or Power or Straight Truck) that is not owned by XPO LTL.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Mandatory data required for adding a foreign equipment includes: responsibleSicCd, foreignScacCd, equipmentNbr, equipmentTypeCd, and equipmentTypeDetailCd.
     * <br/>2. The responsibleSicCd must be a valid linehaul SIC and must be active as of the create date.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. Once the foreign equipment is successfully created, an equipment ID will be returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    addForeignEquipment(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/foreign-equipment'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation will perform a bulk update for the Equipment Status and/or Remark. The Equipment Status and Remark can be updated at any service center. These updates are only allowed when the SIC provided matches the Equipment's current SIC. The only status updates allowed are: CITY and Available.
     * <br/>With this request for each Equipment, either Status or Remark or both can be updated. If only the status is being updated, then ensure that remark is not supplied and vice versa.
     * <br/>
     * <br/>
     * <br/>The following conditions represent one use case. The users can choose to update either one or both.
     * <br/>
     * <br/>Pre-condition 1: At least 1 EquipmentStatusRemark record is supplied with a valid and active Linehaul SIC and either Status or Remark or both are supplied.
     * <br/>Post-condition : Equipment Status Remark is updated as per input values.
     * <br/>
     * <br/>Pre-condition 2: Input Current Status = Available and Equipment can not be updated to new Status.
     * <br/>Post-condition 2: Error message is returned for this equipment.
     * <br/>
     * <br/>Pre-condition 3: Input Current Status = Available and Equipment can be updated to input status.
     * <br/>Post-condition 3: Equipment status is updated along with Status update timestamp.
     * <br/>
     * <br/>Pre-condition 4: Input Current Status = OutOfService.
     * <br/>Post-condition 4: Equipment status can not be updated to OutOfService. Error message associated with this Equipment is returned.
     * <br/>
     * <br/>Pre-condition 5: Input Current Status = CITY.
     * <br/>Post-condition 5:. Equipment status is updated along with Status update timestamp.
     * <br/>
     * <br/>Pre-condition 6: Input remarks to be updated are supplied. Remarks can be updated to "blanks".
     * <br/>Post-conditions 6: Equipment Remarks are updated.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    bulkUpdateEquipmentStatusRemark(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment-status-remarks'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation creates an Equipment Event after the trailer pictures were taken by a dock worker when closing or opening a trailer.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: Mandatory data (equipmentId or equipmentNbr (prefix-suffix), eventOccuredDateTime, eventSubTypeCd, and eventTypeCd) is provided to create the event. The equipment must not have the same event type and subtype already created.
     * <br/>Post-conditions: An Equipment Event is created.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-conditions: The Equipment Event for the equipmentId, SIC, shift, eventTypeCd, and eventSubTypeCd already exists.
     * <br/>Post-conditions: A new equipment event is not created.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createEquipmentEvent(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/equipment-events'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates an association between the equipment information and the employee that scans and works on the equipment.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, employee ID, and equipment number are required.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 201 is returned along with the equipment operator ID.
     * <br/>2. If the equipment type was provided, but it isn't associated with the equipment number provided, then a 404 not found is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createEquipmentScan(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment-scans'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates an association between the forklift information and the employee that scans the forklift.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid SIC, employee ID, and forklift ID are required.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a status code of 201 is returned along with the forklift ID.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createForkliftScan(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/forklift-scans'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation returns the most recent forklift information associated with the requested employee.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid employee ID is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the employee has the most recent forklift scan information, then it is returned.
     * <br/>2. If the employee doesn't have any forklift scans recorded, then a 404 - record not found is returned.
     * <br/>3. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getForkliftScanByEmployee(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/forklift-scans/{employeeId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the loaded shipments for an equipment ID.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1.  A valid equipmentId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then loaded shipments for the equipment will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getLoadedShipmentsByEquipmentId(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment/{equipmentId}/loaded-shipments'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the loaded shipment snapshots for the equipment ID provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1.  A valid equipmentId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the details for the loaded shipment snapshots for the equipmentId will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getLoadedShipmentSnapshotsByEquipmentId(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment/{equipmentId}/loaded-shipment-snapshots'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * For the input sic code this operation will return a list of all the Equipment at the service center provided. The list can be filtered by following: equipment type, equipment eurrent status, from door number, to door number or a list of equipment numbers can be supplied.
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-condition: A valid SIC and no optional parameters are supplied.
     * <br/>Post-condition: A list of all the Equipment at the input SIC is retrieved.
     * <br/>
     * <br/>Use Case 2
     * <br/>Pre-condition: A valid SIC and list of Equipment numbers are supplied.
     * <br/>Post-condition: A list of Equipment with matching input Equipment number is retrieved. If an Equipment is not at that service center, then a message 'Equipment not found at the sic' is returned.
     * <br/>
     * <br/>Use Case 3
     * <br/>Pre-condition: A valid SIC and Equipment current status is supplied.
     * <br/>Post-condition: A list of Equipment with matching input Equipment status is returned.
     * <br/>
     * <br/>Use Case 4
     * <br/>Pre-condition: A valid SIC and Equipment type are supplied.
     * <br/>Post-condition: A list of Equipment with matching input Equipment type is returned.
     * <br/>
     * <br/>Use Case 5
     * <br/>Pre-condition: A valid SIC and from door and to door is supplied.
     * <br/>Post-condition: A list of Equipment that are at the doors specified in the input door range is returned.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listEquipmentBySic(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/service-centers/{sicCd}/equipment'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This API endpoint will retrieve a list of all Equipment Events for a given Equipment Id and Load Release Nbr. eventTypeCd and eventSubTypeCd are optional parameters and if supplied then list will be filtered by these events.
     * <br/>
     * <br/>
     * <br/>Use Case 1
     * <br/>Pre-conditions: A valid equipmentId and loadReleaseNbr is supplied.
     * <br/>Post-conditions: List of Equipment events for input equipmentId and LoadReleaseNumber are returned. If optional parameters eventTypeCd and eventSubTypeCd are supplied then the list is only filtered to display those events.
     * <br/>If no event is found then 404 is returned.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listEquipmentEvents(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipments/{equipmentId}/events/{loadReleaseNbr}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists parent and child PROs for an equipment ID.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1.  A valid equipmentId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the details for the list of loaded parent and child PROs will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listLoadedProsByEquipmentId(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/equipment/{equipmentId}/loaded-pros'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation gets the load quality rating for a trailer's open or close event.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A trailer must exist for the given prefix and suffix. The prefix may be 0-padded for numeric values, but the suffix must not.
     * <br/>2. The SIC provided must be valid and exist.
     * <br/>3. The door number must exist for the requested SIC.
     * <br/>4. The event type must be either 'Open' or 'Close'.
     * <br/>5. The timestamp at which the picture was taken must follow RFC 3339. E.g. '2022-08-30T01:49:45.607+00:00'.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer's load quality rating, along with any associated reason codes, will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getTrailerLoadQualityRating(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailers/load-quality-ratings'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the trailer specification.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid trailertypeCd and trailerSubTypeCd is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the trailer specification satisfying the criteria is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getTrailerSpecification(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailer-specifications/{trailerTypeCd}/{trailerSubTypeCd}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation will return a list of trailer content. It lists the shipments and hazmat information for shipments loaded on the trailer.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid equipment identifier must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of trailer content is returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listTrailerContent(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailer-contents'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Delete expired messages in the queue
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteExpiredMessages(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation returns counts for the number of ensembles in each of the status cd values.
     * <br/>Pre-conditions:
     * <br/>1. Input search criteria may be provided.
     * <br/>Post-condition:
     * <br/>1. Counts for each ensemble status are returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getEnsembleStatusCounts(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/counts/{fromTmst}/{toTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns counts for PubSub statuses
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getPubSubStatusCounts(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/summary/counts/{fromTmst}/{toTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns counts for the number of messages pending in the queue.
     * <br/>Pre-conditions:
     * <br/>1. Queue name is provided.
     * <br/>Post-condition:
     * <br/>1. Count of all messages in ready and wait statuses
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getQueuePendingCount(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/counts/pending'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation return Status of Given Subscription
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getSubscription(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a count of number of undelivered messages in this PubSub subscription
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getUndeliveredMessages(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/undelivered/counts'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates one or more SUSPENDED Ensemble execution row to a status of KILLED, in order to indicate it is has been forced to stop processing.
     * <br/>Pre-conditions:
     * <br/>1. One or more Ensemble Instance Ids that is in a status of SUSPENDED is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. Ensemble record(s) updated to a Status of KILLED.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    killEnsemble(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/ensembles/kill'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * List all expired messages in the queue
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listExpiredMessages(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages/{enqueueFromTmst}/{enqueueToTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the queues.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listQueues(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the Pub/Sub subscriptions.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listSubscriptions(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Replay a message in expired status
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    replayMessage(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages/{messageId}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation Restarts a STARTED or NOT_STARTED Ensemble execution based on input Ensemble Instance Id.
     * <br/>Pre-conditions:
     * <br/>1. Input Ensemble Instance Id is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. STARTED or NOT_STARTED Ensemble execution status is updated to STARTED and execution is initiated; if any Minuets exist for the Ensemble, those are initiated in sequence and status updates are performed.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    restartEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/ensembles/{ensembleInstId}/restart'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation Resumes a SUSPENDED Ensemble execution based on input Ensemble Instance Id.
     * <br/>Pre-conditions:
     * <br/>1. Input Ensemble Instance Id is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. SUSPENDED Ensemble execution status is updated to STARTED and execution is initiated; if any Minuets exist for the Ensemble, those are initiated in sequence and status updates are performed.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    resumeEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/ensembles/{ensembleInstId}/resume'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Start a queue.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startQueue(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/start'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Start or restart a PubSub subscription.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startSubscription(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/start'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Stop a queue. Stopping a queue will only stop the dequeuing process, it will continue to enqueue
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopQueue(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/stop'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Stop a queue. Stopping a queue will only stop the dequeuing process, it will continue to enqueue
     * @param {?} request
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopQueueWebhook(request, pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/webhooks/queues/{queueName}/stop'), {
            pathParams: pathParams,
            queryParams: queryParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Stop a PubSub subscription.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopSubscription(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/stop'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Export documents from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. All documents matching the filter will be exported as CSV or Excel format
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    exportEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/exports'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Aggregations from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>2. One of more fields are supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. Aggregations for each supplied field
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listAggregationsEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/aggregations'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Search documents from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. Documents matching the filter will be returned
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    searchEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/searches'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Check changed documents against registered filters for ensemble-state-unfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    changesFeedEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/changes'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Register a filter with XRT for EnsembleStateUnfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    registerFilterEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/filters/register'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Unregister a filter with XRT for EnsembleStateUnfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    unregisterFilterEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/filters/unregister'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Delete Elastic document for EnsembleState
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteElasticDocumentEnsembleState(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Get Elastic document from EnsembleState index for given primary key
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getElasticDocumentEnsembleState(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get document count from EnsembleState index
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getElasticDocumentEnsembleStateCount(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_count'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Update Elastic document for EnsembleState
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateElasticDocumentEnsembleState(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}/_update'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * List all ensemble configurations
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listEnsembleConfigurations(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/configurations'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the timers.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listTimerEnsembles(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timer-ensembles/{name}/timers'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Start a timer.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startTimerEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timers/{name}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Stop a timer.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopTimerEnsemble(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timers/{name}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Start ensemble by invoking API
     * <br/>        	PRE-CONDITION:
     * <br/>        		valid channelName is required
     * <br/>        		valid payload is required
     * <br/>        	POST-CONDITION:
     * <br/>        		Ensemble is started and an id is returned in the response
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startAsynchPrintChEnsemble(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/DOP_ASYNCH_PRINT_CH/ensembles'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Start ensemble by invoking API
     * <br/>        	PRE-CONDITION:
     * <br/>        		valid channelName is required
     * <br/>        		valid payload is required
     * <br/>        	POST-CONDITION:
     * <br/>        		Ensemble is started and an id is returned in the response
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startPrintTrlrManifestChEnsemble(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/DOP_PRINT_TRLR_MANIFEST_CH/ensembles'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(DockOperationsApiService.DockOperationsApiEndpoint);
    }
}
DockOperationsApiService.ɵfac = function DockOperationsApiService_Factory(t) { return new (t || DockOperationsApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
DockOperationsApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DockOperationsApiService, factory: DockOperationsApiService.ɵfac });
DockOperationsApiService.DockOperationsApiEndpoint = 'dockoperationsApiEndpoint';
/** @nocollapse */
DockOperationsApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DockOperationsApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkDockOperationsModule {
}
SdkDockOperationsModule.ɵfac = function SdkDockOperationsModule_Factory(t) { return new (t || SdkDockOperationsModule)(); };
SdkDockOperationsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkDockOperationsModule });
SdkDockOperationsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DockOperationsApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkDockOperationsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    DockOperationsApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkDockOperationsModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Path parameters for get Ensemble status counts
 */
class GetEnsembleStatusCountsPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * From timestamp
         * Required: true
         * Array: false
         */
        this.fromTmst = undefined;
        /**
         * To timestamp
         * Required: true
         * Array: false
         */
        this.toTmst = undefined;
    }
}
/**
 * Response to the request to get Ensemble status counts
 */
class GetEnsembleStatusCountsResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.ensembleMetrics = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.queueMetrics = undefined;
    }
}
/**
 * Path parameters for get Ensemble status counts
 */
class GetQueuePendingCountPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Response for getQueuePendingCount
 */
class GetQueuePendingCountResp {
    constructor() {
        /**
         * Number of messages in either ready or wait status. This count indicates the queue depth.
         * Required: false
         * Array: false
         */
        this.pendingCount = undefined;
    }
}
/**
 * Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsemblePath {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Unique identifier for the application workflow.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsembleRqst {
}
/**
 * Response to the Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsembleResp {
    constructor() {
        /**
         * Ensemble that was Restarted.
         * Required: false
         * Array: false
         */
        this.ensembleRestartedInd = undefined;
    }
}
/**
 * Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsemblePath {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Unique identifier for the application workflow.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsembleRqst {
}
/**
 * Response to the Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsembleResp {
    constructor() {
        /**
         * Ensemble that was Resumed
         * Required: false
         * Array: false
         */
        this.ensembleResumedInd = undefined;
    }
}
/**
 * Request to start ensemble.
 */
class StartMessageDrivenEnsembleRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.queue = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.message = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.eventDataType = undefined;
    }
}
/**
 * Enter comments
 */
class StartMessageDrivenEnsembleResp {
    constructor() {
        /**
         * Instance ID of the ensemble that was started.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to stop execution of an Ensemble
 */
class KillEnsembleRqst {
    constructor() {
        /**
         * Unique identifier for the ensemble.
         * Required: true
         * Array: true
         */
        this.ensembleInstIds = undefined;
    }
}
/**
 * Response to the request to stop execution of an Ensemble
 */
class KillEnsembleResp {
    constructor() {
        /**
         * Ensembles that were killed.
         * Required: false
         * Array: true
         */
        this.status = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueuePath {
    constructor() {
        /**
         * Name of the queue to stop
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueueWebhookPath {
    constructor() {
        /**
         * Name of the queue to stop
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueueWebhookQuery {
    constructor() {
        /**
         * Authorization token
         * Required: false
         * Array: false
         */
        this.auth_token = undefined;
    }
}
/**
 * Path parameters for startQueue
 */
class StartQueuePath {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Response for listQueues
 */
class ListQueuesResp {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: true
         */
        this.queues = undefined;
    }
}
/**
 * Path parameters
 */
class ListExpiredMessagesPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * From enqueue timestamp
         * Required: true
         * Array: false
         */
        this.enqueueFromTmst = undefined;
        /**
         * Tom enqueue timestamp
         * Required: true
         * Array: false
         */
        this.enqueueToTmst = undefined;
    }
}
/**
 * Response
 */
class ListExpiredMessagesResp {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: true
         */
        this.message = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteExpiredMessagesPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteExpiredMessagesQuery {
    constructor() {
        /**
         * Id of the message to be deleted
         * Required: true
         * Array: true
         */
        this.messageId = undefined;
    }
}
/**
 * Response to the request to stop execution of an Ensemble
 */
class DeleteExpiredMessagesResp {
    constructor() {
        /**
         * Ensembles that were killed.
         * Required: false
         * Array: true
         */
        this.status = undefined;
    }
}
/**
 * Path parameters
 */
class ReplayMessagePath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * ID of the message to replay. It needs to be in expired status
         * Required: true
         * Array: false
         */
        this.messageId = undefined;
    }
}
/**
 * Path parameters for get Ensemble status counts
 */
class GetPubSubStatusCountsPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
        /**
         * From timestamp
         * Required: true
         * Array: false
         */
        this.fromTmst = undefined;
        /**
         * To timestamp
         * Required: true
         * Array: false
         */
        this.toTmst = undefined;
    }
}
/**
 * Response to the request to get Ensemble status counts
 */
class GetPubSubStatusCountsResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.pubsubMetrics = undefined;
    }
}
/**
 * Path parameters for startSubscription
 */
class StartSubscriptionPath {
    constructor() {
        /**
         * Id of the subscription to start
         * Required: false
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Path parameters for stopSubscription
 */
class StopSubscriptionPath {
    constructor() {
        /**
         * Id of the subscription to stop
         * Required: false
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Path parameters for get Undelivered Message counts
 */
class GetUndeliveredMessagesPath {
    constructor() {
        /**
         * Id of subscription
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Response for getUndeliveredMessages
 */
class GetUndeliveredMessagesResp {
    constructor() {
        /**
         * Number of Undelivered Messages.
         * Required: false
         * Array: false
         */
        this.undeliveredCount = undefined;
    }
}
/**
 * Response for listSubscriptions
 */
class ListSubscriptionsResp {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: true
         */
        this.subscriptions = undefined;
    }
}
/**
 * Path parameters for Get subscription count
 */
class GetSubscriptionPath {
    constructor() {
        /**
         * Subscription id
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Returns status of a given subscription
 */
class GetSubscriptionResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.subscription = undefined;
    }
}
class MessageDrivenEnsemblePayload {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * The event occurrence timestamp
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The event occurrence timestamp in microseconds
         * Required: false
         * Array: false
         */
        this.eventTmstMicro = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: false
         */
        this.eventData = undefined;
    }
}
class DynamicMessageDrivenPayload {
    constructor() {
        /**
         * The type of the payload
         * Required: true
         * Array: false
         */
        this.eventDataType = undefined;
        /**
         * The message payload
         * Required: true
         * Array: false
         */
        this.payload = undefined;
    }
}
class TransactionEventEnsemblePayload {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * The event occurrence timestamp
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The event occurrence timestamp in microseconds
         * Required: false
         * Array: false
         */
        this.eventTmstMicro = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: false
         */
        this.eventData = undefined;
    }
}
/**
 * Status of a delete expired message request
 */
class DeleteExpiredMessageStatus {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Indicates whether the ensemble was killed.
         * Required: false
         * Array: false
         */
        this.messageDeletedInd = undefined;
        /**
         * A status describing why the message could not be deleted. Populated if messageDeletedInd is false
         * Required: false
         * Array: false
         */
        this.failStatus = undefined;
    }
}
/**
 * Status of a kill ensemble request
 */
class KillEnsembleStatus {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
        /**
         * Indicates whether the ensemble was killed.
         * Required: false
         * Array: false
         */
        this.ensembleKilledInd = undefined;
        /**
         * A status describing why the ensemble could not be killed. Populated if ensembleKilledInd is false
         * Required: false
         * Array: false
         */
        this.failStatus = undefined;
    }
}
/**
 * Stores execution information for application workflows.
 */
class EnsembleStateSearchRecord {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState = undefined;
    }
}
class Payload {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.type = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.value = undefined;
    }
}
class EnsembleState {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * A short description of the ensemble
         * Required: false
         * Array: false
         */
        this.desc = undefined;
        /**
         * Name of the queue publishing this message.
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Id of the message.
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * The timestamp of when the trigger event was created.
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The timestamp of when the message was received by ensemble.
         * Required: false
         * Array: false
         */
        this.recvTmst = undefined;
        /**
         * The timestamp of when this ensemble was dispatched to the executor thread.
         * Required: false
         * Array: false
         */
        this.dispatchTmst = undefined;
        /**
         * The timestamp of when this ensemble processing started.
         * Required: false
         * Array: false
         */
        this.strtTmst = undefined;
        /**
         * The timestamp of when this ensemble processing ended.
         * Required: false
         * Array: false
         */
        this.endTmst = undefined;
        /**
         * Dequeue time in milliseconds. Populated for started ensembles, and is the difference between the received and event timestamps.
         * Required: false
         * Array: false
         */
        this.dequeueTime = undefined;
        /**
         * Dispatch time in milliseconds. Populated for started ensembles, and is the difference between the dispatch and received timestamps.
         * Required: false
         * Array: false
         */
        this.dispatchTime = undefined;
        /**
         * Wait time in milliseconds. Populated for started ensembles, and is the difference between the start and dispatch timestamps.
         * Required: false
         * Array: false
         */
        this.waitTime = undefined;
        /**
         * Time in milliseconds it took to process this ensemble from the time it was started. Populated for completed ensembles, and is the difference between the end and start timestamps.
         * Required: false
         * Array: false
         */
        this.processTime = undefined;
        /**
         * Total elapsed time in milliseconds to process this ensemble from the time the event was created. Populated for completed ensembles, and is the difference between the start and event timestamps.
         * Required: false
         * Array: false
         */
        this.totalTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lstUpdtTmst = undefined;
        /**
         * Status of workflow execution.
         *
         * Valid values:
         * NOT_STARTED
         * STARTED
         * SUSPENDED
         * COMPLETED
         * Required: false
         * Array: false
         */
        this.statCd = undefined;
        /**
         * Status message for the workflow execution.  This could be an error message, stacktrace, success message, etc.
         * Required: false
         * Array: false
         */
        this.statMsg = undefined;
        /**
         * Same value for CORRELATION
         *
         * id is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multiple rows across various tables for a single business
         *
         * transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Name of the host on which the ensemble was last processed
         * Required: false
         * Array: false
         */
        this.host = undefined;
        /**
         * Name of the thread on which the ensemble was last processed
         * Required: false
         * Array: false
         */
        this.thread = undefined;
        /**
         * Timestamp of when the ensemble started waiting for lock
         * Required: false
         * Array: false
         */
        this.lockWaitStartTmst = undefined;
        /**
         * Time spent on waiting for lock
         * Required: false
         * Array: false
         */
        this.elapsedLockWaitTime = undefined;
        /**
         * Number of times this ensemble was put on lock wait
         * Required: false
         * Array: false
         */
        this.lockWaitCount = undefined;
        /**
         * When the ensemble was paused
         * Required: false
         * Array: false
         */
        this.pauseStartTmst = undefined;
        /**
         * When the pause will expire
         * Required: false
         * Array: false
         */
        this.pauseExpiryTime = undefined;
        /**
         * Number of times this ensemble was put on pause
         * Required: false
         * Array: false
         */
        this.pauseCount = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.minuetStates = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.gotoEnsembleStates = undefined;
        /**
         * Payload that is input to the ensemble execution.
         * Required: false
         * Array: false
         */
        this.payload = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.executionContext = undefined;
    }
}
class NestedEnsembleState {
    constructor() {
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.minuetStates = undefined;
    }
}
class EnsembleExecutionContext {
    constructor() {
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.minuetPtr = undefined;
    }
}
/**
 * Stores execution information for the tasks that compose the application workflow.
 */
class MinuetState {
    constructor() {
        /**
         * Name of the task.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Response payload that is output  from the task.
         * Required: false
         * Array: false
         */
        this.respPayload = undefined;
        /**
         * Datetime the task execution started
         * Required: false
         * Array: false
         */
        this.strtTmst = undefined;
        /**
         * Datetime the task execution ended
         * Required: false
         * Array: false
         */
        this.endTmst = undefined;
        /**
         * Time in milliseconds it took to process this minuet from the time it was started. Populated for completed minuets, and is the difference between the end and start timestamps.
         * Required: false
         * Array: false
         */
        this.processTime = undefined;
        /**
         * Number of times this minuet was retried
         * Required: false
         * Array: false
         */
        this.executionCount = undefined;
        /**
         * Status of task execution.
         *
         * Valid values:
         * STARTED
         * FAILED
         * COMPLETED
         * Required: false
         * Array: false
         */
        this.statCd = undefined;
        /**
         * Status message for the task.  This could be an error message, stacktrace, success message, etc.
         * Required: false
         * Array: false
         */
        this.statMsg = undefined;
    }
}
class EnsembleMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.notStartedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.startedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.completedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.suspendedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.failedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.killedCount = undefined;
    }
}
class PubSubMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.sentMessageCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ackedMessageCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.expiredAckDeadLinesCount = undefined;
    }
}
class QueueMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.readyCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.waitCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.processedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.expiredCount = undefined;
    }
}
class AuxMessagePublishers {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.queueTypeCd = undefined;
    }
}
class EnsembleConfiguration {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.component = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.mode = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shortName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.sourceTable = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.payloadType = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.cacheEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.lockEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.retriggerEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.waitEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.rulesEngineEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.messagePublisherEnabled = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.auxMessagePublishers = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.fileAccessEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.synchronousResponseType = undefined;
    }
}
class Subscription {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.id = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.status = undefined;
    }
}
class LTLEventDockOperations {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * Contains a list of additional event types that are included in this event.
         * Required: false
         * Array: true
         */
        this.auxEventTypes = undefined;
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The name of component from which this event originated.
         * Required: false
         * Array: false
         */
        this.srcComponent = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * A unique id for the event. If this is chunked, the eventId will help in combining chunks of the same message
         * Required: false
         * Array: false
         */
        this.eventId = undefined;
        /**
         * If there are a large number of payloads, the events can be chunked and published as smaller payloads. Set chunkInd to true if this is a chunk of a larger event message
         * Required: false
         * Array: false
         */
        this.chunkedInd = undefined;
        /**
         * If this is a chunked event message, specifies the sequence number of this instance
         * Required: false
         * Array: false
         */
        this.chunkSeqNbr = undefined;
        /**
         * If this is a chunked event message, specifies the total number of chunks
         * Required: false
         * Array: false
         */
        this.totalChunks = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: true
         */
        this.eventData = undefined;
    }
}
/**
 * An Update response from a BULK update to elastic
 */
class BulkUpdateResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this._index = undefined;
        /**
         * Required: false
         * Array: false
         */
        this._id = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.result = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.status = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.error = undefined;
    }
}
/**
 * Details of an error for an item
 */
class BulkUpdateItemError {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.type = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.reason = undefined;
    }
}
/**
 * An item in the bulk api response
 */
class BulkApiRespItem {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.update = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.index = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.create = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.delete = undefined;
    }
}
class EsAggregationFieldRqst {
    constructor() {
        /**
         * the name of the property to aggregate on (siteCode, employeeCode, etc.)
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * aggregation type on that property. Options for field object: term, date, distinctCount. Options for subfield object: term, stats, date, distinctCount
         * Required: false
         * Array: false
         */
        this.type = undefined;
        /**
         * max number of rows to return
         * Required: false
         * Array: false
         */
        this.size = undefined;
        /**
         * second, minute, hour, day, week, month, quarter, year. Applies only when type is set to date
         * Required: false
         * Array: false
         */
        this.dateInterval = undefined;
        /**
         * min number of documents to filter date interval on. Applies only when type is set to date
         * Required: false
         * Array: false
         */
        this.minimumDocumentCount = undefined;
        /**
         * min number of documents to filter date interval on. Applies only when type is set to date
         * Required: false
         * Array: true
         */
        this.subFields = undefined;
    }
}
class EsDynamicPivotRqst {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
    }
}
class EsAggregationRqst {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.dynamicPivot = undefined;
    }
}
class EsAggregationFieldResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.key = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.date = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.subFields = undefined;
    }
}
class EsAggregationResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.dynamicPivot = undefined;
    }
}
class EnsembleStateSearchFilterNot {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
    }
}
class EnsembleStateSearchFilterOr {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "and": this.and,
                "not": this.not
            };
        };
    }
}
class EnsembleStateSearchFilterAnd {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "or": this.or,
                "not": this.not
            };
        };
    }
}
class EnsembleStateSearchFilter {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.q = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.b = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "q": this.q,
                "b": this.b,
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "and": this.and,
                "or": this.or,
                "not": this.not
            };
        };
    }
}
/**
 * Path parameters
 */
class GetElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Query parameters
 */
class GetElasticDocumentEnsembleStateQuery {
    constructor() {
        /**
         * Source filter
         * Required: false
         * Array: false
         */
        this._source = undefined;
        /**
         * Source include filter
         * Required: false
         * Array: false
         */
        this._source_includes = undefined;
        /**
         * Source exclude filter
         * Required: false
         * Array: false
         */
        this._source_excludes = undefined;
    }
}
/**
 * Response from getElasticDocument.
 */
class GetElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The record if found
         * Required: false
         * Array: false
         */
        this.record = undefined;
    }
}
/**
 * Query parameters
 */
class GetElasticDocumentEnsembleStateCountQuery {
    constructor() {
        /**
         * Query filter
         * Required: false
         * Array: false
         */
        this.q = undefined;
    }
}
/**
 * Response from getElasticDocumentCount.
 */
class GetElasticDocumentEnsembleStateCountResp {
    constructor() {
        /**
         * The count of the documents
         * Required: false
         * Array: false
         */
        this.count = undefined;
    }
}
/**
 * Request message to update information for EnsembleState.
 */
class UpdateElasticDocumentEnsembleStateRqst {
    constructor() {
        /**
         * The record to upsert in elastic
         * Required: false
         * Array: false
         */
        this.doc = undefined;
        /**
         * Indicate if an upsert operation should be executed if the document was not found
         * Required: false
         * Array: false
         */
        this.doc_as_upsert = undefined;
    }
}
/**
 * Path parameters
 */
class UpdateElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Response from updateElasticDocument.
 */
class UpdateElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The result of the operation
         * Required: false
         * Array: false
         */
        this.result = undefined;
    }
}
/**
 * Response from bulkUpdateElasticDocument.
 */
class BulkUpdateElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The time it took to process this request
         * Required: false
         * Array: false
         */
        this.took = undefined;
        /**
         * Indicates if there are any errors
         * Required: false
         * Array: false
         */
        this.errors = undefined;
        /**
         * Results of the bulk operations
         * Required: false
         * Array: true
         */
        this.items = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Request message to delete information for EnsembleState.
 */
class DeleteElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The result of the operation
         * Required: false
         * Array: false
         */
        this.result = undefined;
    }
}
/**
 * Request message to search information for ensemble-state-unfiltered.
 */
class SearchEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.pageNumber = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.sortExpressions = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.excludeFields = undefined;
        /**
         * Query for searching
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Response to the request to search information for ensemble-state-unfiltered.
 */
class SearchEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.header = undefined;
        /**
         * Search results
         * Required: false
         * Array: true
         */
        this.result = undefined;
    }
}
/**
 * Request message to export information for ensemble-state-unfiltered.
 */
class ExportEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.fileType = undefined;
        /**
         * Query for exporting
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Request for register filter
 */
class RegisterFilterEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Id of the  user
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The filter to register
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Response for register filter
 */
class RegisterFilterEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Hash for the filter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
        /**
         * Duration for the API execution
         * Required: false
         * Array: false
         */
        this.duration = undefined;
        /**
         * Number of registrations created
         * Required: false
         * Array: false
         */
        this.numberOfRegistrations = undefined;
    }
}
/**
 * Request for register
 */
class UnregisterFilterEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Id of the  user. For future use.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The hash of the filter to unregister. Filter has is returned by registerFilter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
    }
}
/**
 * Request for changes feed
 */
class ChangesFeedEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * A list of document Ids
         * Required: false
         * Array: true
         */
        this.changedDocumentIds = undefined;
        /**
         * A list of changed documents
         * Required: false
         * Array: true
         */
        this.changedDocuments = undefined;
    }
}
/**
 *
 * 				Request for list aggregations
 * 				To aggregate data by any field you need to specify field properties on top level and subfield properties on any deeper level of aggregation.
 *
 */
class ListAggregationsEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Filter for aggregations
         * Required: false
         * Array: false
         */
        this.filter = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.aggregations = undefined;
    }
}
/**
 * Response for list aggregations
 */
class ListAggregationsEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Aggregations
         * Required: false
         * Array: false
         */
        this.aggregations = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.resultCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageNumber = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.duration = undefined;
    }
}
/**
 *
 */
class Badgeassign {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.badgeAssignId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.personId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.badgeNumber = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.effectiveDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.expirationDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedByUserAccountId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.versionCount = undefined;
    }
}
/**
 * Holds a snapshot of Badgeassign. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class BadgeassignSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.badgeAssignId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class DeliveryNotification {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.notificationInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.elecNotificationCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.callDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.callerId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.contactName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.contactPhoneNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.contactPhoneExtensionNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.notificationCategoryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.notificationTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDeliveryDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDeliveryFromTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDeliveryToTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeRefNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.rescheduledReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.internalNote = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fbdsNote = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DeliveryShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleIdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billClassCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastMovementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerCurrentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerEtaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationLiftgateInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.motorizedPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inbondInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.purgeBlockInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.adminAsofDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationArrivalDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.timeDateCriticalInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationNotifyInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceSummaryInd = undefined;
        /**
         * The trailer on which this shipment is currently located
         * Required: false
         * Array: false
         */
        this.currentTrailer = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeCustomerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.drvrCollectCd = undefined;
        /**
         * Desc: Identifies if the
         *
         * shipment is on a trailer that has been excluded from the destination SICs inbound plan
         *
         * (Y) or not (N).
         *
         * 05/01/2019 Added by Cathy Doucet as per Bill Muchmore (PND Tower)
         * Required: false
         * Array: false
         */
        this.onExcludedTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         * This is the ETA at
         *
         * the destination SIC, and is recalculated for every linehaul dispatch and arrive event.
         *
         * 	Added 10/23/2019
         * Required: false
         * Array: false
         */
        this.destinationSicEtaDateTime = undefined;
        /**
         * An appointment should be created for delivering the shipment.  Added 03/11/2021 Cathy Doucet LISG-10771
         * Required: false
         * Array: false
         */
        this.appointmentRequiredInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of DeliveryShipment. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class DeliveryShipmentSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class DimensionsCheckDsrRecheck {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.recheckStartDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.recheckByDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.recheckCompletedDate = undefined;
        /**
         * Same value for CORR
         * ELATION id is assigned to various rows from different tables that form a single
         * business transactions. In other words, this groups multiple rows across various
         * tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event
         * id is assigned to various rows from different tables that form a single database
         * 	transactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DimensionsCheckLog {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.checkDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideExistsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrSelectionTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrSelectedByUserId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cycleEndDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION
         * id is assigned to various rows from different tables that form a single business
         * 	transactions. In other words, this groups multiple rows across various tables f
         * or a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DimensionsCheckShipmentOverride {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.checkDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideByEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideDateTime = undefined;
        /**
         * Same value for CORRE
         * LATION id is assigned to various rows from different tables that form a single b
         * usiness transactions. In other words, this groups multiple rows across various t
         * ables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event i
         * d is assigned to various rows from different tables that form a single database
         * transactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DimensionsCheckTrailer {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.checkDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.processedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideByEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION
         * 	id is assigned to various rows from different tables that form a single busines
         * s transactions. In other words, this groups multiple rows across various tables
         * for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is a
         * ssigned to various rows from different tables that form a single database transa
         * ctions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DockActivity {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockVisitInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockActivitySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockActivityCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryInformationRqdCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualActivityDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualActivityDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freightStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.foodInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Same value for CORRELATIO
         * N id is assigned to various rows from different tables that form a single busine
         * ss transactions. In other words, this groups multiple rows across various tables
         * 	for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * assigned to various rows from different tables that form a single database trans
         * actions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DockLoadedHandlingUnit {
    constructor() {
        /**
         * Unique ID of
         * 	a
         * Dock Location.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The
         * 	Child PRO number that identifies a handling unit that is loaded in a
         * 	dock location.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * This
         * 	parent pro number identifies which handling units are part
         * 					of the same shipment. This is the pro number found in the BOL
         * document.
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of DockLoadedHandlingUnit. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class DockLoadedHandlingUnitSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * Unique ID of
         * 	a
         * Dock Location.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The
         * 	Child PRO number that identifies a handling unit that is loaded in a
         * 	dock location.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class DockLoadedShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of DockLoadedShipment. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class DockLoadedShipmentSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class DockLocation {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.terminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockClosestDoorNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
    }
}
/**
 *
 */
class DockVisit {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockVisitInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockVisitSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerArriveDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerDepartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerArriveDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerDepartDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipperUnloadAtDockInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeLoadedAtDockInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freightStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cashDueCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freezeCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentRtndCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalBillCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPalletCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalMmCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Same value for CORRELATION i
         * d is assigned to various rows from different tables that form a single business
         * transactions. In other words, this groups multiple rows across various tables fo
         * r a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is ass
         * igned to various rows from different tables that form a single database transact
         * ions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.dockActivity = undefined;
    }
}
/**
 *
 */
class DockWorkAssignment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockPlanSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockPlanDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockPlanShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.workerTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.workAssignmentSectorId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.workAssignmentCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.acceptedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.employeeName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.employeeDomicileSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockPlanInstId = undefined;
        /**
         * Same value for CORRELATI
         * ON id is assigned to various rows from different tables that form a single busin
         * ess transactions. In other words, this groups multiple rows across various table
         * s for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * 	assigned to various rows from different tables that form a single database tran
         * sactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class DoorAssignment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.assignmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.owningSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cutoffTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDoorName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.facCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.secondFacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thirdFacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.priorityNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sectorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceProfileInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceDoorDisplaySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doorPlanFacCrossReferenceCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceFacSectorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.owningSicTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mustMoveSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dayFreightInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION
         * id is assigned to various rows from different tables that form a single business
         * 	transactions. In other words, this groups multiple rows across various tables f
         * or a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * This table will be used to stage the data to start the weekly door plan creation process. The table will be truncated and loaded every week.  Added 08/04/2020
 */
class DoorPlanExtractStg {
    constructor() {
        /**
         * SIC Code of the Shipment Origin
         * Required: false
         * Array: false
         */
        this.originSicCode = undefined;
        /**
         * Shift code at the origin SIC.
         *
         * Valid Values
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.originShiftCd = undefined;
        /**
         * SIC Code of the Destination location of the load.
         * Required: false
         * Array: false
         */
        this.destinationSicCode = undefined;
        /**
         * Pickup date of the Shipment.  08/17/2020 Added PKUP_DT to PK
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         * Effective date of the Flow Plan.
         * Required: false
         * Array: false
         */
        this.flowPlanEffectiveDate = undefined;
        /**
         * Current version name of the Flow Plan.
         * Required: false
         * Array: false
         */
        this.flowPlanVersionName = undefined;
        /**
         * XPO or EXC
         * Required: false
         * Array: false
         */
        this.loadToMode1 = undefined;
        /**
         * SIC Code of the 1st Load to location from Orig SIC.
         * Required: false
         * Array: false
         */
        this.loadToSicCode1 = undefined;
        /**
         * Shift Code when the Load reaches at the 1st Load to SIC from Origin Sic.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.loadToShiftCd1 = undefined;
        /**
         * SIC Code where the Load must be after the 1st Load to SIC
         * Required: false
         * Array: false
         */
        this.mustClearSicCode = undefined;
        /**
         * Shift Code when the Load reaches at the Must Clear SIC.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.mustClearShiftCd = undefined;
        /**
         * If the lane is Day lane then Y else N.
         * Required: false
         * Array: false
         */
        this.daylaneFreightInd = undefined;
        /**
         * SIC Code of the 1st Move To Location from the Orig SIC.
         * Required: false
         * Array: false
         */
        this.moveToSicCode1 = undefined;
        /**
         * SIC Code of the 1st Move To Location from the Orig SIC.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.moveToShiftCd1 = undefined;
        /**
         * SIC Code of the 2nd Load to location from Orig SIC.
         * Required: false
         * Array: false
         */
        this.loadToSicCode2 = undefined;
        /**
         * Shift Code when the Load reaches at the 2nd Load to SIC from Origin Sic.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.loadToShiftCd2 = undefined;
        /**
         * SIC Code of the 3rd Load to location from Orig SIC.
         * Required: false
         * Array: false
         */
        this.loadToSicCode3 = undefined;
        /**
         * Shift Code when the Load reaches at the 3rd Load to SIC from Origin Sic.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.loadToShiftCd3 = undefined;
        /**
         * Total Input weight expected from Origin SIC to DEST SIC
         * Required: false
         * Array: false
         */
        this.weightInLbs = undefined;
        /**
         * Total Input cube expected from Origin SIC to DEST SIC.
         * Required: false
         * Array: false
         */
        this.cubeInCubicFeet = undefined;
        /**
         * Total Output weight expected from Origin SIC to DEST SIC
         * Required: false
         * Array: false
         */
        this.weightOutLbs = undefined;
        /**
         * Total Output cube expected from Origin SIC to DEST SIC
         * Required: false
         * Array: false
         */
        this.cubeOutCubicFeet = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * This table captures the preferences about a door at a Sic for a given shift and profile type.  Added 05/13/2021  LISG-12284
 */
class DoorPreference {
    constructor() {
        /**
         * Unique ID
         * Required: false
         * Array: false
         */
        this.doorPreferenceId = undefined;
        /**
         * SIC code of the service center to which the door belongs
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * Shift Code for which the Door Preference is created.
         *
         * Valid Values:
         * I(Inbound)
         * O(Outbound)
         * D(DayReship)
         * N(NightFAC)
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * Indicates the type of Profile for which to capture the Door Preference.
         *
         * Valid values:
         * STATIC
         * CURRENT
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         * Identifies the door number at the Sic
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * Indicates if the Door should be excluded from Step Saver Process.
         * If Y then door is excluded from Step Saver
         * Required: false
         * Array: false
         */
        this.stepSaverExcludeInd = undefined;
        /**
         * Indicates if the Door should be used for Loading and Unloading.
         * If N then door can't be used for Loading and Unloading
         * Required: false
         * Array: false
         */
        this.loadUnloadInd = undefined;
        /**
         * Indicates if the Door should be used as a Trap Door to hold freight for next shift.  If Y then use the door as trap door
         * Required: false
         * Array: false
         */
        this.trapInd = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is assigned to various rows from different tables that form a single database transactions.
         * Multiple database transactions could make up one business transaction, which is indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single database transaction.
         * Typically this is used to publish a message to a queue for consumption or a workflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * When set to Y, to be used for Embargoed Locations.  Added 01/13/2022  LISG-15915
         * Required: false
         * Array: false
         */
        this.embargoInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class EmployeeDevice {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.devSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.primaryDeviceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serverAddress = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.devicePhoneCountryCdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.devicePhoneAreaCdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.devicePhoneNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.logonSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.applCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deviceIpAddress = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Equipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeDetailCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleSequence = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvnt = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvntDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnScacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnReturnSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRespSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRntlCntrNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRntlInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnCreatedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateTransactionSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mfrYr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmclSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.wrkRequestInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pmDueDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inServiceDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.safeStackInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeToRsiInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.extdSlprLaneInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.limitedAvailableInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatusQlfrCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * The equipment prefix and suffix concatenated.
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The validation message associated with Equipment.
         * Required: false
         * Array: false
         */
        this.validationMessage = undefined;
        /**
         * Indicates whether any shipments have been loaded onto the truck or trailer.
         * Required: false
         * Array: false
         */
        this.loadedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentScheduleIdNbr = undefined;
        /**
         * The code that is associated with the status of the schedule when parentScheduleIdNbr exists.
         * Required: false
         * Array: false
         */
        this.parentScheduleStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoad = undefined;
    }
}
/**
 *
 */
class EquipmentHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeDetailCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleSequence = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleIdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnScacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnReturnSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRespSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRntlCntrNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnRntlInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frgnCreatedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateTransactionSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mfrYr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.domicileSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.wrkRequestInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pmDueDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inServiceDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.safeStackInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeToRsiInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.extdSlprLaneInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.limitedAvailableInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatusQlfrCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Table that captures who operated the equipment.  Added initially for forklift use, but can be used by any equipment.  It will be a self-history table, so inserts only.  Added 04/24/2020
 */
class EquipmentOperator {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The date and time the operator logged in to use equipment.
         * Required: false
         * Array: false
         */
        this.scanDateTime = undefined;
        /**
         * Employee id of the last person to scan/login to the equipment.
         * Required: false
         * Array: false
         */
        this.lastOperatorEmployeeId = undefined;
        /**
         * Service Center where equipment is.
         * Required: false
         * Array: false
         */
        this.sicCode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of Equipment. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class EquipmentSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class Event {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.subTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventOccurredDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedReleaseNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.histCurrentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.histCurrentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmsDocId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.transactionSrcCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.operationsShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reason = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Load Quality Rating of a trailer OPEN or CLOS, ranked as a number between 1 (lowest) to 3 (highest).  Added 04/28/2022  LISG-16714
         * Required: false
         * Array: false
         */
        this.loadQualityRatingNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * The table captures the results of the Close Trailer Photos analyzed by the Google Machine Language learning model to identify if the trailer has Guaranteed and Premium shipments loaded on the tail of the trailer.  Added 10/22/2020  LISG-7918
 */
class EventPhotoAnalysis {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventInstanceId = undefined;
        /**
         * If trailer has any guaranteed shipments loaded, then Y, else N.
         * Required: false
         * Array: false
         */
        this.trailerGuaranteedInd = undefined;
        /**
         * If trailer has any premiom shipments loaded, then Y, else N.
         * Required: false
         * Array: false
         */
        this.trailerPremInd = undefined;
        /**
         * Set to Y if Machine Language Model returns GUARANTEED.
         * Required: false
         * Array: false
         */
        this.modelGuaranteedInd = undefined;
        /**
         * Set to Y when Machine Language Model returns PREMIUM.
         * Required: false
         * Array: false
         */
        this.modelPremInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * If a particular event has one or more reasons that need to be captured, this table will hold those reasons.  Added 04/29/2022 as part of Trailer Load Quality Rating LISG-16714
 */
class EventReason {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventInstId = undefined;
        /**
         * Part of unique PK
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Reason for the event can be logged as a set value and/or a freeform text description.
         *
         * For Load Quality Rating, these are the valid values at present:
         * SAFESTACK
         * STRAPS
         * DUNNAGE
         * BRACING
         * Required: false
         * Array: false
         */
        this.reasonCd = undefined;
        /**
         * Reason can be a code and/or a free form text
         * Required: false
         * Array: false
         */
        this.reason = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of EventReason. Contains the details at the time on an event. It also provides the previous values if an update occured
 * If a particular event has one or more reasons that need to be captured, this table will hold those reasons.  Added 04/29/2022 as part of Trailer Load Quality Rating LISG-16714
 */
class EventReasonSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventInstId = undefined;
        /**
         * Part of unique PK
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Holds a snapshot of Event. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class EventSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventInstId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class FloO2dFlowPlanDetailRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentOpnCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day1Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day1LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day1UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day1MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day2Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day2LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day2UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day2MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day3Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day3LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day3UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day3MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day4Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day4LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day4UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day4MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day5Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day5LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day5UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day5MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day6Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day6LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day6UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day6MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hostedCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob1EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac1EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib1EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day1EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob2EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac2EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib2EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day2EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob3EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac3EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib3EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day3EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob4EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac4EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib4EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day4EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob5EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac5EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib5EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day5EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob6EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac6EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib6EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day6EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob7EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac7EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib7EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day7Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day7LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day7UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day7MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day7EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob8EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac8EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib8EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day8Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day8LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day8UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day8MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day8EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob9EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac9EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib9EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day9Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day9LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day9UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day9MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day9EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob10EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac10EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib10EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day10Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day10LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day10UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day10MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day10EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob11EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac11EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib11EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day11Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day11LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day11UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day11MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day11EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob12EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac12EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib12EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day12Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day12LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day12UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day12MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day12EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob13EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac13EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib13EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day13Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day13LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day13UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day13MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day13EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob14EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac14EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib14EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day14Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day14LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day14UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day14MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.day14EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ob15EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fac15EslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15Sic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15LoadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15UnloadFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15MoveModeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15ShuttleSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ib15EslInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class HeadLoadDetail {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lseOrSkdCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cbePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cbeProfitability = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nbrOfFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
    }
}
/**
 * Details about employees that process and approve claims.
 */
class InterfaceEmployee {
    constructor() {
        /**
         * Employee Id of the Claims employee.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * First Name of the Claims employee.
         * Required: false
         * Array: false
         */
        this.firstName = undefined;
        /**
         * Middle Name of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.middleName = undefined;
        /**
         * Last Name of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.lastName = undefined;
        /**
         * Job Description of the Supervisor of the Claims employee.
         * Required: false
         * Array: false
         */
        this.jobDescription = undefined;
        /**
         * The domicile SIC location for the employee.
         * Required: false
         * Array: false
         */
        this.domicileSicCd = undefined;
        /**
         * The employee id of this employee's supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorEmployeeId = undefined;
        /**
         * Desc: The business phone number of the employee.  It is sourced from HRS_EMPL_PHONE_VW in DB2 for typ_cd = 'B'.  01/10/2019 Added by Cathy
         * Required: false
         * Array: false
         */
        this.businessPhoneTxt = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.racfId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrCellPhone = undefined;
        /**
         * Name the employee prefers to be called by.  Added 10/08/2020 LISG-7899
         * Required: false
         * Array: false
         */
        this.preferredFirstName = undefined;
        /**
         * The Active Directory Domain (a collection of objects within a Microsoft Active Directory network) that an emplyee is part of (CONWAY, CFI, CTS, MENLO)
         * Required: false
         * Array: false
         */
        this.domain = undefined;
        /**
         * Network or domain ID assigned to the employee. It is normally a combination of first and last name of the employee.
         * Required: false
         * Array: false
         */
        this.networkUserId = undefined;
        /**
         * XPO email address assigned to the employee
         * Required: false
         * Array: false
         */
        this.emailAddress = undefined;
        /**
         * The Con-way/Menlo 3 character representation of the SF company code.
         * Required: false
         * Array: false
         */
        this.companyCd = undefined;
        /**
         * Business cell phone number
         * Required: false
         * Array: false
         */
        this.businessCell = undefined;
        /**
         * Office phone number
         * Required: false
         * Array: false
         */
        this.businessPhone = undefined;
        /**
         * Indicates Employees status with the company.
         *
         * Valid Values are (04/13/2011: Cathy Doucet synced these with PeopleSoft):
         *
         * A = Active
         * P = Leave with pay
         * L = Leave without pay
         * S = Suspended
         * D = Deceased
         * R = Retired
         * Q = Retired with pay
         * T = Terminated
         * Required: false
         * Array: false
         */
        this.employeeStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.primaryRoleId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.primaryRoleDescription = undefined;
        /**
         * Indicates if employee is fulltime or partime.
         *
         * Valid values are
         *
         * F = Full time
         * P = Part time
         * Required: false
         * Array: false
         */
        this.fullPartTimeCd = undefined;
        /**
         * Identifies the type of work the employee performs
         *
         * Format of the Job Code is CC9999, where
         * CC - Two character component prefix for which the code is valid.
         * Example: CC- Con-Way Central, CS- Con-Way Southern etc.
         * 9999 - Four digit code assigned to the Job
         * Required: false
         * Array: false
         */
        this.jobCode = undefined;
        /**
         * Indicates if employee has Commercial Drivers License; for XPO includes doubles, triples enforcements.
         * Required: false
         * Array: false
         */
        this.cdlLicInd = undefined;
        /**
         * If applicable, date the CDL license expires
         * Required: false
         * Array: false
         */
        this.cdlLicExpiryDate = undefined;
        /**
         * Indicates if employee has license for pulling high volumes or certain types of HazMat shipments
         * Required: false
         * Array: false
         */
        this.hazmLicenseInd = undefined;
        /**
         * If applicable, date the HAZM license expires
         * Required: false
         * Array: false
         */
        this.hazmLicenseExpiryDate = undefined;
        /**
         * Indicates if employee has license for pulling high volumes of liquid shipments
         * Required: false
         * Array: false
         */
        this.tankLicenseInd = undefined;
        /**
         * If applicable, date the TANK license expires
         * Required: false
         * Array: false
         */
        this.tankLicenseExpiryDate = undefined;
        /**
         * Indicates if employee has license for cross-border schedules
         * Required: false
         * Array: false
         */
        this.fastidLicenseInd = undefined;
        /**
         * If applicable, date the FASTID license expires
         * Required: false
         * Array: false
         */
        this.fastidLicenseExpiryDate = undefined;
        /**
         * Indicates if employee has license for access to ports or high-security locations
         * Required: false
         * Array: false
         */
        this.twicLicenseInd = undefined;
        /**
         * If applicable, date the TWIC license expires
         * Required: false
         * Array: false
         */
        this.twicLicenseExpiryDate = undefined;
        /**
         * OSHA requires that every forklift operator be trained and certified to operate the powered industrial truck in the workplace, and that the operator's performance be evaluated on the provisions of 1910.178(l)(3) every three years. ... That is the only operating license required by OSHA.
         * Required: false
         * Array: false
         */
        this.forkliftLicenseInd = undefined;
        /**
         * If applicable, date the FORKLIFT license expires
         * Required: false
         * Array: false
         */
        this.forkliftLicenseExpiryDate = undefined;
        /**
         * The Success Factors version of Employee ID.  Added 02/19/2021 forLNH and PND.
         * Required: false
         * Array: false
         */
        this.sfEmployeeId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of InterfaceEmployee. Contains the details at the time on an event. It also provides the previous values if an update occured
 * Details about employees that process and approve claims.
 */
class InterfaceEmployeeSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * Employee Id of the Claims employee.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class KronosPerson {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.personId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.personNumber = undefined;
    }
}
/**
 *
 */
class LoadDeck {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
    }
}
/**
 *
 */
class LoadEquipmentHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadEquipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerEquipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadEquipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadEquipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.closeDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadEquipmentWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * A snapshot of
 * the loaded handling unit captured along with the snapshot of the
 * trailer load at the time of a significant event.  This contains all
 * handling units currently loaded on a trailer at this time.
 */
class LoadHandlingUnitSnapshot {
    constructor() {
        /**
         * This is the
         * 	surrogate id for equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The
         * 	date of the last event (LOAD, UNLOAD ..)
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         * The sequence
         * 	number of the handling unit on the trailer with respect to all other
         * 	handling units loaded on the trailer.  This is mostly used for dock
         * 	automation.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The Child PRO number of the loaded handling unit.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * This parent pro number identifies which handling units are part  of
         * 	the same shipment. This is the pro number found in the BOL
         * 	document.
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * This
         * 	is the 4 character prefix of the equipment id.  (eg.  0415 or SWFT
         * 	etc)
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         * This
         * 	is the six digit equipment id suffix.  (eg.  123456 or 37 or 3737).
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         * A system
         * 	assigned sequential number to further uniquely identify each Delivery
         * 	Location on a Pickup
         * Request.
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         * Unique
         * 	ID assigned to Pickup Request by PUR component
         * Required: false
         * Array: false
         */
        this.pickupRequestInstanceId = undefined;
        /**
         * Indicates whether a hanlding unit is part of the headload or not.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * Bill
         * 	destination SIC.
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         * Indicates this load event was a mis load or not.
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LoadReleaseNbr {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadReleaseNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LoadedEquipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadEquipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * The loaded handling
 * unit of the trailer load.
 */
class LoadedHandlingUnit {
    constructor() {
        /**
         * This is the
         * 	surrogate id for equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The sequence number
         * 	of the handling unit on the trailer with respect to all other handling
         * 	units loaded on the trailer.  This is mostly used for dock
         * 	automation.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The Child
         * 	PRO number of the loaded handling unit.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * This
         * 	parent pro number identifies which handling units are part of the same
         * 	shipment. This is the pro number found in the BOL document.
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * This is the
         * 	4 character prefix of the equipment id.  (eg.  0415 or SWFT etc)
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         * This is the
         * 	six digit equipment id suffix.  (eg.  123456 or 37 or 3737).
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         * This is a
         * 	representation of the placement on a trailer.  The trailer is divided
         * 	length-wise into to and bottom, left and right, and then across into 7
         * 	sections.  This creates 28 positions in the trailer.  Each byte of this
         * 	field will represent  one of th
         * Required: false
         * Array: false
         */
        this.dckLrgMarks = undefined;
        /**
         * The device
         * 	id of the terminal where the last update to this record was
         * made.
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         * Indicates
         * 	whether a handling unit is part of the headload or not.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn1Ind = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn2Ind = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn3Ind = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn4Ind = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn5Ind = undefined;
        /**
         * Desc:
         * 	Indicates if the hanlding unit occupies this section.
         * Required: false
         * Array: false
         */
        this.trailerSectn6Ind = undefined;
        /**
         * Bill
         * 	destination SIC.
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         * Indicates this
         * 	load event was a mis load or not.
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Indicates that the child PROs are split.  Added 03/24/2021  LISG-11031
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         * The user that authorized the split or misload.  Added 03/24/2021  LISG-11031
         * Required: false
         * Array: false
         */
        this.overrideUserId = undefined;
        /**
         * Timestamp of when the spit or misload was authorized.  Added 03/24/2021  LISG-11031
         * Required: false
         * Array: false
         */
        this.overrideDateTime = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.positionOnTrailerCd = undefined;
        /**
         * The name and employee ID of the person who loaded the shipment.
         * Required: false
         * Array: false
         */
        this.loadedByEmployee = undefined;
        /**
         * The service center identification code for the dock where the shipment was loaded.
         * Required: false
         * Array: false
         */
        this.loadedAtSic = undefined;
        /**
         * The service center identification code of the dock worker that loaded the PRO.
         * Required: false
         * Array: false
         */
        this.loadByEmployeeSicCd = undefined;
        /**
         * Indicates whether the Handling Unit's parent is also loaded on the same trailer.
         * Required: false
         * Array: false
         */
        this.parentLoadedInd = undefined;
    }
}
/**
 *
 */
class LoadedShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dckLrgMarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn1Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn2Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn3Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn4Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn5Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSectn6Ind = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Indicates if the shipment loaded on a trailer is incomplete. This means not all handling units for a shipment are in the same trailer.  Added 1/03/2021 LISG-15475
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LoadedShipmentSnapshot {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Indicates if the shipment loaded on a trailer is incomplete. This means not all handling units for a shipment are in the same trailer.  Added 1/03/2021 LISG-15475
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocDoorPlanProfileRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ownerSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.createDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.weekDayNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocDoorPlanRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.displaySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cutTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.facCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.priorityNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.facSectorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doorSectorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.secondFacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thirdFacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mustMoveSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dayFreightInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocDoorRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.displaySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.areaInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.areaSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.horizontalCoordinateNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.verticalCoordinateNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sectorId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pupOnlyInd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocLoadPlanRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.firstFacSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mustClearSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.secondsFacSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thirdFacSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dayFreightInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originRailSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eslInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationPowerSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.roomSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thruSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.meetSic = undefined;
    }
}
/**
 *
 */
class LocOperationsServiceCenterProfitabilityRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cityOperationsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.autoprintPnDManifestCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundAvgLoadWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundManPowerLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundPpldLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundPpldCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prideStudyInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupConfirmInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeVolumeThresholdLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.laserPrinter = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.linePrinter = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.autoprintOutboundManifestCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.autoprintDsrLastCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadPlanInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.smart4RolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sectorBalanceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrFacInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrFacRolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrInboundInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrInboundRolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.autoprintDsrTripCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mimsOperationsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mimsRolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockOperationsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockOperationsRolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inboundArrivalInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inboundArrivalRolloutDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.avgOutboundDensity = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.avgOutboundPieceVolumeCubicFeet = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocStripDoorOverrideRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.displaySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrExcludeDoorInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadUnloadDoorInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class LocationExceptionCtl {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.terminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exceptionDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exceptionSequenceNbr = undefined;
        /**
         * Same value for CORRELATION
         * 	id is assigned to various rows from different tables that form a single busines
         * s transactions. In other words, this groups multiple rows across various tables
         * for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is a
         * ssigned to various rows from different tables that form a single database transa
         * ctions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class NotificationShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.notificationInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentProNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class OperationsLoadEquipmentHazard {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazardCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.classCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.subClassCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.unnaCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.weightInLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.limitedQuantityProductInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cntn1199GalInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poisonInhaleInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.specialInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.internationalInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazardZone = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poisonLiquidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.liquidProduct = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class OperationsTrailerRoutingSnapshot {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerActnCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.viaInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.unloadPtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadPtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.midnightsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.omtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.processedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.snapshotEventCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Placard {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.placardType = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.unnaCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
    }
}
/**
 *
 */
class PlanningEvent {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.evtInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventCreatedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planSicCd = undefined;
        /**
         * Same value for CORRELATI
         * ON id is assigned to various rows from different tables that form a single busin
         * ess transactions. In other words, this groups multiple rows across various table
         * s for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * 	assigned to various rows from different tables that form a single database tran
         * sactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class PlanningEventTrailer {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.evtInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInclFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reviewRequiredFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedLoadDestinationSic = undefined;
        /**
         * Same value for CORR
         * ELATION id is assigned to various rows from different tables that form a single
         * business transactions. In other words, this groups multiple rows across various
         * tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event
         * id is assigned to various rows from different tables that form a single database
         * 	transactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class PlanningTrailer {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.endDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nextFacSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleOriginSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCubeProfitability = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadOriginSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billCountNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frzblInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedServiceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDfrdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr1EmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr1Name = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr2EmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr2Name = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedCbePrfCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedNbrOfFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedDoorSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedSectorId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedYardCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleViaSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrBrkOrPropCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrExcludeTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrManualInclInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrOverrideEtaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrPlanAccptInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadedRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrDoorAssignmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bestDoorSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bestDoorStepsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.assignmentDoorStepsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inclHdldProsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrLoadedDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrTmanRvwInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrDoorReqInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrPupTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInclFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reviewRequiredFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.properInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerActnCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mustMoveSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedBrkInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nextOutboundSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.partialTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.partialTrailerManualOverrideInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATIO
         * N id is assigned to various rows from different tables that form a single busine
         * ss transactions. In other words, this groups multiple rows across various tables
         * 	for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * assigned to various rows from different tables that form a single database trans
         * actions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.thruShipment = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.xdockShipment = undefined;
    }
}
/**
 *
 */
class PlanningTrailerHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.effectiveDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.expiryDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.endDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCubeProfitability = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nextFacSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleOriginSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadOriginSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billCountNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frzblInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedServiceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDfrdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr1EmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr1Name = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr2EmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsr2Name = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedCbePrfCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedNbrOfFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedDoorSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedSectorId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedYardCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleViaSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrBrkOrPropCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrExcludeTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrManualInclInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrOverrideEtaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrPlanAccptInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrDoorAssignmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadedRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bestDoorSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bestDoorStepsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.assignmentDoorStepsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inclHdldProsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrLoadedDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrTmanRvwInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrDoorReqInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ssrPupTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInclFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reviewRequiredFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.properInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerActnCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mustMoveSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceLastUpdateTransactionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceLastUpdateUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceDeleteBy = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedBrkInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nextOutboundSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.partialTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.partialTrailerManualOverrideInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         * Same value for CORRE
         * LATION id is assigned to various rows from different tables that form a single b
         * usiness transactions. In other words, this groups multiple rows across various t
         * ables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event i
         * d is assigned to various rows from different tables that form a single database
         * transactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ProMovementHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedAtSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedServiceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.misloadAuthrzUserId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventDoor = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of ProMovementHist. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class ProMovementHistSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class ProfileExcludeTrailer {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.selectionProfileId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdSuffixNbr = undefined;
        /**
         * Same value for CORRELATI
         * ON id is assigned to various rows from different tables that form a single busin
         * ess transactions. In other words, this groups multiple rows across various table
         * s for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * 	assigned to various rows from different tables that form a single database tran
         * sactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ProfileSic {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.selectionProfileId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileSicSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.arrivalCutoffTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dateOffsetNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicGroupName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicTypeCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Projection {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prjctnSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.adjustedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nextFacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.divertSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION i
         * d is assigned to various rows from different tables that form a single business
         * transactions. In other words, this groups multiple rows across various tables fo
         * r a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is ass
         * igned to various rows from different tables that form a single database transact
         * ions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class RefEquipmentIdXrefRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdMbf = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdMcms = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actDateTime = undefined;
    }
}
/**
 *
 */
class RefScacCodeRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierMcn = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierAddress = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierCity = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierState = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierCountry = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierZip = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierPhone = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierChngFld = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierAddressChngCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierAdoptionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierUserCrtdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierLastUpdateUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierLastUpdateDateTime = undefined;
    }
}
/**
 *
 */
class RefStandardCodeRo {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.codeType = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.codeValue = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shortDescription = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.longDescription = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.effectiveEndDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.effectiveStartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Route {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.categoryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.plannedDoor = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockLocationInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.terminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.liftgateCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalBillCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPalletCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalMmCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.warrantyCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryStopCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupStopCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceValidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockReleaseInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryRouteDepartTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originNodeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originNodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originNodeSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationNodeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationNodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationNodeSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedTrailerTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedNodeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedNodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedNodeSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalDeliveryWeightCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.protectRouteInd = undefined;
        /**
         * The number of RRS shipments on this
         *
         * Route.  Added 10/23/2019
         * Required: false
         * Array: false
         */
        this.rrsCount = undefined;
        /**
         * The number of Guaranteed by
         *
         * 12 shipments on this Route.  Added 10/23/2019
         * Required: false
         * Array: false
         */
        this.guaranteedBy12Count = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteEarliestDueTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteEarliestMessage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteLatestMessage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteLatestDueTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDispatchTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedClearTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockLocationName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fullTrailerId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentDockLocation = undefined;
        /**
         * Special services requested by a customer for a shipment delivery.
         * Required: false
         * Array: true
         */
        this.specialServices = undefined;
        /**
         * Indicates whether the shipment has a scheduled appointment for delivery.
         * Required: false
         * Array: false
         */
        this.appointmentStatusCd = undefined;
        /**
         * The earliest date of service.
         * Required: false
         * Array: false
         */
        this.earliestServiceDate = undefined;
        /**
         * The latest date of service.
         * Required: false
         * Array: false
         */
        this.latestServiceDate = undefined;
    }
}
/**
 * Contains handling unit
 * 	information of a Route Shipment indicated as incomplete which is on a
 * 	Route.
 */
class RouteHandlingUnit {
    constructor() {
        /**
         * Unique ID
         * 	assigned to Route.
         * Required: false
         * Array: false
         */
        this.routeInstanceId = undefined;
        /**
         * Unique
         * 	sequence number within a Route.  Together with Route Inst ID,
         * it uniquely identifies a row in the Route Shipment table.
         * Required: false
         * Array: false
         */
        this.routeShipmentSequenceNbr = undefined;
        /**
         * This is
         * 	the child PRO Number identifying the handling unit included in a route
         * 	shipment when its complete shipment indicator is N.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class RouteShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeShipmentSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.positionOnTrailer = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadedFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.operatingRouteFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.diversionLoadDestinationSicCd = undefined;
        /**
         * Same value for event id is
         * 	assigned to various rows from different tables that form a single database tran
         * sactions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates if
         * 	the route shipment in a route is incomplete. This means not all
         * 	handling units are in the same route. Route Handling Unit records are
         * 	expected in this case, to identify which handling units are part of
         * 	this route shipment.
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of RouteShipment. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class RouteShipmentSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.historyActionCd = undefined;
        /**
         * The timestamp of when this snapshot was created.
         * Required: false
         * Array: false
         */
        this.historyCreatedTimestamp = undefined;
        /**
         * Snapshot.
         * Required: false
         * Array: false
         */
        this.routeShipment = undefined;
        /**
         * Previous values. Only attributes that are different from snapshot will be populated
         * Required: false
         * Array: false
         */
        this.routeShipmentDiff = undefined;
    }
}
/**
 * Holds a snapshot of Route. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class RouteSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.historyActionCd = undefined;
        /**
         * The timestamp of when this snapshot was created.
         * Required: false
         * Array: false
         */
        this.historyCreatedTimestamp = undefined;
        /**
         * Snapshot.
         * Required: false
         * Array: false
         */
        this.route = undefined;
        /**
         * Previous values. Only attributes that are different from snapshot will be populated
         * Required: false
         * Array: false
         */
        this.routeDiff = undefined;
    }
}
/**
 *
 */
class RouteTrip {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeTripSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fromDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.toDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Same value for event id is ass
         * igned to various rows from different tables that form a single database transact
         * ions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of RouteTrip. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class RouteTripSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.historyActionCd = undefined;
        /**
         * The timestamp of when this snapshot was created.
         * Required: false
         * Array: false
         */
        this.historyCreatedTimestamp = undefined;
        /**
         * Snapshot.
         * Required: false
         * Array: false
         */
        this.routeTrip = undefined;
        /**
         * Previous values. Only attributes that are different from snapshot will be populated
         * Required: false
         * Array: false
         */
        this.routeTripDiff = undefined;
    }
}
/**
 *
 */
class Schedule {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleIdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.milg = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.displayUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.finalDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.intmdlScac = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.chargeReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.discrInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.onDfrdLegInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ScheduleHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleIdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.milg = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.displayUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.finalDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.intmdlScac = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.chargeReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.discrInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.drvrId1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.drvrId2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.onDfrdLegInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ScheduledDriver {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduleIdNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
    }
}
/**
 * Contains information about the Lane the Door is loading to and the type of lane, HSS or LTL, associated with the door plan.  Added 06/09/2020
 */
class ScoDoorPlan {
    constructor() {
        /**
         * Profile the door plan belongs to.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * Identifies the door at the SIC. 07/01/2020 Flipped from NUMBER to VARCHAR
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The sequence in which the door needs to be picked when loading to the same first load point
         * Required: false
         * Array: false
         */
        this.displaySequenceNbr = undefined;
        /**
         * Priority Number assigned to the Door Plan
         * Required: false
         * Array: false
         */
        this.priorityNbr = undefined;
        /**
         * First load point for the destination group the door is loading to.
         * Required: false
         * Array: false
         */
        this.firstLoadPointSicCode = undefined;
        /**
         * Shift the shipments will arrive at the first load point for the destination group the door is loading to
         * Required: false
         * Array: false
         */
        this.firstLoadPointShiftCd = undefined;
        /**
         * Farthest load point the destination group is loading to. This is the SIC code that is the farthest along the load leg path to destination sics.
         * Required: false
         * Array: false
         */
        this.farthestLoadPointSicCode = undefined;
        /**
         * Shift the shipments will arrive at the farthest load point for the destination group the door is loading to
         * Required: false
         * Array: false
         */
        this.farthestLoadPointShiftCd = undefined;
        /**
         * Type of lane.
         *
         * Valid Values:
         * LINEHAUL
         * EXCLUSIVE_HSS
         * SUPPLEMENTAL_HSS
         * Required: false
         * Array: false
         */
        this.laneTypeCd = undefined;
        /**
         * Sector number to which the door plan is applicable within the Freight Assembly Center (FAC)
         * Required: false
         * Array: false
         */
        this.facSectorNbr = undefined;
        /**
         * Sector number to which the door plan is applicable within the Service Center
         * Required: false
         * Array: false
         */
        this.doorSectorNbr = undefined;
        /**
         * Identifies Day Freight - freight that moves through a day point.
         *
         * Y/N
         * Required: false
         * Array: false
         */
        this.dayFreightInd = undefined;
        /**
         * HH24:MM - Latest time when the trailer at this door sould leave. Hour should be from 0 to 23 and MM should be from 00 to 59
         * Required: false
         * Array: false
         */
        this.cutOffTime = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is assigned to various rows from different tables that form a single database transactions.
         * Multiple database transactions could make up one business transaction, which is indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single database transaction.
         * Typically this is used to publish a message to a queue for consumption or a workflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates the source that matched the door plan lane. Eg. Static.  Added 04/20/2021  LISG-11671
         * Required: false
         * Array: false
         */
        this.matchSourceCd = undefined;
        /**
         * Indicates how far the door plan close to Sic Code is according to Freight flow. A value of 1 means First FAC, Value 2 means 2nd FAC and so on. For Pure Destination doors the value will be 99.  Added 06/10/2021  LISG-12810
         * Required: false
         * Array: false
         */
        this.loadLevelNbr = undefined;
        /**
         * Load Leg Destination Sic Code of the 1st load leg of the freight flow path.  Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.firstLoadLegDestinationSicCd = undefined;
        /**
         * Load Leg Destination Shift Code of the 1st load leg of the freight flow path.  Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.firstLoadLegDestinationShiftCd = undefined;
        /**
         * Average Weight of all the shipments that go through this lane.  Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.avgLaneWeightLbs = undefined;
        /**
         * Average Volume in Cubic Feet of all the shipments that go through this lane.   Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.avgLaneVolumeCubicFeet = undefined;
        /**
         * Average Pup Count based on the threshold that go through this lane.   Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.avgPupCount = undefined;
        /**
         * Average Shipment count that goes through this lane.  Added 08/02/2021  LISG-14098
         * Required: false
         * Array: false
         */
        this.avgShipmentCount = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates whether the current door plan matches the door plan in the static profile.
         * Required: false
         * Array: false
         */
        this.staticMatchInd = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.scoDoorPlanDestination = undefined;
    }
}
/**
 * Contains information about all the Destination locations that the Door is loading to. Door plan can also be setup for Consignee Customer Number.  Added 06/09/2020
 */
class ScoDoorPlanDestination {
    constructor() {
        /**
         * Profile the door plan belongs to.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * Identifies the door at the SIC.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * Sequential number to uniquely identify the record
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Final destination of shipments that will be loaded to this door
         * Required: false
         * Array: false
         */
        this.destinationSicCode = undefined;
        /**
         * Destination Postal Code of shipments that will be loaded to this door
         * Required: false
         * Array: false
         */
        this.destinationPostalCd = undefined;
        /**
         * Consignee whose shipments will be loaded to this door - from legacy CIS system.
         * Required: false
         * Array: false
         */
        this.legacyCisCustomerNbr = undefined;
        /**
         * Consignee whose shipments will be loaded to this door - from NCIS system.
         * Required: false
         * Array: false
         */
        this.customerLocationFuncId = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is assigned to various rows from different tables that form a single database transactions.
         * Multiple database transactions could make up one business transaction, which is indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single database transaction.
         * Typically this is used to publish a message to a queue for consumption or a workflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Identifies if a Destination is a Headload destination when loaded through this door.  Added 11/11/2021  LISG-15545
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Contains information of the Door loading profile. A Loading door profile is based on a SIC and Shift. The SIC Code must be a Linehaul and Active SIC and can be a zone.  Added 06/09/2020
 */
class ScoDoorPlanProfile {
    constructor() {
        /**
         * System Generated Unique Identifier.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * SIC code of the service center to which the door plan profile belongs
         * Required: false
         * Array: false
         */
        this.sicCode = undefined;
        /**
         * Shift Code for which the door plan profile is created.
         *
         * Valid Values:
         * OUTBOUND
         * INBOUND
         * NIGHT_FAC
         * DAY_FAC
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * Unique Name assigned to the Profile
         * Required: false
         * Array: false
         */
        this.profileName = undefined;
        /**
         * Default value  is DEFAULT.
         *
         * Valid values:
         * CURRENT
         * DEFAULT
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is assigned to various rows from different tables that form a single database transactions.
         * Multiple database transactions could make up one business transaction, which is indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single database transaction.
         * Typically this is used to publish a message to a queue for consumption or a workflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Captures the day of the week number for the Door Plan profile.  Added 11/03/2020  LISG-8444
         *
         * Valid Values:
         * SUNDAY
         * MONDAY
         * TUESDAY
         * WEDNESDAY
         * THURSDAY
         * FRIDAY
         * SATURDAY
         * Required: false
         * Array: false
         */
        this.dayOfWeekCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.scoDoorPlan = undefined;
    }
}
/**
 *
 */
class ScoEvent {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.evtInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.subTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stopInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupReqInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sendToDeviceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.event = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serverAddress = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.callDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.callSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hookInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrUserId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.applicationCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeActivitySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.activitySpfcNodeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.activitySpfcNodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.activitySpfcName = undefined;
        /**
         * Unique ID assigned to Route.
         *
         * Added 7/2/2019
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Same value for CORRELATION id is
         * assigned to various rows from different tables that form a single business trans
         * actions. In other words, this groups multiple rows across various tables for a s
         * ingle business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of ScoEvent. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class ScoEventSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.evtInstId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class SelectionProfile {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.selectionProfileId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.createDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteStartTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteEndTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inboundDestinationSicInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundArrivalTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundOverheadTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundTrapTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundEnrouteTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.outboundCloseTrailerInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.weekDayNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.owningSicCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.profileSic = undefined;
    }
}
/**
 *
 */
class ShmEventLogRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.subTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.programId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reportingSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.occurredDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveControlCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalChargeAmount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.occurredSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originTerminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.enrouteInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipperCustomerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeCustomerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bil21StCustomerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bil22NdCustomerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipperCountryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeCountryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.adminInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.chargeToCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thirdPartyInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.adminStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billClassCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billTo2NdRelationshipCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billTo1StRelationshipCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ediSenderId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ediSenderShipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.debtorCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bolInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ShmHandlingUnitMovementRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementReportingSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveControlCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exceptionTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.rfsdReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.undlvdReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmgdCategoryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.remarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bypassScanInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bypassScanReason = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scanDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.splitAuthorizeBy = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.splitAuthorizeDateTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ShmHandlingUnitRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentTrailerInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentDockLocation = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastMovementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.handlingMovementCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dimensionTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reweighInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poorlyPackagedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.moverSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.moverProNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ShmMovementRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementReportingSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.rshpCreditInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveControlCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.qualifierReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerLocationArrivalDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ShmShipmentRw {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billClassCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.chargeToCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originTerminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalChargeAmount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cashCollectInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.purgeBlockInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastMoveReportingSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastMovementDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryInformationRqdCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliverySignatureName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliverySignatureDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.standardTransitDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualTransitDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.transitMovementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.notificationCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedTransitDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.calculatedServiceDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.calculatedServiceDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.calculatedMovementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.diffCalculatedDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.diffTransitDays = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentServiceStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceCalculatedStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceStartDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipperLoadTrailerCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.consigneeUnloadTrailerCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionReason = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.appointmentRequiredInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationNotifyInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.reweighWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poorlyPackagedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.handlingUnitSplitInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.handlingUnitPartialInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.moverSuffix = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Contains handling unit
 * 	information about shipment indicated as incomplete that is loaded on a
 * 	trailer when it was added to a cross dock plan as a thru trailer.
 */
class ThruHandlingUnit {
    constructor() {
        /**
         * Unique ID
         * 	assigned to the plan. Is random generated
         * Required: false
         * Array: false
         */
        this.planInstanceId = undefined;
        /**
         * Unique ID of
         * 	trailer. ID as assigned in EQP component
         * Required: false
         * Array: false
         */
        this.equipmentInstanceId = undefined;
        /**
         * Instance Id of
         * 	the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstanceId = undefined;
        /**
         * This is
         * 	the child PRO Number identifying the handling unit included in a thru
         * 	shipment when its complete shipment indicator is N.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * Total cube
         * 	percentage of all the freight being moved as a unit.
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class ThruShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prjctdWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prjctdCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prjctdServiceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.prjctdDestinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATIO
         * N id is assigned to various rows from different tables that form a single busine
         * ss transactions. In other words, this groups multiple rows across various tables
         * 	for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is
         * assigned to various rows from different tables that form a single database trans
         * actions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates if
         * 	the shipment in a thru trailer is incomplete. This means not all
         * 	handling units for a shipment is in the same thru trailer. Thru
         * 	Handling Unit records are expected in this case, to identify which
         * 	handling units are part of this thru shipment.
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TrailerDsrAssignment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrAssignmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstanceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.activeInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.startDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.endDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TrailerInspection {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerEquipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inspectedDateLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inspectedTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inspectedBy = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.operationCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.inspNotApplicableInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerStrapsCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.maintTtRequiredInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TrailerLoad {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.evntDoor = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvnt = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvntDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLengthFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDestination = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedWeight = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCbePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCbeProfitability = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedReleaseNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xclvInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sealNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.closeDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frzblInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.placardInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.garntServiceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cityRoute = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.brkOrProprCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadedRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadLocation = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dfrdShipmentInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDfrdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sealMatchCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.authrzUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.foodShipmentCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poisonShipmentCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.evntDoorSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.evntShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exctdUnloadShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.closShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInspReqdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exctdUnloadDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedLoadedDestination = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routingRequiredInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideRvwRequiredInd = undefined;
        /**
         * Indicates whether the trailer/straight truck has Liftgate installed or not.  Added 03/18/2021 LISG-10718
         *
         * Values: Y/N
         * Required: false
         * Array: false
         */
        this.liftgateInd = undefined;
        /**
         * Identifies if pro needs RRS=Rapid Remote Service.   Added 03/18/2021 LISG-7488
         * Required: false
         * Array: false
         */
        this.rrsInd = undefined;
        /**
         * Identifies if pro needs G12=Guaranteed by Noon Service.  Added 03/18/2021  LISG-7488
         * Required: false
         * Array: false
         */
        this.g12Ind = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.trailerInspection = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.trailerRouting = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadDetail = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.loadedEquipment = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.loadedShipment = undefined;
    }
}
/**
 *
 */
class TrailerLoadHist {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEvent = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventDoor = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLengthFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDestinationSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedWeight = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCbePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedCbeProfitability = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedReleaseNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xclvInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.billCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sealNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.closeDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.frzblInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.placardInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedServiceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cityRoute = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.brkOrProprCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerLoadedRemarks = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadLocation = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.customerMadSuffix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUpdateDeviceId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.updatedTimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dfrdShipmentInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadedDfrdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sealMatchCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.authrzUserid = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.foodShipmentCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.poisonShipmentCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventDoorSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exctdUnloadShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.closShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerInspReqdInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedLoadedDestination = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.exctdUnloadDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.routingRequiredInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideRvwRequiredInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TrailerRouting {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.viaInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.unloadPtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadPtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.midnightsNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.omtInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.processedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TrailerSpecification {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerSubTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.effectiveDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.expiryDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.descr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fullCapacityPercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.fullCapacityVolume = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Length of trailer, in feet.  Added 05/07/2020 for PND Optimizer
         * Required: false
         * Array: false
         */
        this.trailerLengthNbr = undefined;
        /**
         * PND Weight capacity, in pounds, of the trailer.  Added 05/07/2020 for PND Optimizer
         * Required: false
         * Array: false
         */
        this.pndWeightCapacityLbs = undefined;
        /**
         * PND Pallet capacity (number of pallets that can fit on the equipment) of the trailer.  Added 05/07/2020 for PND Optimizer
         * Required: false
         * Array: false
         */
        this.pndPalletCapacityNbr = undefined;
        /**
         * PND HU (Handling Unit) capacity of the trailer.  Added 05/07/2020 for PND Optimizer
         * Required: false
         * Array: false
         */
        this.pndHandlingUnitCapacityNbr = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class Trip {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripDsrName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualDepartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualReturnDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.categoryCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDepartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedReturnDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.helperEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lunchTakenTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopAreaId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.odometerEndNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.odometerStartNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overtimeStartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripRmrkInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.terminalSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cashDueCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.timeDateCriticalCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryStopCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryCompletedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.earlyCutoffCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freezeCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.liftgateCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupStopCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupCompletedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stopCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stopCompletedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentRtndCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headloadCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.warrantyCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripCompletedDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceValidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mobileDeviceStartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.mobileDeviceEndDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedEmptyDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.incompletePickupWeightCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.releaseStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.doNotAutoDisplayFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopArrivalDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cmsPullId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hssBookingNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cmsOutForBidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cmsOfferId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.thirdPartyDriverHazmatCertFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastStopNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUsedNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.directionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.departTimeOfDayCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.arrivalTimeOfDayCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.runTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.createSourceCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.optimizerSourceCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.optimizerRunId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.optimizerTripId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastResequenceDateTime = undefined;
        /**
         * The number of RRS shipments on this
         *
         * Trip.  Added 10/23/2019
         * Required: false
         * Array: false
         */
        this.rrsCount = undefined;
        /**
         * The number of Guaranteed by 12
         *
         * shipments on this Trip.  Added 10/23/2019
         * Required: false
         * Array: false
         */
        this.guaranteedBy12Count = undefined;
        /**
         * Identifies the partner carrier for this cartage trip.  Added 03/24/2021 LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsCarrierId = undefined;
        /**
         * Amount we expect to be charged by the partner carrier for this trip.  Added 03/24/2021 LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsEstimatedChargeAmount = undefined;
        /**
         * Actual amount we were invoiced by the partner carrier for this trip.  Added 03/24/2021  LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsInvoicedChargeAmount = undefined;
        /**
         * Identifying number of the Partner carrier for this trip.  Added 03/24/2021 LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsPartnerTripId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * The total number of motor moves associated with the trip.
         * Required: false
         * Array: false
         */
        this.totalMotorMoves = undefined;
        /**
         * The identifier of the first Trip Node that was a Stop on this Trip.
         * Required: false
         * Array: false
         */
        this.firstStopNodeSeqNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dispatchGroupId = undefined;
    }
}
/**
 *
 */
class TripDriver {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overtimeStartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.domicileSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class TripEquipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripEquipmentSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lengthUOMUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lengthUOMFeetNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.asgmntStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerEmptyFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.suggestedTrailerTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originalMoveToSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Identifies the type of trip; denormed from SCO_TRIP.  At present, it is needed solely for Linehaul.  Added 04/15/2020
         *
         * VALID VALUES
         * L=Linehaul
         * (null)
         * Required: false
         * Array: false
         */
        this.tripTypeCd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentIdFullName = undefined;
    }
}
/**
 *
 */
class TripNode {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nodeInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stopSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sequenceInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedArriveDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDepartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedArriveDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDepartDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideOperationsInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideInstructionInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDeliveryFromTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDeliveryToTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planDistanceFromPrevNode = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.odometerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentRtndCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.nodeSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.delayReasonCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.estimatedDelayMinimum = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.latitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.longitudeNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lastUsedActivitySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.stopBypassedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryWindowCalculatedOffsetMinutes = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryActivityCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupActivityCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentActivityCount = undefined;
        /**
         * The planned distance from the previous node captured with up to 2 places decimal.  Added 10/08/2019
         * Required: false
         * Array: false
         */
        this.plannedDistanceFromNodeMl = undefined;
        /**
         * Identifies the type of trip; denormed from SCO_TRIP.  At present, it is needed solely for Linehaul.  Added 04/15/2020
         *
         * VALID VALUES
         * L=Linehaul
         * (null)
         * Required: false
         * Array: false
         */
        this.tripTypeCd = undefined;
        /**
         * Amount we expect to be charged by the partner carrier for this stop.  Added 03/24/2021 LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsEstimatedChargeAmount = undefined;
        /**
         * Actual amount we were invoiced by the partner carrier for this stop.  Added 03/24/2021  LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsInvoicedChargeAmount = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates if a customer picks up or drops off freight at the dock.
         * Required: false
         * Array: false
         */
        this.dockProfileInd = undefined;
        /**
         * Indicates that a customer has a forklift.
         * Required: false
         * Array: false
         */
        this.forkliftInd = undefined;
        /**
         * The type of customer location; i.e. business/commercial, distribution center, construction site, etc.
         * Required: false
         * Array: false
         */
        this.customerLocationType = undefined;
        /**
         * The employee ID of the DSR.
         * Required: false
         * Array: false
         */
        this.driverEmployeeId = undefined;
    }
}
/**
 *
 */
class TripNodeActivity {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeActivitySequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.activityCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.entityTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.parentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freightStatusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryInformationRqdCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualActivityDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.actualActivityDateTimeLocal = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.swingEquipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.swingTripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cashDueInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.earlyCutoffCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freezeCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headloadCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.liftgateInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.timeDateCriticalInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.appointmentInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.foodInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalBillCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalPalletCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalWeightCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalMmCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Same value for CORRE
         * LATION id is assigned to various rows from different tables that form a single b
         * usiness transactions. In other words, this groups multiple rows across various t
         * ables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Defines the specific
         *
         * type of service provided for a shipment.    Added 10/23/2019
         *
         *
         * Values:
         * 1 - Normal LTL
         * 2 - Con-Way Deferred Express (Deprecated)
         * 3 - LTL Expedite Service
         * 4 - Guaranteed by 12
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         * Amount we expect to be charged by the partner carrier for delivery of this shipment.  Added 03/24/2021 LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsEstimatedChargeAmount = undefined;
        /**
         * Actual amount we were invoiced by the partner carrier for delivery of this shipment.  Added 03/24/2021  LISG-10965
         * Required: false
         * Array: false
         */
        this.cmsInvoicedChargeAmount = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Indicates that a shipment has bulk liquid.
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
    }
}
/**
 * Holds a snapshot of TripNodeActivity. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class TripNodeActivitySnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.tripNodeActivitySequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Holds a snapshot of TripNode. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class TripNodeSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.historyActionCd = undefined;
        /**
         * The timestamp of when this snapshot was created.
         * Required: false
         * Array: false
         */
        this.historyCreatedTimestamp = undefined;
        /**
         * Snapshot.
         * Required: false
         * Array: false
         */
        this.tripNode = undefined;
        /**
         * Previous values. Only attributes that are different from snapshot will be populated
         * Required: false
         * Array: false
         */
        this.tripNodeDiff = undefined;
    }
}
/**
 * Holds a snapshot of Trip. Contains the details at the time on an event. It also provides the previous values if an update occured
 * null
 */
class TripSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.historyActionCd = undefined;
        /**
         * The timestamp of when this snapshot was created.
         * Required: false
         * Array: false
         */
        this.historyCreatedTimestamp = undefined;
        /**
         * Snapshot.
         * Required: false
         * Array: false
         */
        this.trip = undefined;
        /**
         * Previous values. Only attributes that are different from snapshot will be populated
         * Required: false
         * Array: false
         */
        this.tripDiff = undefined;
    }
}
/**
 * Contains handling unit
 * 	information related to Shipments in an outbound plan that are indicated
 * 	as incomplete. This should never be the case of pickup requests.
 */
class XdockHandlingUnit {
    constructor() {
        /**
         * Unique ID
         * assigned to the plan. Is random generated
         * Required: false
         * Array: false
         */
        this.planInstanceId = undefined;
        /**
         * Unique
         * sequence number assigned to the shipment within in a plan.
         * Required: false
         * Array: false
         */
        this.xdockShipmentSequenceNbr = undefined;
        /**
         * This is
         * 	the child PRO Number identifying a handling unit of a shipment.
         * Required: false
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class XdockPlan {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.driverCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.autoInclReshipFlag = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION i
         * d is assigned to various rows from different tables that form a single business
         * transactions. In other words, this groups multiple rows across various tables fo
         * r a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is ass
         * igned to various rows from different tables that form a single database transact
         * ions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.xdockShipment = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.planningTrailer = undefined;
    }
}
/**
 *
 */
class XdockShipment {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockPlanInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockShipmentSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.xdockProgressCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.freezableInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.planInclInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.shipmentTypeCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.totalMmCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ttlPiecesCount = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.ttlWeightLbs = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.divertSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.overrideDoor = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dvrsnNextMoveSic = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dvrsnLoadToShiftCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dvrsnHssCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dvrsnDayInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.runId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dvrsnInstructionSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hssScheduledDepartDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.hssLoadedGroupSequenceNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.detailCapxtimestamp = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.replicationLastUpdateDateTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.dmlDateTime = undefined;
        /**
         * Same value for CORRELATION
         * id is assigned to various rows from different tables that form a single business
         * 	transactions. In other words, this groups multiple rows across various tables f
         * or a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Same value for event id is as
         * signed to various rows from different tables that form a single database transac
         * tions.
         * Multiple database transactions could make up one business transaction, which is
         * 	indicated by correlation_id
         * In other words, this groups multiple rows across various tables for a single da
         * tabase transaction.
         * Typically this is used to publish a message to a queue for consumption or a wor
         * kflow.
         * Required: false
         * Array: false
         */
        this.scoEventId = undefined;
        /**
         * Indicates if
         * 	the xdock shipment is partial. This means not all handling units are in
         * 	the same xdock plan. XDock Handling Unit records are expected in this
         * 	case, to identify which handling units are part of this xdock
         * 	shipment.
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class EventWait {
    constructor() {
        /**
         * Unique identifier of records in this table. Values populated from sequence
         * Required: false
         * Array: false
         */
        this.waitInstanceId = undefined;
        /**
         * Id of the ensemble that is being put on lock wait
         * Required: false
         * Array: false
         */
        this.ensembleInstanceId = undefined;
        /**
         * Name of the queue that was the source of this ensemble message
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * The timestamp of when this ensemble was first put on lock wait
         * Required: false
         * Array: false
         */
        this.waitStartTmst = undefined;
        /**
         * The number of times this ensemble was put on lock wait
         * Required: false
         * Array: false
         */
        this.waitCount = undefined;
        /**
         * The duration of wait in milliseconds
         * Required: false
         * Array: false
         */
        this.waitTime = undefined;
        /**
         * The maximum wait time in milliseconds before the lock will be overridden
         * Required: false
         * Array: false
         */
        this.maxWaitTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class RetriggerEvent {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventRetriggerId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.regionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceTableName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Details of a symphony message
 */
class SymphonyMessage {
    constructor() {
        /**
         * ID of the message
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Timestamp of when the message was enqueued
         * Required: false
         * Array: false
         */
        this.enqueueTmst = undefined;
        /**
         * Number of time the message was retried
         * Required: false
         * Array: false
         */
        this.retryCount = undefined;
        /**
         * Message payload
         * Required: false
         * Array: false
         */
        this.payload = undefined;
    }
}
/**
 * Details about a message queue. E.g. Oracle Advanced Queue
 */
class SymphonyQueue {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Maximum number of retries
         * Required: false
         * Array: false
         */
        this.maxRetries = undefined;
        /**
         * Delay for retries
         * Required: false
         * Array: false
         */
        this.retryDelay = undefined;
        /**
         * Indicates if enqueue is enabled
         * Required: false
         * Array: false
         */
        this.enqueueEnabled = undefined;
        /**
         * Indicates if dequeue is enabled
         * Required: false
         * Array: false
         */
        this.dequeueEnabled = undefined;
        /**
         * The retention time
         * Required: false
         * Array: false
         */
        this.retention = undefined;
    }
}
/**
 * Captures transaction events. API writes one record per transaction.  Added to EVT seed model  06/26/2020
 */
class TransactionEvent {
    constructor() {
        /**
         * PK. Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         * Required: false
         * Array: false
         */
        this.transactionType = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Number of seconds to hold event before publishing.  Added 09/21/2020  LISG-7498
         * Required: false
         * Array: false
         */
        this.eventReleaseDelaySeconds = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.transactionDetails = undefined;
    }
}
/**
 * Stores the snapshot of all the tables that were updated as part of the transaction. The snapshot is a json representation of all columns that were changed. The snapshot will be created by insert/update/delete triggers on the source table.   Added to EVT seed model  06/26/2020
 */
class TransactionEventDetail {
    constructor() {
        /**
         * PK. Unique id for the snapshot record. Generated by Sequence.
         * Required: false
         * Array: false
         */
        this.detailId = undefined;
        /**
         * Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         * Name of the table for which the snapshot is stored
         * Required: false
         * Array: false
         */
        this.tableName = undefined;
        /**
         * Json string containing the before and after values for all the columns that were changed by the transaction.
         * Required: false
         * Array: false
         */
        this.snapshot = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         * Required: false
         * Array: false
         */
        this.transactionType = undefined;
    }
}
/**
 * The payload type for the asynchronous report printing channel.
 */
class AsynchReportPrintingPayload {
    constructor() {
        /**
         * The type of matrix report to print. This applies to DSR Check-in, Outbound Break Manifest, and PD Manifest.
         * Required: false
         * Array: false
         */
        this.matrixReportType = undefined;
        /**
         * The identifier of the printer to which the report to print will be routed. If this is not supplied, then it defaults to VOID.
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
        /**
         * The service center identification code for the location from where the request to print originated.
         * Required: false
         * Array: false
         */
        this.requestingSicCd = undefined;
        /**
         * The unique identifier of the routes to print. This applies to PD Manifest.
         * Required: false
         * Array: true
         */
        this.routeInstId = undefined;
        /**
         * The concatenation of the equipment prefix-suffix. This applies to Closed Load Manifest (Linehaul).
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The unique identifier of the trip to print. This applies to DSR Check-in and Outbound Break Manifest reports.
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * The identifier of the user that submitted the request to print a report.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Basic details that are always provided to the end consumer. Loose piece count, motor move count, cube, weight, headLoadInd, originSicCd, loadDateTIme loadedSequenceNumber are always relevant for load planning.
 */
class BasicUnit {
    constructor() {
        /**
         * The business identifier for a shipment, handling unit, or pickup request.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The number of loose pieces represented by the PRO number in the set.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * The number of motor moves represented by the PRO number in the set.
         * Required: false
         * Array: false
         */
        this.motorMovesCount = undefined;
        /**
         * The amount of the cube percentage that is occupied by the PRO number.
         * Required: false
         * Array: false
         */
        this.cube = undefined;
        /**
         * The amount of weight in pounds occupied by the PRO number.
         * Required: false
         * Array: false
         */
        this.weightLbs = undefined;
        /**
         * Indicates whether the PRO number is loaded in the front of the trailer.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * The identification code for the service center from which the PRO number originated.
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The date and time when the PRO number was loaded onto the trailer.
         * Required: false
         * Array: false
         */
        this.loadDateTime = undefined;
        /**
         * The order in which the PRO number is loaded onto the trailer.
         * Required: false
         * Array: false
         */
        this.loadedSequenceNbr = undefined;
        /**
         * The identification code for the service center destination.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * The natural key identifier for a shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
    }
}
/**
 * Information about the trailer to break
 */
class BreakTrailer {
    constructor() {
        /**
         * The door number on the dock to which the trailer is assigned.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The door number that is assigned from the StepSaver process.
         * Required: false
         * Array: false
         */
        this.stepSaverDoorNbr = undefined;
        /**
         * The door sector number as assigned by the StepSaver process.
         * Required: false
         * Array: false
         */
        this.stepSaverSectorNbr = undefined;
        /**
         * Information about the trailer at the dock door.
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
    }
}
/**
 * This describes the owner of the Shipment, Handling Unit, or Pickup Request.
 */
class Consignee {
    constructor() {
        /**
         * The first part of the consignee's name.
         * Required: false
         * Array: false
         */
        this.name1 = undefined;
        /**
         * The second part of the consignee's name.
         * Required: false
         * Array: false
         */
        this.name2 = undefined;
        /**
         * The address provided by the consignee.
         * Required: false
         * Array: false
         */
        this.address = undefined;
        /**
         * The city for the consignee's address.
         * Required: false
         * Array: false
         */
        this.city = undefined;
        /**
         * The state code for the consignee's address.
         * Required: false
         * Array: false
         */
        this.stateCd = undefined;
        /**
         * The country code for the consignee's address.
         * Required: false
         * Array: false
         */
        this.countryCd = undefined;
        /**
         * The six digit zip code for the consignee's address.
         * Required: false
         * Array: false
         */
        this.zip6 = undefined;
        /**
         * The four digit zip code for the consignee's address. This attribute will be missing in some cases.
         * Required: false
         * Array: false
         */
        this.zip4 = undefined;
    }
}
/**
 * The standard trailer attributes are represented by trailer number, current SIC code, equipment status, trailer status, load destination, loaded weight, loaded cube, loaded motor moves, loaded shipment count, and load remarks. Additional attributes are added for cross dock planning purposes, which consist of headloadInd, specialServiceInd, reshipInd, etaDateTime, consignee, and route plan for the trailer.
 */
class CrossDockTrailer {
    constructor() {
        /**
         * Indicates whether the trailer is carrying a head load in the front of the trailer.
         * Required: false
         * Array: false
         */
        this.containsHeadLoadInd = undefined;
        /**
         * Indicates whether a shipment onboard the trailer is associated with a Route.
         * Required: false
         * Array: false
         */
        this.containsRouteInd = undefined;
        /**
         * Indicates whether the trailer is a reship trailer.
         * Required: false
         * Array: false
         */
        this.reshipInd = undefined;
        /**
         * The estimated date and time of arrival based on the linehaul schedule.
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         * The identification code for the service center in which the trailer is currently present.
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         * The equipment status code for the trailer being represented.
         * Required: false
         * Array: false
         */
        this.equipmentStatusCd = undefined;
        /**
         * The trailer status code in for the trailer being represented.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The concatenation of the trailer prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The identification code for the service center for which the trailer is destined.
         * Required: false
         * Array: false
         */
        this.loadDestinationCd = undefined;
        /**
         * The amount of loaded weight carried by the trailer in pounds.
         * Required: false
         * Array: false
         */
        this.weightLbs = undefined;
        /**
         * The amount of loaded cube percentage carried by the trailer.
         * Required: false
         * Array: false
         */
        this.cube = undefined;
        /**
         * The number of motor moves that are carried by the trailer.
         * Required: false
         * Array: false
         */
        this.motorMovesCount = undefined;
        /**
         * The number of shipments that are carried by the trailer.
         * Required: false
         * Array: false
         */
        this.billCount = undefined;
        /**
         * The distinct set of shipment consignees that are carried by the trailer.
         * Required: false
         * Array: true
         */
        this.distinctConsignees = undefined;
        /**
         * The load remarks for the trailer load that are carried by the trailer.
         * Required: false
         * Array: false
         */
        this.loadRemarks = undefined;
        /**
         * The codes associated with the distinct set of special services carried by the trailer.
         * Required: false
         * Array: true
         */
        this.specialServices = undefined;
        /**
         * The earliest delivery time based on all of the loaded shipments onboard the trailer.
         * Required: false
         * Array: false
         */
        this.earliestShipmentDeliveryTime = undefined;
        /**
         * Indicates whether the trailer is in the route plan.
         * Required: false
         * Array: false
         */
        this.inRoutePlanInd = undefined;
        /**
         * The status of the schedule.
         * Required: false
         * Array: false
         */
        this.scheduleStatus = undefined;
    }
}
/**
 * Door Assignment based on CURRENT DoorPlanProfile
 */
class CurrentPlanDoorAssignment {
    constructor() {
        /**
         * Identifies the door at the SIC.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * Final destination of shipments that will be loaded to this door
         * Required: false
         * Array: false
         */
        this.destinationSicCode = undefined;
        /**
         * First load point for the destination group the door is loading to.
         * Required: false
         * Array: false
         */
        this.firstLoadPointSicCode = undefined;
        /**
         * Shift the shipments will arrive at the first load point for the destination group the door is loading to
         * Required: false
         * Array: false
         */
        this.firstLoadPointShiftCd = undefined;
        /**
         * Farthest load point the destination group is loading to. This is the SIC code that is the farthest along the load leg path to destination sics.
         * Required: false
         * Array: false
         */
        this.farthestLoadPointSicCode = undefined;
        /**
         * Shift the shipments will arrive at the farthest load point for the destination group the door is loading to
         * Required: false
         * Array: false
         */
        this.farthestLoadPointShiftCd = undefined;
        /**
         * The trailer status.  E.g. Unloading, Loading, Trap, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
        /**
         * The equipment ID prefix-suffix for the trailer. E.g. 313-3760.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * Unique identifier of the Trailer
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The total count of shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentCount = undefined;
        /**
         * The total weight of the shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentWeight = undefined;
    }
}
/**
 * Information about the Customer Profile
 */
class CustomerProfile {
    constructor() {
        /**
         * The destination zip code in the profile.
         * Required: false
         * Array: false
         */
        this.destZip = undefined;
        /**
         * The Cubic Feet Profile for the customer.
         * Required: false
         * Array: false
         */
        this.profileType = undefined;
    }
}
/**
 * The scheduled delivery time for a Shipment. Time is represented on a standard delivery time or time date critical delivery.
 */
class DeliveryTime {
    constructor() {
        /**
         * The date range in which the delivery window opens and closes.
         * Required: false
         * Array: false
         */
        this.dateRange = undefined;
        /**
         * The code associated with the delivery date type for a shipment. It can be a standard delivery or time date critical.
         * Required: false
         * Array: false
         */
        this.deliveryDateTypeCd = undefined;
        /**
         * The time range in which the delivery window opens and closes.
         * Required: false
         * Array: false
         */
        this.timeRange = undefined;
    }
}
/**
 * Information about a dock door.
 */
class DockDoor {
    constructor() {
        /**
         * The location of the door in the dock.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
        /**
         * The equipment ID prefix-suffix for the trailer. E.g. 313-3760.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The current status of the trailer at the door location.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The unique identifier of the Cross Dock Plan for a SIC and shift.
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         * The count of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsCount = undefined;
        /**
         * The total cube of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsCube = undefined;
        /**
         * The total weight of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsWeight = undefined;
        /**
         * The total count of headload shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingHeadLoadShipments = undefined;
        /**
         * The total count of shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentCount = undefined;
        /**
         * The total cube of all the shipments loaded on trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentCube = undefined;
        /**
         * The total weight of the shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentWeight = undefined;
        /**
         * The count of the hazardous shipments that are loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.hazmatShipmentCount = undefined;
        /**
         * The current status of the trailer at the door.
         * Required: false
         * Array: false
         */
        this.doorStatus = undefined;
        /**
         * The destination SIC code of the trailer.
         * Required: false
         * Array: false
         */
        this.loadDestinationSic = undefined;
        /**
         * The trailer length, in feet, of the trailer. E.g. 28.
         * Required: false
         * Array: false
         */
        this.trailerLengthFt = undefined;
        /**
         * The count of load deck.
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         * The total count of the headload shipments that are loaded onto the trailer.
         * Required: false
         * Array: false
         */
        this.trailerHeadloadShipmentCount = undefined;
        /**
         * The total weight of the equipment that is loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedEquipmentWeightLbs = undefined;
        /**
         * The door plan associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.currentPlan = undefined;
        /**
         * The identifier of the door plan profile associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.profileInstId = undefined;
        /**
         * The current date time.
         * Required: false
         * Array: false
         */
        this.versionCheckTimestamp = undefined;
        /**
         * Delivery Route Dispatch Time.  Start time of the Route
         * Required: false
         * Array: false
         */
        this.routeDispatchTime = undefined;
        /**
         * Route Prefix - Route Suffix
         * The route name prefix is usually the name of the geographic area.  The route name suffix is usually user assigned and could be a number assigned to uniquely identify the route within a geographic area.
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         * The unique identifier assigned to the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The SIC for the service center responsible for the route.
         * Required: false
         * Array: false
         */
        this.routeSicCd = undefined;
        /**
         * The count of routes for this dock door.
         * Required: false
         * Array: false
         */
        this.routesForDoorCount = undefined;
        /**
         * The count of shipments that are on Dock
         * Required: false
         * Array: false
         */
        this.onDockShipmentCount = undefined;
        /**
         * Sector Number to which the Door belongs to
         * Required: false
         * Array: false
         */
        this.sectorNbr = undefined;
        /**
         * Priority of the loading door
         * Required: false
         * Array: false
         */
        this.doorPriority = undefined;
        /**
         * Door number at the dock
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * Set to true if there is any Hazmat shipment
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * The count of shipments with unknown location
         * Required: false
         * Array: false
         */
        this.unknownLocShipmentCount = undefined;
        /**
         * Set to true if there is any Headload shipment
         * Required: false
         * Array: false
         */
        this.headloadInd = undefined;
        /**
         * The total motor moves remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingMotorMoveCount = undefined;
        /**
         * The total count of parent PRO numbers that are partially loaded.
         * Required: false
         * Array: false
         */
        this.parentProPartialLoadedCount = undefined;
        /**
         * The total count of child PRO numbers that are within the partially loaded parent PRO numbers.
         * Required: false
         * Array: false
         */
        this.childProPartialLoadedCount = undefined;
        /**
         * The total count of parent PRO numbers that are partially remaining.
         * Required: false
         * Array: false
         */
        this.parentProPartialRemainingCount = undefined;
        /**
         * The total count of child PRO numbers that are within the partially remaining parent PRO numbers.
         * Required: false
         * Array: false
         */
        this.childProPartialRemainingCount = undefined;
    }
}
/**
 * Information about the door plan at the dock in a service center
 */
class DockDoorPlan {
    constructor() {
        /**
         * The identifier of the door at the SIC.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The priority number assigned to the Door Plan.
         * Required: false
         * Array: false
         */
        this.priorityNbr = undefined;
        /**
         * The first load point for the destination group to which the door is loading.
         * Required: false
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The farthest load point to which the destination group is loading. This is the service center identification code that is the farthest along the load leg path to the destination SICs.
         * Required: false
         * Array: false
         */
        this.closeToSicCd = undefined;
        /**
         * The latest time (HH24:MM) when the trailer at this door should leave.  The hour should be from 0 to 23 and minutes from 00 to 59.
         * Required: false
         * Array: false
         */
        this.cutOffTime = undefined;
        /**
         * The list of final destinations of shipments that will be loaded to this door.
         * Required: false
         * Array: true
         */
        this.doorPlanDestinations = undefined;
        /**
         * The FAC sector for which the door plan will be created.
         * Required: false
         * Array: false
         */
        this.facSectorNbr = undefined;
        /**
         * The identifier of the application for this request.
         * Required: false
         * Array: false
         */
        this.applicationId = undefined;
    }
}
/**
 * Information about the door plan destination at the dock in a service center.
 */
class DockDoorPlanDestination {
    constructor() {
        /**
         * The final destination of shipments that will be loaded to this door.
         * Required: false
         * Array: false
         */
        this.destinationSicCode = undefined;
        /**
         * The destination postal code of shipments that will be loaded to this door.
         * Required: false
         * Array: false
         */
        this.destinationPostalCd = undefined;
        /**
         * The consignee whose shipments will be loaded to this door - from legacy CIS system.
         * Required: false
         * Array: false
         */
        this.legacyCisCustomerNbr = undefined;
        /**
         * The consignee whose shipments will be loaded to this door - from NCIS system.
         * Required: false
         * Array: false
         */
        this.customerLocationFuncId = undefined;
    }
}
/**
 * Information about the door setup at a dock in a service center.
 */
class DockDoorSetup {
    constructor() {
        /**
         * The door plan associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.currentPlan = undefined;
        /**
         * The destination SIC of the trailer.
         * Required: false
         * Array: false
         */
        this.loadDestination = undefined;
        /**
         * The identifier of the door plan profile associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.profileInstId = undefined;
        /**
         * The equipment ID prefix-suffix for the trailer. E.g. 313-3760.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The current status of the trailer at the door location.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
        /**
         * The current date time.
         * Required: false
         * Array: false
         */
        this.versionCheckTimestamp = undefined;
    }
}
/**
 * Information about trailer that is currently assigned to a Dock Door
 */
class DockDoorTrailer {
    constructor() {
        /**
         * The location of the door in the dock.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
        /**
         * The equipment ID prefix-suffix for the trailer. E.g. 313-3760.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The current status of the trailer at the door location.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The unique identifier of the cross dock plan for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         * The count of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsCount = undefined;
        /**
         * The total cube of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsCube = undefined;
        /**
         * The total weight of the shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingShipmentsWeight = undefined;
        /**
         * The total count of headload shipments remaining to be loaded/unloaded to/from the trailer.
         * Required: false
         * Array: false
         */
        this.remainingHeadLoadShipments = undefined;
        /**
         * The total count of shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentCount = undefined;
        /**
         * The total cube of all the shipments loaded on trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentCube = undefined;
        /**
         * The total weight of the Shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedShipmentWeight = undefined;
        /**
         * The count of the hazardous shipments that are loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.hazmatShipmentCount = undefined;
        /**
         * The current status of the trailer at the door.
         * Required: false
         * Array: false
         */
        this.doorStatus = undefined;
        /**
         * The destination SIC of the trailer.
         * Required: false
         * Array: false
         */
        this.loadDestinationSic = undefined;
        /**
         * The current date time.
         * Required: false
         * Array: false
         */
        this.versionCheckTimestamp = undefined;
        /**
         * Route Prefix - Route Suffix
         * The route name prefix is usually the name of the geographic area.  The route name suffix is usually user assigned and could be a number assigned to uniquely identify the route within a geographic area.
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         * The unique identifier assigned to a route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The SIC of the service center responsible for the route.
         * Required: false
         * Array: false
         */
        this.routeSicCd = undefined;
        /**
         * The count of routes for this dock door.
         * Required: false
         * Array: false
         */
        this.routesForDoorCount = undefined;
        /**
         * The length, in feet, of the trailer. E.g. 28.
         * Required: false
         * Array: false
         */
        this.trailerLengthFt = undefined;
        /**
         * The count of load deck.
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         * The total count of the headload shipments that are loaded onto the trailer.
         * Required: false
         * Array: false
         */
        this.trailerHeadloadShipmentCount = undefined;
        /**
         * The total weight of the equipment that is loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedEquipmentWeightLbs = undefined;
        /**
         * The door plan associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.currentPlan = undefined;
        /**
         * The identifier of the door plan profile associated with the door for the SIC and shift.
         * Required: false
         * Array: false
         */
        this.profileInstId = undefined;
        /**
         * The priority of the door plan.
         * Required: false
         * Array: false
         */
        this.priorityNbr = undefined;
        /**
         * The door number at the dock.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 * Information about the Dock Worker
 */
class DockEmployee {
    constructor() {
        /**
         * The domicile Sic for the employee
         * Required: false
         * Array: false
         */
        this.deptSic = undefined;
        /**
         * Unique Identifier for the employee
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * Code identifying whether the employee is hourly or salaried.
         * Required: false
         * Array: false
         */
        this.employeeTypeCd = undefined;
        /**
         * First name of the employee
         * Required: false
         * Array: false
         */
        this.firstName = undefined;
        /**
         * Last name of the employee
         * Required: false
         * Array: false
         */
        this.lastName = undefined;
        /**
         * Middle initial of the employee
         * Required: false
         * Array: false
         */
        this.middleInitial = undefined;
        /**
         * Preferred first name of the employee
         * Required: false
         * Array: false
         */
        this.preferredFirstName = undefined;
        /**
         * The Success Factors (SF) 8 character employee ID.
         * Required: false
         * Array: false
         */
        this.sfEmployeeId = undefined;
        /**
         * Type of employment: F(Full Time) or P(Part Time)
         * Required: false
         * Array: false
         */
        this.employmentTypeCd = undefined;
        /**
         * Driver Type: valid values are LTLCD (city driver) and LTLLD (linehaul driver)
         * Required: false
         * Array: false
         */
        this.driverTypeCd = undefined;
        /**
         * If set to true, then the employee has the supervisor role.
         * Required: false
         * Array: false
         */
        this.isSupervisorInd = undefined;
    }
}
/**
 * Information about Planning Trailer that can be updated by the users.
 */
class DockPlanningTrailer {
    constructor() {
        /**
         * The uUnique identifier of the XDock Plan
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         * The plan for XDock.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The SIC for the XDock plan.
         * Required: false
         * Array: false
         */
        this.planSicCd = undefined;
        /**
         * The shift code. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * Basic equipment information.
         * Required: false
         * Array: false
         */
        this.equipment = undefined;
        /**
         * Indicates the action being taken for the trailer in the plan.
         * Valid Values:
         * BYP - Bypass
         * HLD - Hold
         * BRK - Breaker
         * Required: false
         * Array: false
         */
        this.trailerActionCd = undefined;
        /**
         * The load destination for Step Saver use.
         * Required: false
         * Array: false
         */
        this.stepSaverLoadDest = undefined;
        /**
         * Indicates if a review is required.
         * Required: false
         * Array: false
         */
        this.reviewRequiredInd = undefined;
    }
}
/**
 * Shipment information at the dock.
 */
class DockShipment {
    constructor() {
        /**
         * The number of days it actually takes to move a shipment from shipper to consignee.
         * Required: false
         * Array: false
         */
        this.actualTransitDays = undefined;
        /**
         * Indicates whether the record for the PRO is an active one or one retrieved from the archive.
         * Required: false
         * Array: false
         */
        this.archiveInd = undefined;
        /**
         * Each service center is divided into multiple geographic areas for delivery. This identifies the delivery area of destination service center in which this shipment s consignee is located.
         * Required: false
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         * Used to determine if the pro requires auditing after rating.
         * Required: false
         * Array: false
         */
        this.auditInd = undefined;
        /**
         * Identifies the type of shipment.
         * Valid Values:
         * A = Normal Movement(NORM)
         * B = Master Shipment(MSTR)
         * C = Segment of a Master shipment (MSEG)
         * D = Revenue Bill for Split segments (PTLT)
         * E = Partial Shipment Segment (PSEG)
         * G = Claims overage Reporting Bill (OREP)
         * H = Genral Claims Business Shipment (GCBZ)
         * I =  Astray Freight Segment (MOVR)
         * J = Company Business Shipment (COBZ)
         * K = Expedite
         * Required: false
         * Array: false
         */
        this.billClassCd = undefined;
        /**
         * Current status of the Shipment from billing point of view.
         * Valid Values:
         * 1 - Unbilled
         * 2 - In FBES Suspense Queue
         * 3 - Billed
         * 4 - Rated
         * 5 - Paid
         * 6 - Cancelled
         * Required: false
         * Array: false
         */
        this.billStatusCd = undefined;
        /**
         * Identifies the shipment as containing bulk liquid.  If volume is known, this applies to shipments >119 gallons.
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         * The sequence number identifying the movement (service-stopping event) for the calculation of CALC_SVC_DAYS.
         * NOTE - VALUE CAN BE ZERO FOR PARTLOT (PTLT) PROS.
         * Required: false
         * Array: false
         */
        this.calculatedMovementSequenceNbr = undefined;
        /**
         * The timestamp of a service stopping event.
         * Required: false
         * Array: false
         */
        this.calculatedServiceDateTime = undefined;
        /**
         * The number of days it takes to move a shipment from shipper until it reaches a service stopping event.
         * Required: false
         * Array: false
         */
        this.calculatedServiceDays = undefined;
        /**
         * Identifies who is responsible for charges for the Shipment - either the Shipper or the Consignee or the responsibility may be split between BOTH parties. For BOTH bills, the split for each line item will be stored along with the line item in the commodity, ac_svc or the misc_line_item table in future. Currently the total PPD and total COLLECT charges are currently stored as separate line items in the misc_line_item entity.
         * Valid Values :
         * P    -  Prepaid - shipper responsible for all charges
         * C    -  Collect - consignee responsible for all charges
         * B    -  Both - shipper and consignee responsible
         * -  Valid only for Non-Revenue bills.
         * Required: false
         * Array: false
         */
        this.chargeToCd = undefined;
        /**
         * Latest available time that freight can be picked up from a customer.
         * Required: false
         * Array: false
         */
        this.closeTime = undefined;
        /**
         * Identifies whether a consignee unloaded a trailer, and if so, where consignee took possession of trailer.
         * Values:
         * N : Consignee did not unload trailer (default)
         * D : Dock Pickup; a loaded trailer is picked up at Con-way dock by consignee to be unloaded by consignee
         * S : Spot loaded; a loaded trailer is left at the consignee site for consignee to unload
         * Required: false
         * Array: false
         */
        this.consigneeUnloadTrlrCd = undefined;
        /**
         * The method used to calculate the volume of the freight (TOT_VOL_CFT).
         * VALUES
         * ACTL - Actual dimensions captured by the driver (length x width x height)
         * DEST - Shipper profile for the shipment?s destination ZIP (average shipment volume when the shipper ships to that ZIP)
         * DFLT - Default shipper profile (average shipment volume for shipper regardless of ZIP)
         * SIC - Service center profile (average shipment volume across all shipments at that SIC)
         * SYS - System profile (average shipment volume across all shipments in LTL)
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileMthdCd = undefined;
        /**
         * If a default or destination shipper profile was used to calculate the volume of the freight, this field describes the type of shipper profile used.
         * Allowed values:
         * FTPRNT - Footprint piece profile
         * VOLSHP - Volume-shipment
         * VOLPCE - Volume-piece
         * DNSITY - Density shipment
         * HEIGHT - Height piece
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileTypeCd = undefined;
        /**
         * SIC where the Shipment currently is.
         * Required: false
         * Array: false
         */
        this.currentSicCd = undefined;
        /**
         * This identifies the default qualifying tariff for the shipment. If the rating process does not identify any other tariffs for the customer from rate aids, this is used as the rating tariff.
         * Required: false
         * Array: false
         */
        this.defaultTariffsId = undefined;
        /**
         * This code indicates that there is a requirement to capture delivery information for this shipment because of customer special requirements.  This is usually an EDI customer requirement that must be met.  The name of the person that signed for delivery and the timestamp are also captured in this record.
         * Values:
         * R - delivery info is required
         * C - delivery informaiton has been captured  and exists with this record
         * blank - No delivery information required for this shipment
         * Required: false
         * Array: false
         */
        this.deliveryInformationRqdCd = undefined;
        /**
         * Code representing results of a specific delivery activity. The values are the same as what used to be  Event that stopped service).
         * This has been denormalized from Movement for performance reasons and should always be kept in sync.
         * Valid Values :
         * A= Over Shipment
         * B=Trapped shipment/MBD1TRAP
         * C=Hold for customs/MBD1CSTM
         * D=Undelivered/MBD1UNDL
         * E=Hold for appointment/MBD1APPT
         * F=On spotted trailer/MBD1SPOT
         * G=Cartage
         * H=Attempted delivery/MBD1ATMP
         * J=All short
         * K=Partial short/MBD1PSRT
         * L=Refused delivery/MBD1RFSD
         * M=Damaged shipment/MBD1RDMG
         * N=Suspense/MBD1SUSP     - Not Used
         * O=Wait/MBD1WAIT              - Not Used
         * P=Purge Blocked/MBD2PBLK
         * R=Return Status/MBD2RTRN
         * T=Transfer/MBD2TSFR
         * Z=Final delivery/MBD1FINL
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         * This is the date and time recorded when the person named in DLVR_SIG_NM_TXT signed for the shipment.
         * Required: false
         * Array: false
         */
        this.deliverySignatureDateTime = undefined;
        /**
         * This is the name of the person that signed for the delivery of the freight.  This name is required by some customers and is passed along to them via EDI.  This name is captured if the DLVR_UNFO_RQD_CD is set.
         * Since a shipment can be delivered in parts, (part short, etc) there can be more than one signature.  This field will hold the name of the last delivery movement.  The previous signatures can be retrieved from shipment history records.
         * Required: false
         * Array: false
         */
        this.deliverySignatureNm = undefined;
        /**
         * SIC that is scheduled to deliver the Shipment.
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * Difference between CALC_SVC_DAYS and EST_TRNST_DAYS.
         * Required: false
         * Array: false
         */
        this.diffCalculatedDays = undefined;
        /**
         * Difference between ACTL_TRNST_DAYS and EST_TRNST_DAYS.
         * Required: false
         * Array: false
         */
        this.diffTransitDays = undefined;
        /**
         * The list of shipment dimension details.
         * Required: false
         * Array: true
         */
        this.dimensions = undefined;
        /**
         * The end time of the window specified by the customer for delivering the shipment.
         * Required: false
         * Array: false
         */
        this.endDeliveryTime = undefined;
        /**
         * Date that the shipment should be delivered based on standard lane days.
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * The standard number of days it should take to move a shipment from origin to destination, as defined in the OSS_SVC_STDS_A/B tables, adjusted by +1 if LATE_TENDER_IND =  Y.
         * Required: false
         * Array: false
         */
        this.estimatedTransitDays = undefined;
        /**
         * In the event a customer requires a shipment to travel from origin to destination
         * without the loading of any additional shipments on the trailer(s), the shipment is considered Exclusive Use.
         * Required: false
         * Array: false
         */
        this.exclusiveUseInd = undefined;
        /**
         * Indicates why a shipment may be exempt from meeting service standards.
         * Values:
         * blank - Not Exempt;
         * any valid exemption reason code
         * Required: false
         * Array: false
         */
        this.exemptReasonCd = undefined;
        /**
         * The number of times that a FBDS has been printed for this shipment.
         * Required: false
         * Array: false
         */
        this.fbdsPrintCount = undefined;
        /**
         * Indicates whether the shipment contains food or posion. Assumption: A shipment will never contain both.
         * Valid Values:
         * 1 - Neither
         * 2 - Food
         * 3 -  Poison
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         * Required: false
         * Array: false
         */
        this.freezableInd = undefined;
        /**
         * Generated by rating. Identifies port of entry code through which freight will enter the US from another country. This may be associated with the destination city or the customer s broker.
         * Required: false
         * Array: false
         */
        this.fromPortCd = undefined;
        /**
         * Indicates whether this is a government shipment or not.
         * Required: false
         * Array: false
         */
        this.govtBolTrafficInd = undefined;
        /**
         * Indicates that a Coupon has been used to allow the shipment to participate in the Con-Way Guaranteed Service Program for free.
         * Required: false
         * Array: false
         */
        this.guaranteedCouponInd = undefined;
        /**
         * Indicates if the shipment is under the Con-Way Guaranteed Service Program.
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         * The list of all handling units that belong to the parent PRO.
         * Required: false
         * Array: true
         */
        this.handlingUnits = undefined;
        /**
         * The list of HazMat details.
         * Required: false
         * Array: true
         */
        this.hazmatDetails = undefined;
        /**
         * Indicates whether or not a shipment includes  any commodities with hazardous materials. It is a denormalized attribute for performance puposes.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * The sequence number for the heaviest commodity.
         * Required: false
         * Array: false
         */
        this.heaviestCommoditySequenceNo = undefined;
        /**
         * Indicates whether the shipment has been inspected or not.
         * Required: false
         * Array: false
         */
        this.inspectedInd = undefined;
        /**
         * Date and time, when the last movement for this shipment  occurred. This is a denormalized attribute from the MOVEMENT entity.
         * Required: false
         * Array: false
         */
        this.lastMovementDateTime = undefined;
        /**
         * The Pro number for the last MOVR PRO billed for this shipment.
         * Required: false
         * Array: false
         */
        this.lastMoverPro = undefined;
        /**
         * SIC where the last movement event for the shipment  happened and reported.  This is a denormalized attribute from the MOVEMENT entity for performance purposes.
         * Required: false
         * Array: false
         */
        this.lastMoveRptgSicCd = undefined;
        /**
         * Indicates whether shipment could not be picked up in time (due to late tender by shipper) to make service.
         * Values: Y - Late Tender; blank or N - Not Late Tender
         * Required: false
         * Array: false
         */
        this.lateTenderCd = undefined;
        /**
         * This is the length in feet that a shipment will take up in a trailer.  This dimension is typically used when the freight is long and narrow and cannot have anything stacked on top of it (e.g. carpet rolls).  For this reason it takes a larger portion of the trailer volume than a shipment of the same weight that is packaged on pallets.  This value can then be used in the planning of trailer loads and to rate shipments that have these characteristics.
         * Required: false
         * Array: false
         */
        this.linealFootTotalNbr = undefined;
        /**
         * Total loose pieces from all commodities in the shipment.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * Specifies whether the shipment  in question needs to be manually rated or not. If required, it may be changed to a code indicating the reason as well for manually rating it.
         * It is same as special instructions field on the FBES screen.
         * ==NOTE==
         * When this indicator is set, it means the rates and charges must be manully reviewed before the bill is marked as RATED. Howerver the auto rating system is allowed to put rates and charges on the bill prior to putting it in a manual entry or manual audit queue.
         * This is different from the indicator AUTO_RATEABLE_IND which indicates whether the auto rating system is even allowed to put rates and charges on the bill.
         * Required: false
         * Array: false
         */
        this.manualRatingRequiredInd = undefined;
        /**
         * Identifies the number of moves or lifts made with a forklift or a pallet jack to move freight without manual intervention by the driver. This count may be equal to or less than the number of pieces in the shipment.  This is used by the costing system.
         * Required: false
         * Array: false
         */
        this.motorizedPiecesCount = undefined;
        /**
         * This indicates whether MTRZD_PCS_CNT is known or applicable.
         * Valid Values:
         * Y - Yes, MTRZD_PCS_CNT is known/applicable
         * N - No, MTRZD_PCS_CNT is NOT known/applicable
         * Required: false
         * Array: false
         */
        this.motorizedPiecesKnownInd = undefined;
        /**
         * The status of the latest movement for a Shipment from an operations point-of-view. This is a denormalized atribute from the MOVEMENT entity.
         * Valid Values :
         * Spaces - Not applicable
         * 1 - On dock
         * 2 - On trailer
         * 3 - Out for delivery
         * 4-  Interim Delivery
         * 5 - Final Delivered
         * 6 - Not Applicable
         * 6 - No movements allowed
         * 7 - Cancelled
         * Required: false
         * Array: false
         */
        this.movementStatusCd = undefined;
        /**
         * Indicates whether or not an notification exists for this shipment.  If it exists, the details will exist in the SHM NOTFICATION table.  The notification is created in the SCO (Smart4) system.
         * Values:
         * A - Appointment exists
         * N - Notification exists
         * O -Appointment Not Required
         * R- Reappointment candidate.  PSRT/RDMG Pro  could be reappointment for delivery
         * blank - Neither exist
         * Required: false
         * Array: false
         */
        this.notificationCd = undefined;
        /**
         * Pickup delivery route code from CAD used for sorting to print delivery sets in this order.
         * Required: false
         * Array: false
         */
        this.obcPickupDlvRouteCd = undefined;
        /**
         * SIC where the Shipment originates.  Usually associated with PRO prefix and can be overriden.
         * Required: false
         * Array: false
         */
        this.originTerminalSicCd = undefined;
        /**
         * Information about shipment parties.
         * Required: false
         * Array: true
         */
        this.parties = undefined;
        /**
         * Indicates whether a shipment pickup date was backdated during bill entry.
         * Values:
         * Y - Shipment pickup date was backdated at bill entry
         * N - Shipment pickup date = bill entry date
         * Required: false
         * Array: false
         */
        this.pickupBackdateInd = undefined;
        /**
         * Earliest available date that Shipment can be
         * picked up from a customer.
         * Required: false
         * Array: false
         */
        this.pickupDate = undefined;
        /**
         * Time when the shipment was picked up. This will be required for Late Tender shipments and optional for other shipments.
         * Required: false
         * Array: false
         */
        this.pickupTime = undefined;
        /**
         * This number identifies a shipment. This is the identifier given to the customer as a reference.
         * The numbers are printed on labels for each service center.  Labels are put on the Bill-Of-Lading and on the individual pieces of freight for identification.
         * Internal PRO number format is Oppp-sssss-c where 'ppp' is the pro-prefix, 'ssss' is the pro-suffix and 'c' is the check digit (modulus 7). It is usually displayed in the format 'ppp-sssss-c'
         * An expedited shipment may not always have a real PRO number. It may be given a dummy number in the same format and should not be written out to MBF.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * This is the volume of the shipment expressed as the percentage of a full pup (28 feet long trailer).
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         * Instance id of the Pickup Request that is associated with this Shipment during the Confirm On-Board process.
         * Required: false
         * Array: false
         */
        this.purInstId = undefined;
        /**
         * Earliest available time that freight can be picked up from a customer.
         * Required: false
         * Array: false
         */
        this.readyTime = undefined;
        /**
         * Date the shipment is required to be delivered.
         * Required: false
         * Array: false
         */
        this.requiredDeliveryDate = undefined;
        /**
         * Indicates whether the shipment will generate revenue for Con-way or not.
         * Valid Values :
         * Y - generates revenue
         * N - does not generate revenue
         * Required: false
         * Array: false
         */
        this.revenueBillInd = undefined;
        /**
         * Identifies the last Route the shipment was put on.
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * Identifies the last Route the shipment was put on.
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         * Identifies whether the shipment is currently on a  Route (either planning route or dispatched route) Staged (available) for Routing, or is Not on a route.
         * Valid Values
         * - Not Routed
         * R - Routed
         * S - Staged
         * Required: false
         * Array: false
         */
        this.routeTypeCd = undefined;
        /**
         * Indicates whether shipment service calculations have been performed.
         * Values:
         * 0 - Not Calculated Yet
         * 1 - Cannot Calculate (all variables not defined)
         * ? - Calculated from (service stopping event or appointment - replace '?' with DLVRY_QALFR_CD values)
         * Required: false
         * Array: false
         */
        this.serviceCalculatedStatusCd = undefined;
        /**
         * Business date on which the service clock starts.  This value will be calculated automatically for all shipments, based on the values of PKUP_DT and LATE_TENDER_CD.  If a shipment is tendered late, the service start date will be set to the next business date after the pick-up date.
         * Required: false
         * Array: false
         */
        this.serviceStartDate = undefined;
        /**
         * Defines the specific type of service provided for a shipment.
         * Values:  1 - Normal LTL, 2 - Con-Way Deferred Express.
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         * This code identifies the method in which Con-way received the freight from the customer.
         * Current values are:
         * PU: Regular Pickup:  This is when the driver goes to the customer dock and loads the Shipment on the trailer to return to the service center.
         * HL: Hook Loaded: This is when the driver goes to the customer site and pickup a loaded trailer that this Shipment was on.
         * DD: Dock Drop:  This is when the customer delivers the Shipment to a Con-way Service Center, so no driver went to the Customer site
         * Required: false
         * Array: false
         */
        this.shipmentAcquiredTypeCd = undefined;
        /**
         * System generated unique identifier (as per CBD standard).
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Indicates whether shipment met service standards.
         * Values: Fail, Success, Exempt, Unknown
         * Source : Calculated
         * Required: false
         * Array: false
         */
        this.shipmentServiceStatusCd = undefined;
        /**
         * The list of shipper customer dimensions profile details.
         * Required: false
         * Array: true
         */
        this.shipperDimensionsProfile = undefined;
        /**
         * Identifies whether a shipper loaded a trailer, and if so, where Con-way took possession of trailer.
         * Values:
         * N : Shipper did not load trailer (default)
         * H : Hook loaded; a trailer is loaded by shipper and picked up by Con-way at shipper s site
         * D : Dock Drop; a trailer is loaded by shipper and dropped at Con-way dock by shipper
         * Required: false
         * Array: false
         */
        this.shipperLoadedTrlrCd = undefined;
        /**
         * This captures the mileage from shipper to consignee as calculated by the Milemaker package.
         * Required: false
         * Array: false
         */
        this.shipperToConsigneeMiles = undefined;
        /**
         * Indicates if anyone handling the freight is required to sign on a signature sheet.
         * Required: false
         * Array: false
         */
        this.signatureServiceInd = undefined;
        /**
         * This indicates whether this was the only Shipment that we acquired from the Customer at the time that we received this one.
         * Values:
         * Y : Yes:  This was the only Shipment Acquired at the time that we received this one.
         * N : No: There were other Shipments Acquired at the time that we received this one.
         * Required: false
         * Array: false
         */
        this.singleShipmentAcquiredInd = undefined;
        /**
         * Indicates the source or origination of the Pro.  This code is needed for ACOR processing to determine whether to roll back to the initial data.
         * Valid Values:
         * 1  - Web        (Pickup Request web page)
         * 2  - EDI        (set 204 or set 211)
         * 3  - FTP        (file transfer)
         * 4  - FBES    (manual Bill Entry)
         * 5  - TCON or LOAD    (i.e. skeleton TCON or non-TCON LOAD)
         * 6  - Pickup Request
         * Required: false
         * Array: false
         */
        this.sourceCd = undefined;
        /**
         * Indicates whether the shipment has been split or not.
         * Valid values: Y/N
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         * The standard number of days it should take to move a shipment from origin to destination, as defined in the OSS_SVC_STDS_A/B tables.
         * Required: false
         * Array: false
         */
        this.standardTransitDays = undefined;
        /**
         * The start time of the window specified by the customer for delivering the shipment.
         * Required: false
         * Array: false
         */
        this.startDeliveryTime = undefined;
        /**
         * Generated by rating: Identifies the port of entry through which freight will enter another country.  This is either associated with the destination or with the customer's broker.
         * Required: false
         * Array: false
         */
        this.toPortCd = undefined;
        /**
         * Includes all charges that contribute to the CTS revenue minus discount.  Includes advance+beyond carrier charges and COD amount.
         * Required: false
         * Array: false
         */
        this.totalChargeAmount = undefined;
        /**
         * Total number of pallets in the shipment.
         * Required: false
         * Array: false
         */
        this.totalPalletsCount = undefined;
        /**
         * Total pieces from all commodities in the shipment.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         * Includes all charges that contribute to the CTS revenue minus discount in US dollars.  Includes advance+beyond carrier charges and COD amount.
         * Required: false
         * Array: false
         */
        this.totalUsdAmount = undefined;
        /**
         * The volume of the freight; derived from the dimensions captured by driver, or entered by a CSR or dock worker for an SL  (Shipper Load and Count), or from one of a variety of profiles. For details, see the description of CFT_PRFL_MTHD_CD.
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * Total weight of all the freight being moved as a unit.  If this is a  Mother  bill then this is the total of all of the  Daughter  bills.
         * Any rating weight allowances or variations (AW, DW, RW, NW) are not included.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         * The sequence number identifying the movement (qualifying delivery event) for the calculation of ACTL_TRNST_DAYS.
         * NOTE - VALUE CAN BE ZERO FOR PARTLOT (PTLT) PROS.
         * Required: false
         * Array: false
         */
        this.transitMovementSequenceNbr = undefined;
        /**
         * Indicates whether the shipment is eligible for the money-back guarantee if moving between direct points under Tariff CNWY-599.
         * Valid Values :
         * Y - eligible for warranty
         * N - not eligible for warranty - default value
         * Required: false
         * Array: false
         */
        this.warrantyInd = undefined;
        /**
         * Identifies the warranty status of a shipment
         * For example, one value of this code would indicate that a warranty  claim has been filed  by the debtor if a shipment has failed service.
         * Valid Values:
         * 0 - default value; This means either the shipment is not eligible (Warranty flag =  N ) or it is eligible and no one has filed a claim.
         * 1 - The customer has filed a claim and it has not been audited.
         * 2 - The customer has filed a claim and it was approved.
         * 3 - The customer has filed a claim and it was denied.
         * Required: false
         * Array: false
         */
        this.warrantyStatusCd = undefined;
        /**
         * Indicates whether the Handling Units are exempt for the parent PRO.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptInd = undefined;
    }
}
/**
 * Information about the shipment that is at a dock.
 */
class DockShipmentLoad {
    constructor() {
        /**
         * Indicates whether an accuracy check is required for the shipment.
         * Required: false
         * Array: false
         */
        this.accuracyCheckRequiredInd = undefined;
        /**
         * The begin time of the appointment.
         * Required: false
         * Array: false
         */
        this.appointmentBeginTime = undefined;
        /**
         * The end time of the appointment.
         * Required: false
         * Array: false
         */
        this.appointmentEndTime = undefined;
        /**
         * The code associated with the current billing status of the shipment.
         * Required: false
         * Array: false
         */
        this.billStatusCd = undefined;
        /**
         * The name and address of the consignee on the shipment.
         * Required: false
         * Array: false
         */
        this.consigneeParty = undefined;
        /**
         * The list of dimensions profiles for the customer based on the destination zip code.
         * Required: false
         * Array: true
         */
        this.customerDimensionsProfiles = undefined;
        /**
         * The shipment's default dimensions.
         * Required: false
         * Array: true
         */
        this.defaultDimensions = undefined;
        /**
         * The shipment delivery qualifier. E.g. Over, Short, Trap, Final Delivered, etc.
         * Required: false
         * Array: false
         */
        this.deliveryQualifier = undefined;
        /**
         * The shipment destination terminal SIC.
         * Required: false
         * Array: false
         */
        this.destSicCd = undefined;
        /**
         * If true, then shipment dimensions are required to be captured.
         * Required: false
         * Array: false
         */
        this.dimensionsRequiredInd = undefined;
        /**
         * The name of the dock location where the shipment is currently located.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
        /**
         * The type of dock location. Either a bay or dock door.
         * Required: false
         * Array: false
         */
        this.dockLocationType = undefined;
        /**
         * Expanded name: Estimated Delivery Date
         * Description: Date that the shipment should be delivered based on standard lane days.
         * Required: false
         * Array: false
         */
        this.estimatedDeliveryDate = undefined;
        /**
         * The ETA of the schedule associated with the shipment.
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         * The Freight Bill Delivery Set print count.The number of times that a FBDS has been printed for this shipment
         * Required: false
         * Array: false
         */
        this.fbdsPrintCount = undefined;
        /**
         * Indicates if the shipment type is either a food shipment or poison shipment.
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * If true, then the shipment contents can freeze.
         * Required: false
         * Array: false
         */
        this.freezableInd = undefined;
        /**
         * If true, then the shipment is guaranteed.
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         * The shipment dimensions for each of the pieces.
         * Required: false
         * Array: true
         */
        this.handlingUnits = undefined;
        /**
         * If true, then the shipment has hazardous materials.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * If true, then hazardous material information is required to be captured.
         * Required: false
         * Array: false
         */
        this.hazmatRequiredInd = undefined;
        /**
         * The hazardous material details.
         * Required: false
         * Array: true
         */
        this.hazmats = undefined;
        /**
         * If true, then the shipment is a headload on the trailer.
         * Required: false
         * Array: false
         */
        this.headloadInd = undefined;
        /**
         * If true, then the inspection is required on this shipment at the dock.
         * Required: false
         * Array: false
         */
        this.inspectionRequiredInd = undefined;
        /**
         * The equipment ID of the trailer to inspect.
         * Required: false
         * Array: false
         */
        this.inspectionTrailerNbr = undefined;
        /**
         * If set to true, then the shipment should be left on the trailer.
         * Required: false
         * Array: false
         */
        this.leaveOnTrailerInd = undefined;
        /**
         * The sequence in which the shipment should be loaded
         * Required: false
         * Array: false
         */
        this.loadSequenceNbr = undefined;
        /**
         * The date and time the shipment was last loaded.
         * Required: false
         * Array: false
         */
        this.loadTimestamp = undefined;
        /**
         * Name and Employee Id of the person who loaded the shipment
         * Required: false
         * Array: false
         */
        this.loadedByEmployee = undefined;
        /**
         * The count of loose pieces on this shipment.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * If set to true, then the number of motor moves are known for this shipment.
         * Required: false
         * Array: false
         */
        this.mmKnownInd = undefined;
        /**
         * Identifies the number of moves or lifts made with a forklift or a pallet jack to move freight without manual intervention by the driver.
         * Required: false
         * Array: false
         */
        this.motorMoves = undefined;
        /**
         * Identifies the shipment position on the trailer for a given route. Previously, progressiveLoadingCd.
         * Required: false
         * Array: false
         */
        this.positionOnTrailerCd = undefined;
        /**
         * Progressive loading cd of the shipment: Stripped, NotStripped or TConned
         * Required: false
         * Array: false
         */
        this.progressiveLoadingCd = undefined;
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Expanded Name: PUP_VOLUME_PERCENTAGE
         * Desc: This is the volume of the shipment expressed as the percentage of a full pup (28 feet long trailer).
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         * If true, then the shipment is moving as rate saver.
         * Required: false
         * Array: false
         */
        this.rateSaverInd = undefined;
        /**
         * If set to true, then the reweigh button is displayed on the handheld device.
         * Required: false
         * Array: false
         */
        this.reweighButtonInd = undefined;
        /**
         * If set to true, then reweigh is required for this shipment.
         * Required: false
         * Array: false
         */
        this.reweighRequiredInd = undefined;
        /**
         * The route associated with the shipment.
         * Required: false
         * Array: false
         */
        this.route = undefined;
        /**
         * Route sequence number assigned to the Shipment on the route
         * Required: false
         * Array: false
         */
        this.routeSequenceNbr = undefined;
        /**
         * Indicates the service type on the shipment. E.g. Normal, Deferred, Guaranteed By Noon, etc.
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         * If true, then the shipping documents are required by the DSR. Normally shipping documents are required for cross border shipments.
         * Required: false
         * Array: false
         */
        this.shipmentDocRequiredInd = undefined;
        /**
         * The unique identifier of the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The current dock location of the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentLocation = undefined;
        /**
         * The count of shipments on this stop.
         * Required: false
         * Array: false
         */
        this.shipmentsOnStopCount = undefined;
        /**
         * The count of shipments remaining to be loaded/unloaded.
         * Required: false
         * Array: false
         */
        this.shipmentsRemainingCount = undefined;
        /**
         * The total pallet count of the shipment.
         * Required: false
         * Array: false
         */
        this.totalPalletCount = undefined;
        /**
         * The total piece count of the shipment.
         * Required: false
         * Array: false
         */
        this.totalPieceCount = undefined;
        /**
         * The total weight of the shipment.
         * Required: false
         * Array: false
         */
        this.totalWeight = undefined;
        /**
         * The PRO number of the handling unit.
         * Required: false
         * Array: false
         */
        this.trackingProNbr = undefined;
        /**
         * The section of the trailer where the shipment is placed.
         * Required: false
         * Array: true
         */
        this.trailerSections = undefined;
        /**
         * Usually set to current date time when the request was sent by the handheld.
         * Required: false
         * Array: false
         */
        this.versionCheckTimestamp = undefined;
        /**
         * The shipment's volume in cubic feet based on the dimensions.
         * Required: false
         * Array: false
         */
        this.volumeCubicFeet = undefined;
        /**
         * If set to true, then the shipment was diverted.
         * Required: false
         * Array: false
         */
        this.divertInd = undefined;
        /**
         * The unique identifier of the pickup request.
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         * The sequence number of the pickup request line item under one unique ID.
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         * If set to true, then Handling Units are exempt for the parent PRO.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptInd = undefined;
        /**
         * The door number from where the shipment will be loaded.
         * Required: false
         * Array: false
         */
        this.loadDoorNbr = undefined;
        /**
         * The service center identification code for the dock where the shipment was loaded.
         * Required: false
         * Array: false
         */
        this.loadedAtSic = undefined;
        /**
         * The service center identification code of the dock worker that loaded the PRO.
         * Required: false
         * Array: false
         */
        this.loadByEmployeeSicCd = undefined;
        /**
         * If set to true, then the shipment is a misload.
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * The move-to service center identification code of the diverted lane.
         * Required: false
         * Array: false
         */
        this.divertMoveToSicCd = undefined;
        /**
         * The close-to service center identification code of the diverted lane.
         * Required: false
         * Array: false
         */
        this.divertCloseToSicCd = undefined;
        /**
         * If set to true, then the shipment is diverted to a day lane.
         * Required: false
         * Array: false
         */
        this.divertDayFreightInd = undefined;
        /**
         * Indicates whether the shipment is partially loaded.
         * Required: false
         * Array: false
         */
        this.partiallyLoadedInd = undefined;
        /**
         * The denormalized field which stores a MOVR PRO that is associated with the parent PRO which will move this handling unit across the border.
         * Required: false
         * Array: false
         */
        this.moverProNbr = undefined;
        /**
         * The mover suffix that uniquely identifies the child PROs that were split from the parent and that need to cross the border.
         * Required: false
         * Array: false
         */
        this.moverSuffix = undefined;
        /**
         * Indicates whether the child PRO is part of a PLT mover that has not cleared customs in-bond yet.
         * Required: false
         * Array: false
         */
        this.customsInBondInd = undefined;
    }
}
/**
 * This type was created to force transformer generation.
 */
class DoNotUse {
    constructor() {
        /**
         * The code associated with the type of event.
         * Required: false
         * Array: false
         */
        this.scoEventTypeCd = undefined;
        /**
         * The code associated with the sub type of event.
         * Required: false
         * Array: false
         */
        this.scoEventSubTypeCd = undefined;
        /**
         * The code associated with the application.
         * Required: false
         * Array: false
         */
        this.applicationCd = undefined;
    }
}
/**
 * The recommendations for a Door Plan.
 */
class DoorPlanRecommendation {
    constructor() {
        /**
         * The identifier of the door at the SIC.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The category for the recommendation.
         * Required: true
         * Array: false
         */
        this.category = undefined;
        /**
         * The code associated with the recommendation type.
         * Required: true
         * Array: false
         */
        this.recommendationTypeCd = undefined;
        /**
         * The JSON that is returned which represents the recommendation.
         * Required: true
         * Array: false
         */
        this.recommendationJson = undefined;
    }
}
/**
 * Contains DoorPlan and List of Shipments
 */
class DoorPlanShipment {
    constructor() {
        /**
         * The Door Plan associated with the shipments.
         * Required: true
         * Array: false
         */
        this.doorPlan = undefined;
        /**
         * The list of head-load shipments.
         * Required: true
         * Array: true
         */
        this.shipments = undefined;
    }
}
/**
 * Information about the availabilty of a driver.
 */
class DriverAvailability {
    constructor() {
        /**
         * The identifier which is used for the Success Factors applications.
         * Required: false
         * Array: false
         */
        this.successFactorsId = undefined;
        /**
         * The identifier that is used for the People Soft applications.
         * Required: false
         * Array: false
         */
        this.peopleSoftId = undefined;
        /**
         * The hours worked by a driver.
         * Required: false
         * Array: false
         */
        this.hoursWorked = undefined;
        /**
         * The availabilty of a driver.
         * Required: false
         * Array: false
         */
        this.availability = undefined;
        /**
         * The full name of a driver.
         * Required: false
         * Array: false
         */
        this.fullName = undefined;
    }
}
/**
 * Information about the Equipment Event.
 */
class EquipmentEvent {
    constructor() {
        /**
         * The identifier of the photo archived in the DMS system.
         * Required: false
         * Array: false
         */
        this.dmsDocId = undefined;
        /**
         * The door number where the event occurred.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The current event as recorded in Equipment.
         * Required: false
         * Array: false
         */
        this.eqpCurrentEvent = undefined;
        /**
         * The date and time of the last equipment current event.
         * Required: false
         * Array: false
         */
        this.eqpCurrentEventOccuredDateTime = undefined;
        /**
         * The unique identifier of the equipment event.
         * Required: false
         * Array: false
         */
        this.eqpEventInstd = undefined;
        /**
         * The unique identifier of the equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The date and time when the event occured.
         * Required: false
         * Array: false
         */
        this.eventOccuredDateTime = undefined;
        /**
         * The source of the event. E.g. Handheld or Edge or Navigator.
         * Required: false
         * Array: false
         */
        this.eventSourceCd = undefined;
        /**
         * Further break down of type code into sub types.
         * Values
         * TRLR - Trailer Event
         * PICF - Full Photo Event
         * PICT - Thumbnail Photo Event
         * Required: false
         * Array: false
         */
        this.eventSubTypeCd = undefined;
        /**
         * The type of event that occured. For example, OPEN, CLOSE or LOAD.
         * Required: false
         * Array: false
         */
        this.eventTypeCd = undefined;
        /**
         * The number for the load release of the trailer when it is closed.
         * Required: false
         * Array: false
         */
        this.loadedReleaseNbr = undefined;
        /**
         * The code associated with the shift when the event occured.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The service center identification code for the location where the event occurred.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The employee ID of the dock worker.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The reason for the equipment event.
         * Required: false
         * Array: false
         */
        this.reason = undefined;
        /**
         * The rating for the load quality if this is an open/close event rating.
         * Required: false
         * Array: false
         */
        this.loadQualityRatingNbr = undefined;
        /**
         * The one or more reasons for the equipment event.
         * Required: false
         * Array: true
         */
        this.eventReasons = undefined;
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Indicates whether there are hazardous materials.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * This determines the scale of the load quality rating.
         * Required: false
         * Array: false
         */
        this.maxRating = undefined;
    }
}
/**
 * Maintenance Indicators for an Equipment
 */
class EquipmentMaintenanceIndicator {
    constructor() {
        /**
         * mntRtgInd.
         * Values: E or X
         * Required: false
         * Array: false
         */
        this.reportingCode = undefined;
        /**
         * mnt pm Ind. Value can be P
         * Required: false
         * Array: false
         */
        this.preventiveMaintenanceCode = undefined;
        /**
         * mntTTInd. Value can be T
         * Required: false
         * Array: false
         */
        this.troubleTicketCode = undefined;
    }
}
/**
 * Information about Equipment Current Status and Remarks
 */
class EquipmentStatusRemark {
    constructor() {
        /**
         * Current Location of Equipment
         * Required: false
         * Array: false
         */
        this.currentSic = undefined;
        /**
         * Current Status of the Equipment
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         * Unique Identifier of the Equipment
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * EquipmentPrefix-Suffix
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * Remarks associated with the Equipment
         * Required: false
         * Array: false
         */
        this.equipmentRemarks = undefined;
        /**
         * Date and time when the Status update was done
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         * Validation message associated with Updating the Status and Remark
         * Required: false
         * Array: false
         */
        this.validationMessage = undefined;
    }
}
/**
 * Event snapshot details for DockOps equipment.
 */
class EvtDockOperationsSnapshot {
    constructor() {
        /**
         * The snapshot details for Pro Movement Hist.
         * Required: false
         * Array: false
         */
        this.proMovementHistSnapshot = undefined;
        /**
         * The snapshot details for Equipment.
         * Required: false
         * Array: false
         */
        this.equipmentSnapshot = undefined;
        /**
         * The snapshot details for Dock Loaded Shipment.
         * Required: false
         * Array: false
         */
        this.dockLoadedShipmentSnapshot = undefined;
        /**
         * The snapshot details for Dock Loaded Handling Unit.
         * Required: false
         * Array: false
         */
        this.dockLoadedHandlingUnitSnapshot = undefined;
    }
}
/**
 * Basic Information about an Equipment
 */
class ForeignEquipment {
    constructor() {
        /**
         * Unique Id of Equipment
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * Equipment Prefix - Suffix
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * This is the 4 character prefix of the equipment id. (eg. 0415 or SWFT etc)
         * Required: false
         * Array: false
         */
        this.equipmentPrefix = undefined;
        /**
         * Sequencing or serial part of an equipment unit's identifying number (pure numeric form for equipment number is preferred)
         * Required: false
         * Array: false
         */
        this.equipmentSuffix = undefined;
        /**
         * Equipment Type Cd.Container, Forklift, Dolly, Tractor, Skid, TrailerType -
         * Required: false
         * Array: false
         */
        this.equipmentTypeCd = undefined;
        /**
         * Equipment Type Detail Cd This is a 'intelligent' code that will help identify the characteristics of a piece of equipment.
         * eg. TTC28 - could mean linehaul trailer 28' long.
         * Required: false
         * Array: false
         */
        this.equipmentTypeDetailCd = undefined;
        /**
         * This is the SCAC code of the carrier that the equipment was rented from or the SCAC code of the Substitute service provider.
         * Required: false
         * Array: false
         */
        this.foreignScacCd = undefined;
        /**
         * Validation messages that are used when adding the equipment.
         * Required: false
         * Array: false
         */
        this.messages = undefined;
    }
}
/**
 * The details for a handling unit that is either loaded on a dock or a piece of equipment.
 */
class HandlingUnitOnTrailerOrDock {
    constructor() {
        /**
         * The parent PRO that owns the child PRO that is being loaded to a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * The identifier of the child PRO being loaded to a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.childProNbr = undefined;
        /**
         * The unique identifier of the equipment. This is mutually exclusive from dockInstanceId.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The unique identifier of the dock location. This is mutually exclusive from equipmentId.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The name of the dock location.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * Indicates whether a handling unit is part of the head load.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * The destination SIC of the handling unit.
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         * Indicates whether the shipment is a misload.
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Indicates whether the shipment is a split.
         * Required: false
         * Array: false
         */
        this.splitInd = undefined;
        /**
         * The identifier of the employee who authorized the misload or split.
         * Required: false
         * Array: false
         */
        this.overrideUserId = undefined;
        /**
         * The data and time when the misload or split was approved.
         * Required: false
         * Array: false
         */
        this.overrideDateTime = undefined;
    }
}
/**
 * Headload destinations for a door plan
 */
class HeadloadDestination {
    constructor() {
        /**
         * The profile to which the door plan belongs.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The identifier of the door at the SIC.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The sequential number which is used to uniquely identify the record.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * The final destination of shipments that will be loaded to this door.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * Indicates whether a destination is a Headload destination when loaded through this door.
         * Required: false
         * Array: false
         */
        this.headloadInd = undefined;
    }
}
/**
 * The business identifier for a shipment along with a headload indicator which determines whether the shipment has been modified.
 */
class HeadloadShipment {
    constructor() {
        /**
         * Indicates whether the shipment is a headload.
         * Required: false
         * Array: false
         */
        this.headloadInd = undefined;
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 * Information about the freight flow leg. A Load leg contains one or more move legs.
 */
class Leg {
    constructor() {
        /**
         * The number of days that have elapsed between the origin and destination SIC.
         * Required: false
         * Array: false
         */
        this.cycle = undefined;
        /**
         * The origin service center identification code for the leg.
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The shift code at the origin SIC.
         * Required: false
         * Array: false
         */
        this.originShiftCd = undefined;
        /**
         * The movement mode code associated with the leg.  Permitted values: Linehaul, Supplemental, and Exclusive.
         * Required: false
         * Array: false
         */
        this.moveModeCd = undefined;
        /**
         * The sequence in which the leg appears in the overall flow.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Indicates whether the freight is held at the location.
         * Required: false
         * Array: false
         */
        this.holdLegInd = undefined;
    }
}
/**
 * The loaded unit, which represents a shipment, handling unit, or pickup request.
 */
class LoadedUnit {
    constructor() {
        /**
         * The basic details that are always returned for each element in the response.
         * Required: false
         * Array: false
         */
        this.basicUnit = undefined;
        /**
         * The consignee details that are only returned if the end consumer has requested them.
         * Required: false
         * Array: false
         */
        this.consignee = undefined;
        /**
         * The shipper of the Shipment, Handling Unit, or Pickup Request.
         * Required: false
         * Array: false
         */
        this.shipper = undefined;
        /**
         * The route assigned to the Shipment or Pickup Request.
         * Required: false
         * Array: false
         */
        this.route = undefined;
        /**
         * The time in which a unit is scheduled to be delivered.
         * Required: false
         * Array: false
         */
        this.deliveryTime = undefined;
    }
}
/**
 * Information about a load lane based on the freight flow path.
 */
class LoadLane {
    constructor() {
        /**
         * The service center identification code of the first location to which the Trailer Load is going.
         * Required: false
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The service center identification code of the final destination location of the Trailer Load.
         * Required: false
         * Array: false
         */
        this.closeToSicCd = undefined;
        /**
         * The shift when the freight is expected to arrive - Inbound, Outbound, DayReship or NightFAC
         * Required: false
         * Array: false
         */
        this.closeToShiftCd = undefined;
        /**
         * This describes how far deep into the network are we loading the freight to. E.g. Final Dest or 3rd FAC or  2nd FAC etc.
         * Required: false
         * Array: false
         */
        this.loadLevel = undefined;
        /**
         * The list of service center identification codes for the final destination locations of the freight.
         * Required: false
         * Array: true
         */
        this.destinations = undefined;
        /**
         * The total weight of all the shipments in this lane that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalWeight = undefined;
        /**
         * The total cube percent of all the shipments in this lane that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalCubePct = undefined;
        /**
         * The count of Pups that will be required for this load. This is calculated by dividing total weight and cube by their corresponding linehaul parameters.
         * Required: false
         * Array: false
         */
        this.pupCount = undefined;
        /**
         * Count of shipments in the plan that form part of the load
         * Required: false
         * Array: false
         */
        this.shipmentCount = undefined;
        /**
         * The weight threshold to use when deriving Pup Count. E.g. 16000 or 18000.
         * Required: false
         * Array: false
         */
        this.thresholdWeight = undefined;
        /**
         * The cube percent threshold to use when deriving pup count. E.g. 80 or 90 or 85.
         * Required: false
         * Array: false
         */
        this.thresholdCubePct = undefined;
        /**
         * The Door Plan associated with the Load Lane.
         * Required: false
         * Array: false
         */
        this.doorPlan = undefined;
        /**
         * The total weight of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadWeight = undefined;
        /**
         * The total cube percent of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadCubePct = undefined;
        /**
         * The total count of shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadShipmentCount = undefined;
        /**
         * The count of Pups that will be required for this load based on remaining to load weight and cube.  This is calculated by dividing total weight and cube by their corresponding linehaul parameters.
         * Required: false
         * Array: false
         */
        this.remainingToLoadPupCount = undefined;
        /**
         * The service center identification code for the the headload destination.
         * Required: false
         * Array: false
         */
        this.headloadSicCd = undefined;
        /**
         * The code associated with the shift when the freight is expected to arrive at the headload destination.
         * Required: false
         * Array: false
         */
        this.headloadShiftCd = undefined;
        /**
         * The code associated with the shift for the move to SIC.
         * Required: false
         * Array: false
         */
        this.moveToShiftCd = undefined;
        /**
         * The identifier of the load lane header and detail with form of header-detail.
         * Required: false
         * Array: false
         */
        this.loadLaneId = undefined;
    }
}
/**
 * Information about Load Lane Destination
 */
class LoadLaneDestination {
    constructor() {
        /**
         * The service center identification code for the shipment destination.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * The total weight of all the shipments that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalPlannedWeight = undefined;
        /**
         * The total cube percent of all the shipments that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalPlannedCubePct = undefined;
        /**
         * The count of shipments in the plan that form part of the load.
         * Required: false
         * Array: false
         */
        this.totalPlannedShipmentCount = undefined;
        /**
         * The total weight of the all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadWeight = undefined;
        /**
         * The total cube percent of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadCubePct = undefined;
        /**
         * The total count of shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadShipmentCount = undefined;
        /**
         * The motor moves count for all the shipments in the plan.
         * Required: false
         * Array: false
         */
        this.totalPlannedMmCount = undefined;
        /**
         * The motor moves count for all the shipments remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingMmCount = undefined;
        /**
         * The Door Plan associated with the destination.
         * Required: false
         * Array: false
         */
        this.doorPlan = undefined;
        /**
         * The list of shipments that make up this Load Lane Destination.
         * Required: false
         * Array: true
         */
        this.shipments = undefined;
    }
}
/**
 * Information about the freight flow path and list of destinations.
 */
class LoadLaneFreightFlow {
    constructor() {
        /**
         * The service center identification code of the first location to which the trailer load is going.
         * Required: false
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The service center identification code of the final destination location of the trailer load.
         * Required: false
         * Array: false
         */
        this.closeToSicCd = undefined;
        /**
         * The shift code at the close to SIC when the trailer is arriving.
         * Required: false
         * Array: false
         */
        this.closeToShiftCd = undefined;
        /**
         * This describes how far deep into the network the freight is being loaded. E.g. Final Dest, 3rd FAC, 2nd FAC, etc.
         * Required: false
         * Array: false
         */
        this.loadLevel = undefined;
        /**
         * The list of service center identification codes for the final destination locations of the freight.
         * Required: false
         * Array: true
         */
        this.loadLaneDestinations = undefined;
        /**
         * The total weight of all the shipments in this lane that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalWeight = undefined;
        /**
         * The total cube percent of all the shipments in this lane that are part of the load.
         * Required: false
         * Array: false
         */
        this.totalCubePercentage = undefined;
        /**
         * The count of Pups that will be required for this load. This is calculated by dividing total weight and cube by their corresponding linehaul parameters.
         * Required: false
         * Array: false
         */
        this.pupCount = undefined;
        /**
         * The number of shipments in the plan that form part of the load.
         * Required: false
         * Array: false
         */
        this.shipmentCount = undefined;
        /**
         * The total weight of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadWeight = undefined;
        /**
         * The count of Pups that will be required for this load based on remaining to load weight and cube.  This is calculated by dividing total weight and cube by their corresponding linehaul parameters.
         * Required: false
         * Array: false
         */
        this.remainingToLoadPupCount = undefined;
        /**
         * The total cube percent of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadCubePercentage = undefined;
        /**
         * The total count of shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadShipmentCount = undefined;
        /**
         * The freight flow path from the origin SIC and shift to close to SIC.
         * Required: false
         * Array: false
         */
        this.freightFlowPath = undefined;
        /**
         * The list of load legs associated with the freight flow path from the origin SIC and shift to close to SIC.
         * Required: false
         * Array: true
         */
        this.loadLegs = undefined;
        /**
         * The sector number from the FAC where the destinations will be loaded from when the close to SIC is an FAC location.
         * Required: false
         * Array: false
         */
        this.facSectorNbr = undefined;
    }
}
/**
 * Information about the load leg of the freight flow path.
 */
class LoadLeg {
    constructor() {
        /**
         * The number of days that have elapsed between the origin and destination SIC.
         * Required: false
         * Array: false
         */
        this.cycle = undefined;
        /**
         * The origin service center identification code for the leg.
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The shift code at the origin SIC.
         * Required: false
         * Array: false
         */
        this.originShiftCd = undefined;
        /**
         * The movement mode code associated with the leg.  Permitted values: Linehaul, Supplemental, and Exclusive.
         * Required: false
         * Array: false
         */
        this.moveModeCd = undefined;
        /**
         * The sequence in which the leg appears in the overall flow.
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Indicates whether the freight is held at the location.
         * Required: false
         * Array: false
         */
        this.holdLegInd = undefined;
        /**
         * The load leg destination service center identification code.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * The shift code at the load leg destination.
         * Required: false
         * Array: false
         */
        this.destinationShiftCd = undefined;
        /**
         * The list of move legs associated with the load leg.
         * Required: false
         * Array: true
         */
        this.moveLegs = undefined;
    }
}
/**
 * Information about to where the shipment should be loaded
 */
class LoadToLocation {
    constructor() {
        /**
         * The unique identifier of the area.
         * Required: false
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         * The name of the area to which the dock location belongs.
         * Required: false
         * Array: false
         */
        this.areaName = undefined;
        /**
         * The identifying name of the dock location.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
        /**
         * The count of load deck in a trailer or location.
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         * The total weight of all the equipment that is loaded onto a trailer.
         * Required: false
         * Array: false
         */
        this.loadedEquipmentWeight = undefined;
        /**
         * The sequence number of the shipment on the trailer with respect to all other shipments loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadSequenceNbr = undefined;
        /**
         * The priority number.
         * Required: false
         * Array: false
         */
        this.priority = undefined;
        /**
         * Identifies the shipment position on the trailer for a given route. Previously, progressiveLoadingCd
         * Required: false
         * Array: false
         */
        this.positionOnTrailerCd = undefined;
        /**
         * Information about the route.
         * Required: false
         * Array: false
         */
        this.route = undefined;
        /**
         * The current status.
         * Required: false
         * Array: false
         */
        this.status = undefined;
        /**
         * Trailer Number. Prefix-Suffix
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
        /**
         * Total length of the trailer
         * Required: false
         * Array: false
         */
        this.trailerLength = undefined;
        /**
         * Total loaded volume in cu ft of the trailer
         * Required: false
         * Array: false
         */
        this.trailerLoadCube = undefined;
        /**
         * Total loaded weight of the trailer
         * Required: false
         * Array: false
         */
        this.trailerLoadWeight = undefined;
        /**
         * The count of sibling PROs in a trailer or location.
         * Required: false
         * Array: false
         */
        this.siblingProCount = undefined;
        /**
         * The code associated with the shift to which the PRO is loaded.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Details used in the creation of manifest reports.
 */
class ManifestReport {
    constructor() {
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The unique identifier of the trailer equipment
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
    }
}
/**
 * The attributes which help determine the next best action for a directed loading exception.
 */
class NextBestLoadingAction {
    constructor() {
        /**
         * The priority ranking of the action to be taken. A lower value corresponds to a higher priority.
         * Required: true
         * Array: false
         */
        this.priority = undefined;
        /**
         * The identification code for the service center where the next best action is to take place.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift during which the next best action is taking place.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The service center identification code for the destination for the next load-to move segment of the next best action.
         * Required: true
         * Array: false
         */
        this.loadToSicCd = undefined;
        /**
         * The type of lane from which the next best action was generated.
         * Required: true
         * Array: false
         */
        this.directedLoadingLaneTypeCd = undefined;
        /**
         * The number for the dock door where the next best action should occur.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the trailer that is staged at the door upon which the next best action should load.
         * Required: false
         * Array: false
         */
        this.trailerId = undefined;
        /**
         * The unique identifier of the shipment for which the next best action is recommended.
         * Required: true
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The business identifier of the shipment upon which the next best action is suggested.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The code associated with the type of action which should take place as the next best action.
         * Required: true
         * Array: false
         */
        this.nextBestActionTypeCd = undefined;
    }
}
/**
 * The details for a non-loaded handling unit, which will be used for the split process.
 */
class NonLoadedHandlingUnit {
    constructor() {
        /**
         * The parent PRO number of the handling unit; a denormed field from the parent shipment table.  Refer to the main source table for more details.
         * Required: true
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * The child PRO number identifies a handling unit of a shipment. This is an alternate key of the table.
         * Required: true
         * Array: false
         */
        this.childProNbr = undefined;
    }
}
/**
 * The payload which is used to submit the print trailer manifest report.
 */
class PrintTrailerManifestPayload {
    constructor() {
        /**
         * The identification code for the service center of the trailer for which the manifest will be printed.
         * Required: false
         * Array: false
         */
        this.sicCode = undefined;
        /**
         * The trailer number for which the manifest will be printed.
         * Required: false
         * Array: false
         */
        this.trailerNumber = undefined;
        /**
         * The number assigned to the printer at the service center where the print request will be sent.
         * Required: false
         * Array: false
         */
        this.printerNumber = undefined;
        /**
         * The unique identifier of the employee who is the dock worker making the request.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
    }
}
/**
 * Details for a shipment that has been assigned to a route.
 */
class RoutedShipment {
    constructor() {
        /**
         * The begin time of the appointment.
         * Required: false
         * Array: false
         */
        this.appointmentBeginTime = undefined;
        /**
         * The end time of the appointment.
         * Required: false
         * Array: false
         */
        this.appointmentEndTime = undefined;
        /**
         * The current status of the shipment from the billing point of view.
         * Valid Values:
         * 1 - Unbilled
         * 2 - In FBES Suspense Queue
         * 3 - Billed
         * 4 - Rated
         * 5 - Paid
         * 6 - Cancelled
         * Required: false
         * Array: false
         */
        this.billStatusCd = undefined;
        /**
         * The name and address of the consignee on the shipment.
         * Required: false
         * Array: false
         */
        this.consigneeParty = undefined;
        /**
         * This is the dock location where the shipment is currrently loaded.
         * Required: false
         * Array: false
         */
        this.currentDockLocation = undefined;
        /**
         * The unique identifier of the dock location where the shipment is currently loaded.
         * Required: false
         * Array: false
         */
        this.currentDockLocationId = undefined;
        /**
         * The trailer where the shipment is currrently loaded.
         * Required: false
         * Array: false
         */
        this.currentTrailerId = undefined;
        /**
         * The shipment destination service center identification code.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * Indicates whether the shipment contains food or posion. Assumption: A shipment will never contain both.
         * Valid Values:
         * 1 - Neither
         * 2 - Food
         * 3 -  Poison
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         * Required: false
         * Array: false
         */
        this.freezableInd = undefined;
        /**
         * Indicates whether the shipment is under the Con-Way Guaranteed Service Program.
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         * The list of handling units for a route.
         * Required: false
         * Array: true
         */
        this.handlingUnits = undefined;
        /**
         * Indicates whether or not a shipment includes  any commodities with hazardous materials. It is a denormalized attribute for performance puposes.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether a shipment is head loaded onto the trailer.
         * Required: false
         * Array: false
         */
        this.headloadInd = undefined;
        /**
         * The door number from where the shipment will be loaded.
         * Required: false
         * Array: false
         */
        this.loadDoorNbr = undefined;
        /**
         * The service center identification code for the dock where the shipment was loaded.
         * Required: false
         * Array: false
         */
        this.loadedAtSic = undefined;
        /**
         * The name and employee ID of the person who loaded the shipment.
         * Required: false
         * Array: false
         */
        this.loadedByEmployee = undefined;
        /**
         * The sequence in which the shipment should be loaded.
         * Required: false
         * Array: false
         */
        this.loadSequenceNbr = undefined;
        /**
         * The date and time when the shipment was last loaded.
         * Required: false
         * Array: false
         */
        this.loadDateTime = undefined;
        /**
         * Identifies the number of moves or lifts made with a forklift or a pallet jack to move freight without manual intervention by the driver. This count may be equal to or less than the number of pieces in the shipment.  This is used by the costing system.
         * Required: false
         * Array: false
         */
        this.motorizedPiecesCount = undefined;
        /**
         * Identifies the shipment position on the trailer for a given route.
         * Required: false
         * Array: false
         */
        this.positionOnTrailerCd = undefined;
        /**
         * The business identifier of the parent shipment or legacy PRO.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * This is the volume of the shipment expressed as the percentage of a full pup (28 feet long trailer).
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         * The unique identifier of the shipment/
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The current location of the shipment. If the shipment is at another SIC, then populate with the SIC code; else DOCK.
         * Required: false
         * Array: false
         */
        this.shipmentLocation = undefined;
        /**
         * The total number of pieces from all commodities in the shipment.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         * The total weight of all the freight being moved as a unit.  If this is a mother bill, then this is the total of all of the daughter bills.
         * Any rating weight allowances or variations (AW, DW, RW, NW) are not included.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         * The sections of the trailer where the shipment is located.
         * Required: false
         * Array: true
         */
        this.trailerSections = undefined;
        /**
         * The shipment's volume in cubic feet based on the dimensions.
         * Required: false
         * Array: false
         */
        this.volumeCubicFeet = undefined;
        /**
         * The total loose pieces count for the shipment.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * Defines the specific type of service provided for a shipment.
         * Values:  1 - Normal LTL, 2 - Con-Way Deferred Express.
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
    }
}
/**
 * Shipment dock history details.
 */
class ShipmentDockHistory {
    constructor() {
        /**
         * The type of event.
         * Required: false
         * Array: false
         */
        this.event = undefined;
        /**
         * The service center where the update associated with the event occurred.
         * Required: false
         * Array: false
         */
        this.updateAtSic = undefined;
        /**
         * The origin SIC of the shipment.
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         * The destination SIC of the shipment.
         * Required: false
         * Array: false
         */
        this.destinationSic = undefined;
        /**
         * The load release number of the trailer the shipment is on during the event.
         * Required: false
         * Array: false
         */
        this.loadReleaseNbr = undefined;
        /**
         * The destination SIC of the trailer the shipment was loaded on during the event.
         * Required: false
         * Array: false
         */
        this.loadDestinationSic = undefined;
        /**
         * The trailer number the shipment was loaded on during the event.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The weight of the trailer the shipment was loaded on during the event.
         * Required: false
         * Array: false
         */
        this.trailerWeightLbs = undefined;
        /**
         * The cube of the trailer the shipment was loaded on during the event.
         * Required: false
         * Array: false
         */
        this.trailerCubePercentage = undefined;
        /**
         * The bill count of shipments on the trailer during the event.
         * Required: false
         * Array: false
         */
        this.shipmentsOnTrailerCount = undefined;
        /**
         * The service center where the event occurred.
         * Required: false
         * Array: false
         */
        this.occurredSic = undefined;
        /**
         * The elapsed time between the previous and current events.
         * Required: false
         * Array: false
         */
        this.elapsedTime = undefined;
        /**
         * The timestamp for when the event occurred.
         * Required: false
         * Array: false
         */
        this.occurredDateTime = undefined;
        /**
         * The unique identifier of the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The description of the event.
         * Required: false
         * Array: false
         */
        this.description = undefined;
        /**
         * audit info of the operation, including updateById information
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * The details for a shipment that is either loaded on a dock or a piece of equipment.
 */
class ShipmentOnTrailerOrDock {
    constructor() {
        /**
         * The business identifier associated with the shipment that is in the bill of lading.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The unique identifier of the equipment. This is mutually exclusive from dockInstanceId.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The unique identifier of the dock location. This is mutually exclusive from equipmentId.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The name of the dock location.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * Indicates whether a handling unit is part of the head load.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * The unique identifier of the pickup request when the shipment is part of a pickup.
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         * The identifier of the pickup request line item of the shipment when it is part of a pickup.
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         * The destination SIC of the shipment.
         * Required: false
         * Array: false
         */
        this.billDestinationSic = undefined;
        /**
         * Indicates whether the shipment is a misload.
         * Required: false
         * Array: false
         */
        this.misloadInd = undefined;
        /**
         * Indicates whether the shipment is complete.
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * The identifier of the employee who is the worker that performed the action.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * The date and time when the movement took place.
         * Required: false
         * Array: false
         */
        this.movementDateTime = undefined;
    }
}
/**
 * Information about Route for the Shipments
 */
class ShipmentRoute {
    constructor() {
        /**
         * Unique Id of the route
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Route Prefix
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * Suffix value of the Route
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         * Date when the Route is effective
         * Required: false
         * Array: false
         */
        this.routeDate = undefined;
        /**
         * Category Code of the Route: Delivery Route, Dock Route or Planning Route
         * Required: false
         * Array: false
         */
        this.categoryCd = undefined;
        /**
         * If set to true then the Route is Released
         * Required: false
         * Array: false
         */
        this.xdockReleaseInd = undefined;
        /**
         * Planned departure time of the Delivery Route
         * Required: false
         * Array: false
         */
        this.deliveryRouteDepartTime = undefined;
    }
}
/**
 * Skeleton information about a shipment
 */
class ShipmentSkeleton {
    constructor() {
        /**
         * The unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * SIC Code of the location where the dimensions were entered
         * Required: false
         * Array: false
         */
        this.requestingSicCd = undefined;
        /**
         * Hazmat details for the shipment
         * Required: false
         * Array: true
         */
        this.hazmatGroups = undefined;
        /**
         * PRO number of the Shipment
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * 1 or more Handling Unit information for the Shipment
         * Required: false
         * Array: true
         */
        this.handlingUnits = undefined;
        /**
         * Identifies the shipment as containing bulk liquid.  If volume is known, this applies to shipments >119 gallons.
         * Required: false
         * Array: false
         */
        this.bulkLiquidInd = undefined;
        /**
         * Total loose pieces from all commodities in the shipment.
         * Count of non Motor Move pieces associated with a shipment. This count plus Motor Moves defines the total number of pieces moving within the Con-way system for Operations productivity.  This does not necessarily balance with the total pieces or commodity pieces entered during bill entry.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * Indicates whether the shipment contains food or posion. Assumption: A shipment will never contain both.
         * Valid Values:
         * 1 - Neither
         * 2 - Food
         * 3 -  Poison
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * Identifies the number of moves or lifts made with a forklift or a pallet jack to move freight without manual intervention by the driver. This count may be equal to or less than the number of pieces in the shipment.  This is used by the costing system.
         * Source : MBF root -  MBMTRPCS
         * Required: false
         * Array: false
         */
        this.motorizedPiecesCount = undefined;
        /**
         * Indicates if the shipment is under the Con-Way Guaranteed Service Program.
         * Values : Y/N
         * Source : MBF, E-commerce
         * Required: false
         * Array: false
         */
        this.guaranteedInd = undefined;
        /**
         * Shipment Destination Postal Code
         * Required: false
         * Array: false
         */
        this.destPostalCd = undefined;
        /**
         * Total weight of all the freight being moved as a unit.  If this is a  Mother  bill then this is the total of all of the  Daughter  bills.
         * Any rating weight allowances or variations (AW, DW, RW, NW) are not included.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Source : MBF: root: MBTOTWT
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         * Total pieces from all commodities in the shipment.
         * This can be derived from the individual commodities, but besides performance, there is a timing issue as well. SMART needs the information when freight is loaded on the trailer (TCON) and it may happen before the bill has been entered into the system.
         * Source : MBF: root: MBTOTPCS
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         * Indicates whether or not a shipment includes  any commodities with hazardous materials. It is a denormalized attribute for performance puposes.
         * Valid Values : Y/N
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether shipment requires special handling to prevent freezing during harsh weather.
         * Ideally, it should be specified at the commodity level, but has been de-normalized for Shipment, since that is level at which it is currently captured
         * Source: MBF root - MBFZB (x 08  of MBTRAFIC)
         * Valid Values : Y/N
         * Y - Can be damaged by freezing
         * Required: false
         * Array: false
         */
        this.freezableInd = undefined;
        /**
         * The volume of the freight; derived from the dimensions captured by driver, or entered by a CSR or dock worker for an SL  (Shipper Load and Count), or from one of a variety of profiles. For details, see the description of CFT_PRFL_MTHD_CD.
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * Total Number of Pallets in the Shipment
         * Required: false
         * Array: false
         */
        this.totalPalletsCount = undefined;
        /**
         * This indicates whether MTRZD_PCS_CNT is known or applicable..
         * Valid Values:
         * Y - Yes, MTRZD_PCS_CNT is known/applicable
         * N - No, MTRZD_PCS_CNT is NOT known/applicable
         * Source:  FBES
         * Required: false
         * Array: false
         */
        this.motorizedPiecesKnownInd = undefined;
        /**
         * Date and time, when the last movement for this shipment  occurred. This is a denormalized attribute from the MOVEMENT entity.
         * Source: MBF - MBMVTM
         * Required: false
         * Array: false
         */
        this.lastMovementDateTime = undefined;
        /**
         * Defines the specific type of service provided for a shipment.
         * Values:  1 - Normal LTL, 2 - Con-Way Deferred Express.
         * Required: false
         * Array: false
         */
        this.serviceTypeCd = undefined;
        /**
         * This indicates whether this was the only shipment that we acquired from the customer at the time that we received this one.
         * Required: false
         * Array: false
         */
        this.singleShipmentAcquiredInd = undefined;
        /**
         * This code identifies the method in which Con-way received the freight from the customer.
         * Current values are:
         * PU Regular Pickup:  This is when the driver goes to the customer dock and loads the shipment on the trailer to return to the service center.
         * HL Hook Loaded: This is when the driver goes to the customer site and picks up a loaded trailer that this shipment was on.
         * DD Dock Drop:  This is when the customer delivers the shipment to a Con-way service center, so a driver didn't go to the customer site.
         * Required: false
         * Array: false
         */
        this.shipmentAcquiredTypeCd = undefined;
        /**
         * The service center where the last movement event for the shipment happened and was reported.
         * Required: false
         * Array: false
         */
        this.lastMoveRptgSicCd = undefined;
        /**
         * The list of Dimensions for the shipment.
         * Required: false
         * Array: true
         */
        this.dimensions = undefined;
        /**
         * The details for the shipper of the shipment.
         * Required: false
         * Array: false
         */
        this.shipperParty = undefined;
        /**
         * The destination service center identification code.
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * The volume of the shipment expressed as the percentage of a full pup (28 feet long trailer).
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         * The method used to calculate the volume of the freight (TOT_VOL_CFT).
         * Values:
         * ACTL - Actual dimensions captured by the driver (length x width x height)
         * DEST - Shipper profile for the shipment?s destination ZIP (average shipment volume when the shipper ships to that ZIP)
         * DFLT - Default shipper profile (average shipment volume for shipper regardless of ZIP)
         * SIC - Service center profile (average shipment volume across all shipments at that SIC)
         * SYS - System profile (average shipment volume across all shipments in LTL)
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileMthdCd = undefined;
        /**
         * If a default or destination shipper profile was used to calculate the volume of the freight, this field describes the type of shipper profile used.
         * Values:
         * FTPRNT - Footprint piece profile
         * VOLSHP - Volume-shipment
         * VOLPCE - Volume-piece
         * DNSITY - Density shipment
         * HEIGHT - Height piece
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileTypeCd = undefined;
        /**
         * Identifies whether a shipper loaded a trailer, and if so, where Con-way took possession of trailer.
         * Values:
         * N Shipper did not load trailer (default)
         * H Hook loaded; a trailer is loaded by shipper and picked up by Con-way at shipper s site
         * D Dock Drop; a trailer is loaded by shipper and dropped at Con-way dock by shipper
         * Required: false
         * Array: false
         */
        this.shipperLoadedTrlrCd = undefined;
        /**
         * The unique identifier for the BOL request that is associated with this shipment.
         * Required: false
         * Array: false
         */
        this.bolInstId = undefined;
        /**
         * Indicates whether the shipment could not be picked up in time (due to late tender by shipper) to make service.
         * Values: Y - Late Tender; N - Not a Late Tender
         * Required: false
         * Array: false
         */
        this.lateTenderCd = undefined;
        /**
         * The date and time when the driver arrived at the customer location.
         * Required: false
         * Array: false
         */
        this.customerLocationArrivalDateTime = undefined;
        /**
         * Indicates that the PRO is exempted to be tracked via piece level.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         * An explanation of why a PRO is exempted from piece level tracking.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionReason = undefined;
    }
}
/**
 * Information about the shipments on a trailer.
 */
class ShipmentsOnTrailer {
    constructor() {
        /**
         * The business identifier for a shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Unique Id of the Pickup Request
         * Required: false
         * Array: false
         */
        this.pickupRequestInstId = undefined;
        /**
         * Sequence Number of the Pickup Request Line Item under one unique id
         * Required: false
         * Array: false
         */
        this.pickupRequestSequenceNbr = undefined;
        /**
         * The destination SIC of the shipment.
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * The total weight of the shipment.
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         * The hazmat indicator of the shipment.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
        /**
         * Indicates whether the shipment contains food or posion.
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * Information about the hazmat commodities of a shipment.
         * Required: false
         * Array: true
         */
        this.hazMats = undefined;
        /**
         * The handling units of a shipment.
         * Required: false
         * Array: true
         */
        this.handlingUnits = undefined;
        /**
         * Indicates whether all Handling Units are on board the same trailer.
         * Required: false
         * Array: false
         */
        this.completeShipmentInd = undefined;
        /**
         * Indicates whether the parent PRO is loaded indirectly from a child PRO which is traveling without its respective parent PRO.
         * Required: false
         * Array: false
         */
        this.indirectlyLoadedInd = undefined;
    }
}
/**
 * The shipper of the Shipment, Handling Unit, or Pickup Request.
 */
class Shipper {
    constructor() {
        /**
         * The first part of the shipper's name.
         * Required: false
         * Array: false
         */
        this.name1 = undefined;
        /**
         * The second part of the shipper's name.
         * Required: false
         * Array: false
         */
        this.name2 = undefined;
        /**
         * The address provided by the shipper.
         * Required: false
         * Array: false
         */
        this.address = undefined;
        /**
         * The city for the shipper's address.
         * Required: false
         * Array: false
         */
        this.city = undefined;
        /**
         * The state code for the shipper's address.
         * Required: false
         * Array: false
         */
        this.stateCd = undefined;
        /**
         * The country code for the shipper's address.
         * Required: false
         * Array: false
         */
        this.countryCd = undefined;
        /**
         * The six digit zip code for the shipper's address.
         * Required: false
         * Array: false
         */
        this.zip6 = undefined;
        /**
         * The four digit zip code for the shipper's address. This attribute will be missing in some cases.
         * Required: false
         * Array: false
         */
        this.zip4 = undefined;
    }
}
/**
 * Information about access token for the SMART API integration
 */
class SmartApiToken {
    constructor() {
        /**
         * Access Token returned from SMART API Call.
         * Required: false
         * Array: false
         */
        this.access_token = undefined;
        /**
         * When the token expires.
         * Required: false
         * Array: false
         */
        this.expires_in = undefined;
        /**
         * The Type of the token.  (i.e. Bearer)
         * Required: false
         * Array: false
         */
        this.token_type = undefined;
    }
}
/**
 * The summary of the loaded shipments, handling units, or pick up requests. These statistics are used to highlight the combined weight, cube, motor moves, loose pieces, hazmat count, and bill count.
 */
class Statistics {
    constructor() {
        /**
         * The combined weight in pounds for all units.
         * Required: false
         * Array: false
         */
        this.weightLbs = undefined;
        /**
         * The combined cube for all units.
         * Required: false
         * Array: false
         */
        this.cube = undefined;
        /**
         * The number of motor moves for all units.
         * Required: false
         * Array: false
         */
        this.motorMovesCount = undefined;
        /**
         * The number of loose pieces for the PRO number.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
    }
}
/**
 * Information about a suggested door for a route.
 */
class SuggestedDoor {
    constructor() {
        /**
         * The door number on the dock.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The position of the door on the dock.
         * Required: true
         * Array: false
         */
        this.displaySeqNbr = undefined;
        /**
         * The unique identifier of the area.
         * Required: true
         * Array: false
         */
        this.areaInstId = undefined;
        /**
         * The name of the area to which the door belongs.
         * Required: true
         * Array: false
         */
        this.areaName = undefined;
        /**
         * The identifier of the sector to which the door belongs.
         * Required: true
         * Array: false
         */
        this.sectorId = undefined;
        /**
         * The door plan which is related to the active door.
         * Required: false
         * Array: false
         */
        this.doorPlan = undefined;
        /**
         * Information about the trailers assigned to the active door.
         * Required: false
         * Array: true
         */
        this.trailers = undefined;
        /**
         * Information about the routes assigned to the active door.
         * Required: false
         * Array: true
         */
        this.routes = undefined;
        /**
         * Indicates if the door is suggested.
         * Required: true
         * Array: false
         */
        this.suggestedInd = undefined;
        /**
         * The list of door matches that are being suggested (TRAILER, AREA).
         * Required: false
         * Array: true
         */
        this.doorMatchCds = undefined;
    }
}
/**
 * Information for the route assigned to the active door.
 */
class SuggestedDoorRoute {
    constructor() {
        /**
         * The unique identifier of the route.
         * Required: true
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The route prefix.
         * Required: true
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * The route suffix.
         * Required: true
         * Array: false
         */
        this.routeSuffix = undefined;
    }
}
/**
 * Information for the trailer assigned to the active door.
 */
class SuggestedDoorTrailer {
    constructor() {
        /**
         * The unique identifier of the trailer.
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The trailer suffix number.
         * Required: true
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         * The trailer prefix number.
         * Required: true
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         * The status of the trailer equipment.
         * Required: true
         * Array: false
         */
        this.equipmentStatusCd = undefined;
        /**
         * The number of the planned door for the trailer.
         * Required: true
         * Array: false
         */
        this.plannedDoor = undefined;
        /**
         * The length of the trailer in feet.
         * Required: true
         * Array: false
         */
        this.trailerLengthFeet = undefined;
        /**
         * Indicates whether the trailer has liftgate.
         * Required: true
         * Array: false
         */
        this.liftgateInd = undefined;
    }
}
/**
 * The details for an existing door plan that can be associated with new destinations.
 */
class TargetDoorPlan {
    constructor() {
        /**
         * The identifier of the door at the SIC.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The first load point for the destination group to which the door is loading.
         * Required: false
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The farthest load point to which the destination group is loading. This is the service center identification code that is the farthest along the load leg path to the destination SICs.
         * Required: false
         * Array: false
         */
        this.closeToSicCd = undefined;
        /**
         * The current load level of the door plan. E.g. 1 - 99.
         * Required: false
         * Array: false
         */
        this.loadLevelNbr = undefined;
        /**
         * The door plan's close to SIC after the destinations are added to it.
         * Required: false
         * Array: false
         */
        this.newCloseToSicCd = undefined;
        /**
         * The load level of the door plan after the destinations are added to it.
         * Required: false
         * Array: false
         */
        this.newLoadLevelNbr = undefined;
        /**
         * The FAC sector for which the door plan will be created.
         * Required: false
         * Array: false
         */
        this.facSectorNbr = undefined;
    }
}
/**
 * Information about the trailer status.
 */
class Trailer {
    constructor() {
        /**
         * If set to true then Trailer Accuracy check is required
         * Required: false
         * Array: false
         */
        this.accuracyCheckReqdInd = undefined;
        /**
         * Estimated Time of Arrival for the Trailer
         * Required: false
         * Array: false
         */
        this.etaTimestamp = undefined;
        /**
         * Indicates if there is a Head Load on this trailer.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * Name of user and Sic code where the Last Unload was performed on this trailer
         * Required: false
         * Array: false
         */
        this.lastUnloadNameAndSic = undefined;
        /**
         * Date and Time when the last shipment was unloaded from the Trailer
         * Required: false
         * Array: false
         */
        this.lastUnloadTimestamp = undefined;
        /**
         * Unique identifier of the Trailer
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The equipment ID prefix-suffix for the trailer. E.g. 313-3760.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The trailer status.  E.g. Unloading, Loading, Trap, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
        /**
         * Trailer door assignment details.
         * Required: false
         * Array: false
         */
        this.trailerDsrAssignment = undefined;
        /**
         * Indicates whether the trailer is under the Guaranteed by Noon service program.
         * Required: false
         * Array: false
         */
        this.g12Ind = undefined;
        /**
         * Indicates whether the trailer is guaranteed.
         * Required: false
         * Array: false
         */
        this.guaranteedServiceInd = undefined;
        /**
         * Indicates whether the trailer is under the Rapid Remote Service program.
         * Required: false
         * Array: false
         */
        this.rrsInd = undefined;
    }
}
/**
 * Information about trailer close options.
 */
class TrailerCloseOption {
    constructor() {
        /**
         * Indicates whether the Trailer is a Breaker (B), Bypass (BYP), Hold (HLD), or Proper (P).
         * Required: false
         * Array: false
         */
        this.breakOrProperCd = undefined;
        /**
         * Total Distance from Origin Sic to Load Destination SIC
         * Required: false
         * Array: false
         */
        this.distance = undefined;
        /**
         * Farthest commond load leg destination based on loaded shipments on Trailer
         * Required: false
         * Array: false
         */
        this.loadDestinationSicCd = undefined;
        /**
         * The suggested load destination SIC code of the Trailer Load.
         * Required: false
         * Array: false
         */
        this.loadSuggestedSic = undefined;
        /**
         * Number of midnights it will take to go from Origin Sic and Shift to Load Destination Sic
         * Required: false
         * Array: false
         */
        this.midnightOffset = undefined;
        /**
         * The trailer routings assoociated with the close option.
         * Required: false
         * Array: true
         */
        this.trailerRoutings = undefined;
        /**
         * Executes unload shift code at the suggested SIC.
         * Required: false
         * Array: false
         */
        this.unloadShiftCd = undefined;
        /**
         * The farthest common load leg destination based on head loaded shipments on the trailer.
         * Required: false
         * Array: false
         */
        this.headLoadDestinationSic = undefined;
    }
}
/**
 * Shipment information which is used to derive trailer close options.
 */
class TrailerCloseShipment {
    constructor() {
        /**
         * The destination service center identification code of the shipment.
         * Required: false
         * Array: false
         */
        this.destinationTerminalSicCd = undefined;
        /**
         * If the shipment was diverted, then this is the diverted service center identification code.
         * Required: false
         * Array: false
         */
        this.divertSicCd = undefined;
        /**
         * Indicates whether this shipment is freezable.
         * Required: false
         * Array: false
         */
        this.isFreezableInd = undefined;
        /**
         * Indicates whether this shipment is guaranteed.
         * Required: false
         * Array: false
         */
        this.isGuaranteedInd = undefined;
        /**
         * Indicates whether this shipment is hazardous.
         * Required: false
         * Array: false
         */
        this.isHazmatInd = undefined;
        /**
         * Indicates whether this shipment is misloaded.
         * Required: false
         * Array: false
         */
        this.isMisloadInd = undefined;
        /**
         * The business identifier of the shipment that is loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Indicates whether this shipment is head loaded.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
    }
}
/**
 * Information about Trailer Compliance when trailer is Closed
 */
class TrailerCompliance {
    constructor() {
        /**
         * The door number that is assigned from the StepSaver process.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * Set to true when Closed trailer has Guaranteed or Premium shipments and the Google Vision Model identifies them as Guaranteed or Premium based on the wrapping.
         * Required: false
         * Array: false
         */
        this.complianceInd = undefined;
        /**
         * Validation Message
         * Required: false
         * Array: false
         */
        this.message = undefined;
    }
}
/**
 * Information about the content of a trailer.
 */
class TrailerContent {
    constructor() {
        /**
         * The door number that is assigned from the StepSaver process.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The code associated with the country for the trailer.
         * Required: false
         * Array: false
         */
        this.trailerCountryCd = undefined;
        /**
         * Information about the list of shipments on each trailer.
         * Required: false
         * Array: true
         */
        this.shipmentsOnTrailers = undefined;
    }
}
/**
 * Information to update Trailer Load Status, Door and Remarks
 */
class TrailerLoadStatusDoorRemark {
    constructor() {
        /**
         * The door number at the dock where the trailer is assigned.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The date and time the update was performed. If not supplied, then the current date and time will be used.
         * Required: false
         * Array: false
         */
        this.eventTimestamp = undefined;
        /**
         * The trailer load status. E.g. Arrive, City Arrive, Drop, Empty, Trap, etc.
         * Required: false
         * Array: false
         */
        this.newTrailerStatus = undefined;
        /**
         * Indicates if the user is overriding the status update to Overhead.
         * Required: false
         * Array: false
         */
        this.overheadStatusOverrideInd = undefined;
        /**
         * The shift code. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * Remarks for the trailer load.
         * Required: false
         * Array: false
         */
        this.trailerRemarks = undefined;
        /**
         * Remarks associated with the equipment.
         * Required: false
         * Array: false
         */
        this.equipmentRemarks = undefined;
        /**
         * The validation message for the action performed.
         * Required: false
         * Array: false
         */
        this.validationMessage = undefined;
    }
}
/**
 * Information about the trailer section
 */
class TrailerSection {
    constructor() {
        /**
         * The section number of the trailer.
         * Required: false
         * Array: false
         */
        this.sectionNbr = undefined;
    }
}
/**
 * The cross dock location and details for a PRO number.
 */
class XdockShipmentLocation {
    constructor() {
        /**
         * The unique identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The name of the consignee.
         * Required: false
         * Array: false
         */
        this.consigneeName = undefined;
        /**
         * The MAD code for the consignee.
         * Required: false
         * Array: false
         */
        this.consigneeMadCd = undefined;
        /**
         * The name of the shipper.
         * Required: false
         * Array: false
         */
        this.shipperName = undefined;
        /**
         * The MAD code for the shipper.
         * Required: false
         * Array: false
         */
        this.shipperMadCd = undefined;
        /**
         * The name of the bill-to.
         * Required: false
         * Array: false
         */
        this.billToName = undefined;
        /**
         * The MAD code for the bill-to.
         * Required: false
         * Array: false
         */
        this.billToMadCd = undefined;
        /**
         * The code associated with the bill-to status.
         * Required: false
         * Array: false
         */
        this.billToStatusCd = undefined;
        /**
         * The service center identification code for the origin.
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The service center identification code for the destination.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * The total weight of the shipment in pounds.
         * Required: false
         * Array: false
         */
        this.totalWeightLbs = undefined;
        /**
         * The total volume of the shipment in cubic feet.
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * The total number of pieces for the shipment.
         * Required: false
         * Array: false
         */
        this.totalPiecesCount = undefined;
        /**
         * The number of motorized pieces for the shipment.
         * Required: false
         * Array: false
         */
        this.motorizedPiecesCount = undefined;
        /**
         * The number of loose pieces for the shipment.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * Indicates whether a PRO has more than five commodities.
         * Required: false
         * Array: false
         */
        this.moreCommodityInd = undefined;
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Indicates whether inspection correction is required.
         * Required: false
         * Array: false
         */
        this.inspectionCorrectionInd = undefined;
        /**
         * Indicates whether the shipment is at the SIC.
         * Required: false
         * Array: false
         */
        this.shipmentAtSicInd = undefined;
        /**
         * The estimated time of arrival timestamp for the PRO.
         * Required: false
         * Array: false
         */
        this.etaDateTime = undefined;
        /**
         * The service center identification code for the schedule destination.
         * Required: false
         * Array: false
         */
        this.scheduleDestinationSicCd = undefined;
        /**
         * The loading door for the PRO.
         * Required: false
         * Array: false
         */
        this.loadDoor = undefined;
        /**
         * The break door for the PRO.
         * Required: false
         * Array: false
         */
        this.breakDoor = undefined;
        /**
         * The code associated with the status of trailer into which the PRO was loaded.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The number of the trailer into which the PRO was loaded.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The location of the PRO.
         * Required: false
         * Array: false
         */
        this.shipmentLocation = undefined;
        /**
         * The debtor pricing value.
         * Required: false
         * Array: false
         */
        this.debtorPricing = undefined;
        /**
         * The code which represents the results of a specific delivery activity.
         * Required: false
         * Array: false
         */
        this.deliveryQualifierCd = undefined;
        /**
         * The commodity class of the PRO for up to five PROs.
         * Required: false
         * Array: false
         */
        this.commodityClass = undefined;
        /**
         * The NMFC of the PRO for up to five PROs.
         * Required: false
         * Array: false
         */
        this.commodityNmfc = undefined;
        /**
         * The description of the PRO is concatenated for up to five PROs.
         * Required: false
         * Array: false
         */
        this.commodityDescription = undefined;
        /**
         * The unique identifier for the pricing agreement.
         * Required: false
         * Array: false
         */
        this.agreementInstId = undefined;
        /**
         * A system assigned sequential number to uniquely identify each rule set.
         * Required: false
         * Array: false
         */
        this.ruleSetSequenceNbr = undefined;
    }
}
/**
 * Request to activate an existing default Door Plan Profile.
 */
class ActivateDoorPlanProfileRqst {
    constructor() {
        /**
         * System Generated Unique Identifier.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The service center identification code to which the door plan profile belongs.
         * Required: false
         * Array: false
         */
        this.sicCode = undefined;
        /**
         * The shift code for which the door plan profile will be activated.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The unique name assigned to the profile.
         * Required: false
         * Array: false
         */
        this.profileName = undefined;
    }
}
/**
 * Response to the request to activate an existing default Door Plan Profile.
 */
class ActivateDoorPlanProfileResp {
    constructor() {
        /**
         * The DoorPlanProfile record that was activated.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 * Request to backsynch a door plan profile to legacy tables in DB2.
 */
class BacksynchDoorPlanProfileToDb2Rqst {
    constructor() {
        /**
         * The unique identifier of the DoorPlanProfile.
         * Required: false
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The service center identification code to which the door plan profile belongs.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door plan profile will be activated.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The unique name assigned to the profile.
         * Required: false
         * Array: false
         */
        this.profileName = undefined;
    }
}
/**
 * Response to the request to backsynch a door plan profile to legacy tables in DB2
 */
class BacksynchDoorPlanProfileToDb2Resp {
    constructor() {
        /**
         * The DoorPlanProfile record that was created.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
        /**
         * The DoorPlan records that were created in legacy tables.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
        /**
         * The DoorAssignment records that were created in legacy tables.
         * Required: false
         * Array: true
         */
        this.doorAssignments = undefined;
    }
}
/**
 * Path parameters which are used to create the weekly default door plan.
 */
class CreateActiveDoorPlanForSicPath {
    constructor() {
        /**
         * The service center identification code associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift for which the active door plan will be created.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to create the weekly default door plan.
 */
class CreateActiveDoorPlanForSicRqst {
    constructor() {
        /**
         * Details about the list of door plans to be added to the profile.
         * Required: true
         * Array: true
         */
        this.doorPlans = undefined;
    }
}
/**
 * Response to the request to create the weekly default door plan.
 */
class CreateActiveDoorPlanForSicResp {
    constructor() {
        /**
         * The active door plan that was created along with the SIC, shift, and list of profiles.
         * Required: false
         * Array: true
         */
        this.doorPlanProfiles = undefined;
    }
}
/**
 * Path parameter which is used to create a door plan for a door.
 */
class CreateDoorPlanPath {
    constructor() {
        /**
         * The unique identifer of the door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 * Request to create a door plan for a door.
 */
class CreateDoorPlanRqst {
    constructor() {
        /**
         * The door plan to be created.
         * Required: true
         * Array: false
         */
        this.doorPlan = undefined;
        /**
         * If set to true, then any previous warnings have been overriden and door plan updates will be created.  Otherwise validation is performed if door plans can be created.
         * Required: false
         * Array: false
         */
        this.confirmActionInd = undefined;
    }
}
/**
 * Response to the request to create a door plan for a door.
 */
class CreateDoorPlanResp {
    constructor() {
        /**
         * The list of all door plans.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
        /**
         * The details for the warning message.
         * Required: false
         * Array: false
         */
        this.warningMessage = undefined;
    }
}
/**
 *
 */
class CreateDoorPlanDestinationsPath {
    constructor() {
        /**
         * The unique identifier of the door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The door number at the SIC.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 *
 */
class CreateDoorPlanDestinationsRqst {
    constructor() {
        /**
         * The list of door plan destinations to be added.
         * Required: true
         * Array: true
         */
        this.doorPlanDestinations = undefined;
        /**
         * If set to false, then if the door plan results in a new close to SIC with new destinations then a warning message will be sent back to the consumer.  If set to true, then this will be ignored and destinations will be added to the door plan.
         * Required: false
         * Array: false
         */
        this.overrideCloseToWarningInd = undefined;
    }
}
/**
 *
 */
class CreateDoorPlanDestinationsResp {
    constructor() {
        /**
         * The list of door plans and their associated destinations which were created.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
        /**
         * The list of validation messages.
         * Required: false
         * Array: true
         */
        this.validationMessages = undefined;
        /**
         * The new close to SIC when new destinations will be added to the door plan.
         * Required: false
         * Array: false
         */
        this.newCloseToSicCd = undefined;
    }
}
/**
 * Path parameters used to create a door plan profile.
 */
class CreateDoorPlanProfilePath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door plan profile will be created.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to create a door plan profile.
 */
class CreateDoorPlanProfileRqst {
    constructor() {
        /**
         * The unique name assigned to the profile.
         * Required: true
         * Array: false
         */
        this.profileName = undefined;
        /**
         * The door plan profile type.  Permitted values: CURRENT or DEFAULT (default value).
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         * The list of door plans associated with the profile.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
    }
}
/**
 * Response to the request to create a door plan profile.
 */
class CreateDoorPlanProfileResp {
    constructor() {
        /**
         * The door plan profile that was created.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 *
 */
class CreateLoadLanesByDockPlanPath {
    constructor() {
        /**
         * The code associated with the shift for which the Load Lanes will be derived.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 *
 */
class CreateLoadLanesByDockPlanRqst {
    constructor() {
        /**
         * The plan date for which the shipments will be retrieved. If one isn't supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The weight threshold to use when deriving pup count. E.g. 16000, 18000, etc.
         * Required: false
         * Array: false
         */
        this.thresholdWeight = undefined;
        /**
         * The cube percentage threshold to use when deriving pup count. E.g. 80, 90, 85, etc.
         * Required: false
         * Array: false
         */
        this.thresholdCubePct = undefined;
        /**
         * Indicates whether only the deep load lanes along with their current door plans are returned.  This can only be used when the plan date is equal to today's date.
         * Required: false
         * Array: false
         */
        this.includeOptimalLoadLanesInd = undefined;
        /**
         * Indicates whether the active door plan data for the matching load lanes or destination is returned.  This can only be used when the plan date is equal to today's date.
         * Required: false
         * Array: false
         */
        this.includeDoorPlanInd = undefined;
        /**
         * Indicates whether shipments that are remaining to be loaded will be included to derive the load lanes.  If set to false, then all the shipments are included.
         * Required: false
         * Array: false
         */
        this.remainingToLoadShipmentsInd = undefined;
        /**
         * Indicates whether to include shipments in the Load Lane Destinations response.
         * Required: false
         * Array: false
         */
        this.includeShipmentsInd = undefined;
    }
}
/**
 *
 */
class CreateWeeklyDefaultDoorPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door plan profile will be created.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class CreateWeeklyDefaultDoorPlanRqst {
    constructor() {
        /**
         * The day of the week for which to create the door plan.  Permitted values: Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, and Saturday.
         * Required: false
         * Array: false
         */
        this.dayOfWeekCd = undefined;
        /**
         * Indicates whether the Door Plan created should be activated immediately.
         * Required: false
         * Array: false
         */
        this.activateDoorPlanInd = undefined;
    }
}
/**
 *
 */
class CreateWeeklyDefaultDoorPlanResp {
    constructor() {
        /**
         * The door plan profile that was created.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 * Path parameters used to delete a door plan.
 */
class DeleteDoorPlanPath {
    constructor() {
        /**
         * The system generated unique identifer for the profile to which the door plan belongs.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The number associated with the door at the SIC.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 * Query parameter which is used to delete a door plan.
 */
class DeleteDoorPlanQuery {
    constructor() {
        /**
         * If set to true, then the door plan warning message is overriden by the user.  Otherwise validation is performed if door plans can be removed.
         * Required: false
         * Array: false
         */
        this.confirmActionInd = undefined;
    }
}
/**
 * Response to the request to delete a door plan.
 */
class DeleteDoorPlanResp {
    constructor() {
        /**
         * The details for the warning message.
         * Required: false
         * Array: false
         */
        this.warningMessage = undefined;
    }
}
/**
 * Path parameter used to delete a door plan profile.
 */
class DeleteDoorPlanProfilePath {
    constructor() {
        /**
         * The uniqued identifier of the Door Plan Profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 *
 */
class DeriveLoadLanesByDockPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the Load Lanes will be derived.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class DeriveLoadLanesByDockPlanQuery {
    constructor() {
        /**
         * The list of plan dates for which the shipments will be retrieved. If one isn't supplied, then the current date will be used.
         * Required: false
         * Array: true
         */
        this.planDates = undefined;
        /**
         * The weight threshold to use when deriving pup count. E.g. 16000, 18000, etc.
         * Required: false
         * Array: false
         */
        this.thresholdWeight = undefined;
        /**
         * The cube percentage threshold to use when deriving pup count. E.g. 80, 90, 85, etc.
         * Required: false
         * Array: false
         */
        this.thresholdCubePct = undefined;
        /**
         * This can only be used when the plan date is equal to today's date.  When set to true, only the deep load lanes along with their current door plans are returned.
         * Required: false
         * Array: false
         */
        this.includeOptimalLoadLanesInd = undefined;
        /**
         * This can only be used when the plan date is equal to today's date.  When set to true the ACTIVE door plan data for the matching load lanes or destination is returned.
         * Required: false
         * Array: false
         */
        this.includeDoorPlanInd = undefined;
        /**
         * Indicates whether shipments that are remaining to be loaded will be included to derive the load lanes.  If set to false, then all the shipments are included.
         * Required: false
         * Array: false
         */
        this.remainingToLoadShipmentsInd = undefined;
        /**
         * Indicates whether to include shipments in the Load Lane Destinations response.
         * Required: false
         * Array: false
         */
        this.includeShipmentsInd = undefined;
        /**
         * Indicates whether the data is being retrieved from the bypass model or from the standard LoadLanes process.
         * Required: false
         * Array: false
         */
        this.bypassModelInd = undefined;
        /**
         * Indicates whether the optimal lanes should be derived from the loaded shipments at the designated SIC and shift.
         * Required: false
         * Array: false
         */
        this.deriveFromLoadedShipmentsInd = undefined;
        /**
         * The van weight threshold to use when deriving pup count. E.g. 16000, 18000, etc.
         * Required: false
         * Array: false
         */
        this.vanThresholdWeight = undefined;
        /**
         * The van cube percentage threshold to use when deriving pup count. E.g. 80, 90, 85, etc.
         * Required: false
         * Array: false
         */
        this.vanThresholdCubePercentage = undefined;
    }
}
/**
 *
 */
class DeriveLoadLanesByDockPlanResp {
    constructor() {
        /**
         * The list of Load Lanes (move-to and close-to combination for the shipments in the Plan).
         * Required: false
         * Array: true
         */
        this.loadLanes = undefined;
    }
}
/**
 * Path parameter which is used to retrieve an active door plan.
 */
class GetActiveDoorPlanPath {
    constructor() {
        /**
         * The service center identification code associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift for which the active door plan is requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Response to the request to retrieve an active door plan.
 */
class GetActiveDoorPlanResp {
    constructor() {
        /**
         * The door plan profile associated with the input criteria.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 *
 */
class GetDestinationsByLoadLanePath {
    constructor() {
        /**
         * The origin location service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code associated with the door plan.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The move to service center identificaiton code from the door plan.
         * Required: true
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The close to service center identification code from the door plan.
         * Required: true
         * Array: false
         */
        this.closeToSicCd = undefined;
    }
}
/**
 *
 */
class GetDestinationsByLoadLaneResp {
    constructor() {
        /**
         * Information about the freight flow path and destinations for a given lane.
         * Required: false
         * Array: true
         */
        this.loadLanes = undefined;
    }
}
/**
 * Path parameter which is used to retrieve a door plan by its profile ID.
 */
class GetDoorPlanByIdPath {
    constructor() {
        /**
         * The system generated unique identifier for a door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 * Response to the request to retrieve a door plan by its profile ID.
 */
class GetDoorPlanByIdResp {
    constructor() {
        /**
         * The door plan profile associated with the input criterion.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 * Path parameters which are used to retrieve the door plan merge options.
 */
class GetDoorPlanMergeOptionsPath {
    constructor() {
        /**
         * The service center identification code associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift for which the active door plan is requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The number associated with the door at the SIC dock.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 * Query parameter which is used to rerieve the door plan merge options.
 */
class GetDoorPlanMergeOptionsQuery {
    constructor() {
        /**
         * The type of door plan profile, which is used identify the merge options.  Permitted values: CURRENT or DEFAULT (default value).
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
    }
}
/**
 * Response to the request to retrieve door plans to which a door can be merged.
 */
class GetDoorPlanMergeOptionsResp {
    constructor() {
        /**
         * The Door Plan for the door number provided.
         * Required: false
         * Array: false
         */
        this.fromDoorPlan = undefined;
        /**
         * The Door Plans to which the from door can be merged.
         * Required: false
         * Array: true
         */
        this.mergeToDoorPlans = undefined;
    }
}
/**
 * Path parameters used to retrieve a door plan profile.
 */
class GetDoorPlanProfilePath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The door plan profile type.  Permitted values: CURRENT or DEFAULT (default value).
         * Required: true
         * Array: false
         */
        this.profileTypeCd = undefined;
    }
}
/**
 * Response to the request to retrieve a door plan profile.
 */
class GetDoorPlanProfileResp {
    constructor() {
        /**
         * The door plan profile associated with the input criteria.
         * Required: false
         * Array: false
         */
        this.doorPlanProfile = undefined;
    }
}
/**
 *
 */
class GetLoadLaneSummaryByPlanSicAndShiftPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: Inbound, Outbound, DayReship, and NightFAC.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetLoadLaneSummaryByPlanSicAndShiftQuery {
    constructor() {
        /**
         * The plan date for which the lane summary will be retrieved.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The unique identifier of the load lane summary header.
         * Required: false
         * Array: false
         */
        this.headerId = undefined;
        /**
         * The load lane summary detail sequence number for the load lane summary header.
         * Required: false
         * Array: false
         */
        this.detailId = undefined;
    }
}
/**
 *
 */
class GetLoadLaneSummaryByPlanSicAndShiftResp {
    constructor() {
        /**
         * The load lanes for the plan SIC and shift.
         * Required: false
         * Array: true
         */
        this.loadLanes = undefined;
        /**
         * The unique identifier of the model run which is associated with the lane summary.
         * Required: false
         * Array: false
         */
        this.runId = undefined;
        /**
         * The unique identifier of the Lane Summary Header record.
         * Required: false
         * Array: false
         */
        this.laneSummaryHeaderId = undefined;
        /**
         * The execution timestamp of the model run which is associated with the lane summary.
         * Required: false
         * Array: false
         */
        this.runDateTime = undefined;
    }
}
/**
 *
 */
class ListDockShipmentSummariesPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class ListDockShipmentSummariesQuery {
    constructor() {
        /**
         * The plan date for which the shipments will be retrieved. If one isn't supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The code associated with the door plan profile type.  Permitted values: Default, Static, and Current (default value).
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
    }
}
/**
 *
 */
class ListDockShipmentSummariesResp {
    constructor() {
        /**
         * The list of dock shipment summaries for the list of shipments that are included in the dock plan, by SIC and shift, that matched the filter criteria.
         * Required: false
         * Array: true
         */
        this.dockShipmentSummaries = undefined;
    }
}
/**
 *
 */
class ListDoorPlanHeadloadDestinationsPath {
    constructor() {
        /**
         * The unique identifier of the door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The door number at the dock.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 *
 */
class ListDoorPlanHeadloadDestinationsQuery {
    constructor() {
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListDoorPlanHeadloadDestinationsResp {
    constructor() {
        /**
         * The list of headload destinations that matched the filter criteria.
         * Required: false
         * Array: true
         */
        this.headloadDestinations = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Path parameter which is used to list door plan profiles.
 */
class ListDoorPlanProfilesPath {
    constructor() {
        /**
         * The service center identification code associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Query parameters which are used to list of door plan profiles
 */
class ListDoorPlanProfilesQuery {
    constructor() {
        /**
         * The code associated with the shift for which the door plan profiles will be listed.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The door plan profile type.  Permitted values: CURRENT or DEFAULT (default value).
         * Required: false
         * Array: false
         */
        this.profileTypeCd = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list door plan profiles.
 */
class ListDoorPlanProfilesResp {
    constructor() {
        /**
         * The list of door plan profile associated with the input criteria.
         * Required: false
         * Array: true
         */
        this.doorPlanProfiles = undefined;
    }
}
/**
 *
 */
class ListDoorPlanRecommendationsPath {
    constructor() {
        /**
         * The system generated unique identifier for a door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 *
 */
class ListDoorPlanRecommendationsQuery {
    constructor() {
        /**
         * Indicates whether the recommendations returned are from required changes instead of just recommendations.
         * Required: false
         * Array: false
         */
        this.requiredChangesInd = undefined;
    }
}
/**
 *
 */
class ListDoorPlanRecommendationsResp {
    constructor() {
        /**
         * The list of door plan recommendations.
         * Required: false
         * Array: true
         */
        this.doorPlanRecommendations = undefined;
    }
}
/**
 *
 */
class ListHeadloadDestinationsByDoorPlanProfilePath {
    constructor() {
        /**
         * The unique identifier for the Door Plan Profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 *
 */
class ListHeadloadDestinationsByDoorPlanProfileQuery {
    constructor() {
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListHeadloadDestinationsByDoorPlanProfileResp {
    constructor() {
        /**
         * The list of headload lanes.
         * Required: false
         * Array: true
         */
        this.headloads = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListHeadLoadShipmentsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the type of shift at the service center.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class ListHeadLoadShipmentsQuery {
    constructor() {
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The identifier of the door at the SIC.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 *
 */
class ListHeadLoadShipmentsResp {
    constructor() {
        /**
         * The list of Door Plans and their associated head-load shipments.
         * Required: false
         * Array: true
         */
        this.doorPlanShipments = undefined;
    }
}
/**
 *
 */
class ListTargetDoorPlansForDestinationsPath {
    constructor() {
        /**
         * The unique identifier of the Door Plan Profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 *
 */
class ListTargetDoorPlansForDestinationsQuery {
    constructor() {
        /**
         * The list of service center identification codes for the destinations.
         * Required: true
         * Array: true
         */
        this.destinationSicCds = undefined;
    }
}
/**
 *
 */
class ListTargetDoorPlansForDestinationsResp {
    constructor() {
        /**
         * The list of door plans that are grouped by the destinations.
         * Required: false
         * Array: true
         */
        this.targetDoorPlans = undefined;
    }
}
/**
 *
 */
class RepairDoorPlanProfilePath {
    constructor() {
        /**
         * The system generated unique identifier for a door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 *
 */
class RepairDoorPlanProfileRqst {
    constructor() {
        /**
         * Indicates whether any errors during the door plan update process have been overridden by the user.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
    }
}
/**
 * Path parameters used to revert a door plan.
 */
class RevertDoorPlansPath {
    constructor() {
        /**
         * The system generated unique identifer for the profile to which the door plan belongs.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
    }
}
/**
 * Request payload to revert door plans to default value
 */
class RevertDoorPlansRqst {
    constructor() {
        /**
         * The number associated with the door at the SIC.
         * Required: false
         * Array: true
         */
        this.doorNbrs = undefined;
        /**
         * If set to true then all door plans will be reverted to default
         * Required: false
         * Array: false
         */
        this.revertAllDoorsInd = undefined;
    }
}
/**
 * Response to the request to revert a door plan.
 */
class RevertDoorPlansResp {
    constructor() {
        /**
         * The list of door plans which were updated.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.revertFailedDoors = undefined;
    }
}
/**
 * Path parameters used to update a door plan.
 */
class UpdateDoorPlanPath {
    constructor() {
        /**
         * The system generated unique identifer for the profile to which the door plan belongs.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The number associated with the door at the SIC.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 * Request to update a door plan.
 */
class UpdateDoorPlanRqst {
    constructor() {
        /**
         * The door plan details which will be used to update the existing record.
         * Required: true
         * Array: false
         */
        this.doorPlan = undefined;
    }
}
/**
 * Response to the request to update a door plan.
 */
class UpdateDoorPlanResp {
    constructor() {
        /**
         * The door plan which was updated.
         * Required: false
         * Array: false
         */
        this.doorPlan = undefined;
    }
}
/**
 *
 */
class UpdateDoorPlanHeadloadDestinationsPath {
    constructor() {
        /**
         * The unique identifier of the door plan profile.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The door number at the dock.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 *
 */
class UpdateDoorPlanHeadloadDestinationsRqst {
    constructor() {
        /**
         * The list of headload destinations that were updated.
         * Required: true
         * Array: true
         */
        this.headloadDestinations = undefined;
    }
}
/**
 * Path parameters used to update a door plan by action code.
 */
class UpdateDoorPlansByActionPath {
    constructor() {
        /**
         * The system generated unique identifer for the profile to which the door plan belongs.
         * Required: true
         * Array: false
         */
        this.doorPlanProfileId = undefined;
        /**
         * The from-door at the SIC.
         * Required: true
         * Array: false
         */
        this.fromDoorNbr = undefined;
        /**
         * The to-door at the SIC.
         * Required: true
         * Array: false
         */
        this.toDoorNbr = undefined;
        /**
         * The type of action to be performed.  Permitted values: Copy, Merge, Move, and Swap.
         * Required: true
         * Array: false
         */
        this.doorPlanActionCd = undefined;
    }
}
/**
 * Request to update the door plans by action code.
 */
class UpdateDoorPlansByActionRqst {
    constructor() {
        /**
         * If set to true then any errors during the door plan update process have been overridden by the user
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * ID of the Supervisor who is authorizing the loading in case of misload
         * Required: false
         * Array: false
         */
        this.supervisorEmplId = undefined;
        /**
         * If set to true then the door plan updates will be applied otherwise validation is performed if door plans can be updated.
         * Required: false
         * Array: false
         */
        this.confirmActionInd = undefined;
    }
}
/**
 * Response to the request to update the door plans by action code.
 */
class UpdateDoorPlansByActionResp {
    constructor() {
        /**
         * The door plans which were updated.
         * Required: false
         * Array: true
         */
        this.doorPlans = undefined;
        /**
         * The details for the warning message.
         * Required: false
         * Array: false
         */
        this.warningMessage = undefined;
    }
}
/**
 * Path parametes used to retrieve door details.
 */
class GetDoorDetailsPath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The door number that will be used to check if there is a trailer.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to retrieve door details.
 */
class GetDoorDetailsQuery {
    constructor() {
        /**
         * The type of dock location. It can be either the door or a bay near the loading door.
         * Required: false
         * Array: false
         */
        this.dockLocationType = undefined;
        /**
         * The unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Response to the request to retrieve door details.
 */
class GetDoorDetailsResp {
    constructor() {
        /**
         * Details about the door at the SIC for the shift provided.
         * Required: false
         * Array: false
         */
        this.dockDoor = undefined;
    }
}
/**
 * Path parameters used to retrieve door setup details.
 */
class GetDoorSetupDetailsPath {
    constructor() {
        /**
         * The location associated with the door
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The door number that will be used to check if there is a trailer.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to retrieve door setup details.
 */
class GetDoorSetupDetailsQuery {
    constructor() {
        /**
         * If set to true, dock door detailed information will be returned. If set to false, only the door plan information will be returned.
         * Required: false
         * Array: false
         */
        this.detailInd = undefined;
        /**
         * The type of dock location. It can be either the door or a bay near the loading door.
         * Required: false
         * Array: false
         */
        this.dockLocationType = undefined;
        /**
         * The uique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * If set to true then PRO Summary for the trailer will be provided in the response
         * Required: false
         * Array: false
         */
        this.summarizeProsOnTrailerInd = undefined;
    }
}
/**
 * Response to the request to retrieve door setup details.
 */
class GetDoorSetupDetailsResp {
    constructor() {
        /**
         * The door details about the dock door at the SIC for the shift provided.
         * Required: false
         * Array: false
         */
        this.dockDoorTrailer = undefined;
    }
}
/**
 * Path parameters which are used to list dock door preferences.
 */
class ListDockDoorPreferencesPath {
    constructor() {
        /**
         * The service center identification code associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift for which the dock door preferences will be listed.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The door plan profile type.  Permitted values: CURRENT or DEFAULT (default value).
         * Required: true
         * Array: false
         */
        this.profileTypeCd = undefined;
    }
}
/**
 * Query parameters which are used to list dock door preferences.
 */
class ListDockDoorPreferencesQuery {
    constructor() {
        /**
         * The list of codes associated with the door preference types.
         * Required: false
         * Array: true
         */
        this.doorPreferenceTypeCds = undefined;
        /**
         * Pagination information to retrieve the list
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Reponse to the request to list dock door preferences.
 */
class ListDockDoorPreferencesResp {
    constructor() {
        /**
         * Door Preferences
         * Required: false
         * Array: true
         */
        this.doorPreferences = undefined;
        /**
         * Pagination information to retrieve the list
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Path parameters used to list the doors for the dock walk.
 */
class ListDoorsForDockWalkPath {
    constructor() {
        /**
         * The location associated with the doors.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to list the doors for the dock walk.
 */
class ListDoorsForDockWalkQuery {
    constructor() {
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The number associated with the sector which is used to filter the list of doors.
         * Required: false
         * Array: false
         */
        this.sectorNbr = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list the doors for the dock walk.
 */
class ListDoorsForDockWalkResp {
    constructor() {
        /**
         * The unique identifier of the XDock Plan.
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         * The list of details for the doors for the dock walk.
         * Required: false
         * Array: true
         */
        this.dockWalkDoors = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Path parameters to retrieve list of doors for a given lane
 */
class ListDoorsForLanePath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to list doors for a given lane
 */
class ListDoorsForLaneQuery {
    constructor() {
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The SIC of the next location on the lane.
         * Required: false
         * Array: false
         */
        this.nextSicCd = undefined;
        /**
         * The SIC of the destination location.
         * Required: false
         * Array: false
         */
        this.destSicCd = undefined;
        /**
         * The postal code of the destination location.
         * Required: false
         * Array: false
         */
        this.postalCd = undefined;
        /**
         * The plan date for which to retrieve the doors. If not supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeId = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response message for ListDoorsForDockWalk
 */
class ListDoorsForLaneResp {
    constructor() {
        /**
         * The unique identifier of the XDock Plan.
         * Required: false
         * Array: false
         */
        this.planInstId = undefined;
        /**
         * The list of doors for the lane.
         * Required: false
         * Array: true
         */
        this.laneDoors = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class MaintainDockDoorPreferencesRqst {
    constructor() {
        /**
         * The list of Door Preferences which will be used to perform the upsert.
         * Required: true
         * Array: true
         */
        this.doorPreferences = undefined;
    }
}
/**
 *
 */
class MaintainDockDoorPreferencesResp {
    constructor() {
        /**
         * The Door Preferences which were upserted.
         * Required: false
         * Array: true
         */
        this.doorPreferences = undefined;
    }
}
/**
 * Request to create a new dock location.
 */
class CreateDockLocationRqst {
    constructor() {
        /**
         * Dock location details which will be used to be create the record.
         * Required: true
         * Array: false
         */
        this.dockLocation = undefined;
    }
}
/**
 * Response to the request to create a new dock location.
 */
class CreateDockLocationResp {
    constructor() {
        /**
         * Dock location details which were used to create the record.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
    }
}
/**
 * Path parameter used to delete a dock location.
 */
class DeleteDockLocationPath {
    constructor() {
        /**
         * The unique identifier of the dock location.
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
    }
}
/**
 * Path parameter used to retrieve a dock location.
 */
class GetDockLocationPath {
    constructor() {
        /**
         * The unique identifier of the dock location.
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
    }
}
/**
 * Response to the request to return details for a dock location.
 */
class GetDockLocationResp {
    constructor() {
        /**
         * The dock location associated with the unique identifier provided.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
    }
}
/**
 * Query parameters used to list dock locations.
 */
class ListDockLocationsQuery {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The name of the dock location.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the requst to list dock locations at a given service center.
 */
class ListDockLocationsResp {
    constructor() {
        /**
         * A list of dock locations that match the input critria.
         * Required: false
         * Array: true
         */
        this.dockLocations = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListShipmentsInDockLocationPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class ListShipmentsInDockLocationQuery {
    constructor() {
        /**
         * The name of the dock location.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * The unique identifier of the dock location.
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
        /**
         * Indicates whether the information for all of the handling units should be sent.
         * Required: false
         * Array: false
         */
        this.sendAllHandlingUnitsInd = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListShipmentsInDockLocationResp {
    constructor() {
        /**
         * Details about the dock location.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
        /**
         * The list of shipments that are in the dock location.
         * Required: false
         * Array: true
         */
        this.dockShipments = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Path parameter used to update a dock location.
 */
class UpdateDockLocationRemarksPath {
    constructor() {
        /**
         * The unique identifier of the dock location.
         * Required: true
         * Array: false
         */
        this.dockInstId = undefined;
    }
}
/**
 * Request to update a dock location.
 */
class UpdateDockLocationRemarksRqst {
    constructor() {
        /**
         * Remarks about the dock location.
         * Required: false
         * Array: false
         */
        this.dockRemarks = undefined;
    }
}
/**
 * Response to the request to update a dock location.
 */
class UpdateDockLocationRemarksResp {
    constructor() {
        /**
         * Dock location details which were used to update the record.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
    }
}
/**
 * Path parameter which is used to assign a list of shipments to a route.
 */
class AssignShipmentsToRoutePath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Request to assign a list of shipments to a route.
 */
class AssignShipmentsToRouteRqst {
    constructor() {
        /**
         * The employee ID of the user that is making the request
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The unique identifier of the current route to which the shipments are assigned.
         * Required: false
         * Array: false
         */
        this.fromRouteInstId = undefined;
        /**
         * Information for the route to which the shipments should be assigned.
         * Required: true
         * Array: false
         */
        this.assignToRoute = undefined;
        /**
         * If set to true, then any warnings will be ignored.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * If set to true, then route details need to be updated in the database.
         * Required: false
         * Array: false
         */
        this.routeDetailsUpdatedInd = undefined;
        /**
         * The list of shipments to be assigned to the route.
         * Required: true
         * Array: true
         */
        this.assignedShipments = undefined;
        /**
         * The door number on the dock that is assigned to this route.
         * Required: false
         * Array: false
         */
        this.assignedDoorNbr = undefined;
        /**
         * The door number on the dock that is closest to the dock location.
         * Required: false
         * Array: false
         */
        this.closestDoorNbr = undefined;
        /**
         * The name of the dock location associated with the route.
         * Required: false
         * Array: false
         */
        this.dockLocationName = undefined;
        /**
         * The trailer equipment prefix-suffix that is assigned to the route.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The KRONOS badge number of the dock worker.
         * Required: false
         * Array: false
         */
        this.employeeBadgeNbr = undefined;
        /**
         * The KRONOS badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
    }
}
/**
 * Response payload to assign a list of shipments to a route
 */
class AssignShipmentsToRouteResp {
    constructor() {
        /**
         * The route that is assigned to the shipments.
         * Required: false
         * Array: false
         */
        this.assignedRoute = undefined;
    }
}
/**
 *
 */
class BulkUpsertHandlingUnitsFromDockRqst {
    constructor() {
        /**
         * The details about the handling units which will be used to create or update the records.
         * Required: true
         * Array: true
         */
        this.handlingUnitShipments = undefined;
        /**
         * The employee identifier of the user.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The service center identification code of the location.
         * Required: false
         * Array: false
         */
        this.requestingSicCd = undefined;
    }
}
/**
 * Path parameters used to return Dock Engineered Standard by location and employee.
 */
class GetCurrentDockEngineeredStandardPath {
    constructor() {
        /**
         * The location associated with the employee.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The unique identifier for the employee.
         * Required: true
         * Array: false
         */
        this.employeeId = undefined;
    }
}
/**
 * Query parameter used to return Dock Engineered Standard by location and employee.
 */
class GetCurrentDockEngineeredStandardQuery {
    constructor() {
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetCurrentDockEngineeredStandardHeader {
    constructor() {
        /**
         * Pass the token to make the call.
         * Required: true
         * Array: false
         */
        this.smartToken = undefined;
    }
}
/**
 * Response to the request to return the Dock Engineered Standard by location and employee.
 */
class GetCurrentDockEngineeredStandardResp {
    constructor() {
        /**
         * The dock worker's current Dock Engineered Standard percentage
         * Required: false
         * Array: false
         */
        this.currentDesPercentage = undefined;
        /**
         * The timestamp for which the DES was calculated in UTC.
         * Required: false
         * Array: false
         */
        this.calculatedDateTimeUtc = undefined;
        /**
         * The current DES percentage for the entire SIC or shift
         * Required: false
         * Array: false
         */
        this.currentSicDesPercentage = undefined;
        /**
         * The employee's DES rank among all employees on current SIC or shift.
         * Required: false
         * Array: false
         */
        this.employeeRank = undefined;
        /**
         * The total number of employees ranked on current SIC or shift.
         * Required: false
         * Array: false
         */
        this.totalEmployees = undefined;
        /**
         * The number of minutes clocked into Kronos that the current DES is based on.
         * Required: false
         * Array: false
         */
        this.minutesClockedIn = undefined;
        /**
         * The Kronos work center the employee is currently clocked into.
         * Required: false
         * Array: false
         */
        this.kronosWorkcenter = undefined;
    }
}
/**
 *
 */
class GetCurrentMotorMovesPerHourHeader {
    constructor() {
        /**
         * Pass the token to make the call.
         * Required: true
         * Array: false
         */
        this.smartToken = undefined;
    }
}
/**
 *
 */
class GetCurrentMotorMovesPerHourPath {
    constructor() {
        /**
         * The location associated with the employee.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The unique identifier for the employee.
         * Required: true
         * Array: false
         */
        this.employeeId = undefined;
    }
}
/**
 *
 */
class GetCurrentMotorMovesPerHourQuery {
    constructor() {
        /**
         * The code associated with the shift.  Permitted values: D, I, N, O.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetCurrentMotorMovesPerHourResp {
    constructor() {
        /**
         * The dock worker's current motor moves per hour
         * Required: false
         * Array: false
         */
        this.currentMotorMovesPerHour = undefined;
        /**
         * The timestamp for which the MMPH were calculated in UTC.
         * Required: false
         * Array: false
         */
        this.calculatedDateTimeUtc = undefined;
        /**
         * The SIC or shift MMPH goal.
         * Required: false
         * Array: false
         */
        this.motorMovesGoal = undefined;
        /**
         * The employee's MMPH rank among all employees on current SIC or shift.
         * Required: false
         * Array: false
         */
        this.employeeRank = undefined;
        /**
         * The total number of employees ranked on current SIC or shift.
         * Required: false
         * Array: false
         */
        this.totalEmployees = undefined;
        /**
         * The number of minutes clocked into Kronos that the current MMPH is based on.
         * Required: false
         * Array: false
         */
        this.minutesClockedIn = undefined;
        /**
         * The Kronos work center the employee is currently clocked into.
         * Required: false
         * Array: false
         */
        this.kronosWorkcenter = undefined;
    }
}
/**
 * Path parameters which are used to retrieve dock shipment details.
 */
class GetDockShipmentDetailsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The business identifier for the shipment to be loaded.  It can be the tracking PRO or parent PRO.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 * Query parameters which are used to retrieve dock shipment details.
 */
class GetDockShipmentDetailsQuery {
    constructor() {
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Response to the request to retrieve dock shipment details.
 */
class GetDockShipmentDetailsResp {
    constructor() {
        /**
         * Information about the shipment at the dock.
         * Required: false
         * Array: false
         */
        this.dockShipment = undefined;
    }
}
/**
 *
 */
class GetDockShipmentLoadsQuery {
    constructor() {
        /**
         * The business identifiers for the shipments.
         * Required: true
         * Array: true
         */
        this.proNbrs = undefined;
        /**
         * The service center identification code of the location.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift of the location.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetDockShipmentLoadsResp {
    constructor() {
        /**
         * The information about the Dock Shipment Loads.
         * Required: false
         * Array: true
         */
        this.dockShipmentLoads = undefined;
        /**
         * The list of validation error messages.
         * Required: false
         * Array: true
         */
        this.dataValidationErrors = undefined;
    }
}
/**
 * Path parameters to retrieve employee details by Kronos badge number
 */
class GetEmployeeDetailsByBadgeNbrPath {
    constructor() {
        /**
         * Kronos badge number of the employee
         * Required: true
         * Array: false
         */
        this.badgeNumber = undefined;
    }
}
/**
 * Response message - return employee details
 */
class GetEmployeeDetailsByBadgeNbrResp {
    constructor() {
        /**
         * Detailed information about an employee
         * Required: false
         * Array: false
         */
        this.employee = undefined;
    }
}
/**
 *
 */
class GetHandlingUnitProLoadPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the load details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The business identifier for the Handling Unit PRO.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 *
 */
class GetHandlingUnitProLoadQuery {
    constructor() {
        /**
         * Indicates that the PRO will be checked if reweigh is required.
         * Required: false
         * Array: false
         */
        this.reweighInd = undefined;
        /**
         * The unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * If set to true, then the handling unit split is overridden.
         * Required: false
         * Array: false
         */
        this.overrideInd = undefined;
    }
}
/**
 *
 */
class GetHandlingUnitProLoadResp {
    constructor() {
        /**
         * Information about the PRO.
         * Required: false
         * Array: false
         */
        this.pro = undefined;
        /**
         * The list of load to information about the PRO.
         * Required: false
         * Array: true
         */
        this.loadTos = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForShipmentPath {
    constructor() {
        /**
         * The unique identifier of the shipment when requesting a trailer onto which to load it.
         * Required: true
         * Array: false
         */
        this.shipmentInstId = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForShipmentQuery {
    constructor() {
        /**
         * The identification code for the service center where the request is being made.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift during which the request was made.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForShipmentResp {
    constructor() {
        /**
         * The information necessary for determining the next best loading action.  This will be a ranked list of loading actions to take for shipment/trailer pairs.
         * Required: false
         * Array: true
         */
        this.nextBestLoadingAction = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForTrailerPath {
    constructor() {
        /**
         * The unique identifier of the trailer when requesting a shipment to load onto it.
         * Required: true
         * Array: false
         */
        this.trailerId = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForTrailerQuery {
    constructor() {
        /**
         * The identification code for the service center where the request is being made.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift during which the request was made.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetNextBestLoadingActionForTrailerResp {
    constructor() {
        /**
         * The information necessary for determining the next best loading action. This will be a ranked list of loading actions to take for shipment/trailer pairs.
         * Required: false
         * Array: true
         */
        this.nextBestLoadingAction = undefined;
    }
}
/**
 *
 */
class GetPdfReportPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the type of report that will be rendered.
         * Required: true
         * Array: false
         */
        this.reportTypeCd = undefined;
    }
}
/**
 *
 */
class GetPdfReportRqst {
    constructor() {
        /**
         * The parameters which are used to render the report. For example, to print the report for a trailer use: 'name': 'trailerNbr', 'value': '123-4567'.
         * Required: false
         * Array: true
         */
        this.reportParameters = undefined;
    }
}
/**
 *
 */
class GetPdfReportResp {
    constructor() {
        /**
         * The type of report that was rendered.
         * Required: false
         * Array: false
         */
        this.reportTypeCd = undefined;
        /**
         * The list of PDF files which are part of this report.
         * Required: false
         * Array: true
         */
        this.pdfReportAttachments = undefined;
        /**
         * The SIC that issued the request.
         * Required: false
         * Array: false
         */
        this.requestingSic = undefined;
        /**
         * The parameters which were used to render the report. An example would be: 'name': 'trailerNbr', 'value': '123-4567'.
         * Required: false
         * Array: true
         */
        this.requestParameters = undefined;
    }
}
/**
 *
 */
class GetProFbdsDocWithCurrentLocationPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The business identifier of the shipment.  It can refer to a handling unit, parent PRO, or legacy PRO.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 *
 */
class GetProFbdsDocWithCurrentLocationResp {
    constructor() {
        /**
         * The document details for FBDS/Copy-Bill for the shipment.
         * Required: false
         * Array: false
         */
        this.fbdsDocument = undefined;
    }
}
/**
 * Path parameters used to retrieve load details for a PRO.
 */
class GetProLoadDetailsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the load details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The PRO number to be loaded.  It can be the tracking PRO or parent PRO.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 * Query parameters used to retrieve load details for a PRO.
 */
class GetProLoadDetailsQuery {
    constructor() {
        /**
         * Indicates that the PRO will be checked if reweigh is required.
         * Required: false
         * Array: false
         */
        this.reweighInd = undefined;
        /**
         * The unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * If set to true, then the handling unit split is overridden.
         * Required: false
         * Array: false
         */
        this.overrideInd = undefined;
    }
}
/**
 * Respone to the request to retrieve load details for a PRO.
 */
class GetProLoadDetailsResp {
    constructor() {
        /**
         * Information about the PRO.
         * Required: false
         * Array: false
         */
        this.proDetail = undefined;
        /**
         * The list of load to information about the PRO.
         * Required: false
         * Array: true
         */
        this.loadTos = undefined;
    }
}
/**
 *
 */
class GetProXdockLocationsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class GetProXdockLocationsQuery {
    constructor() {
        /**
         * The business identifiers for the shipments.
         * Required: true
         * Array: true
         */
        this.proNbrs = undefined;
        /**
         * The unique identifier for the pricing agreement.
         * Required: false
         * Array: false
         */
        this.agreementInstId = undefined;
        /**
         * A system assigned sequential number which is used to uniquely identify each rule set.
         * Required: false
         * Array: false
         */
        this.ruleSetSequenceNbr = undefined;
    }
}
/**
 *
 */
class GetProXdockLocationsResp {
    constructor() {
        /**
         * The list of details for the shipment xdock locations.
         * Required: false
         * Array: true
         */
        this.xdockShipmentLocations = undefined;
    }
}
/**
 * Path parameters used to retrieve the route's manifest.
 */
class GetRouteManifestPath {
    constructor() {
        /**
         * The location that is requesting the route's manifest.
         * Required: true
         * Array: false
         */
        this.requestingSicCd = undefined;
        /**
         * The code associated with the shift for which the route's manifest was requested. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The unique identifer of the route.
         * Required: true
         * Array: false
         */
        this.routeInstId = undefined;
    }
}
/**
 * Query parameters used to retrieve the route's manifest.
 */
class GetRouteManifestQuery {
    constructor() {
        /**
         * The unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Response to the request to retrieve the route manifest
 */
class GetRouteManifestResp {
    constructor() {
        /**
         * The type of route.
         * Required: false
         * Array: false
         */
        this.categoryCd = undefined;
        /**
         * The date of the route.
         * Required: false
         * Array: false
         */
        this.routeDate = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The route terminal service center identification code where the route was created.
         * Required: false
         * Array: false
         */
        this.routeSicCd = undefined;
        /**
         * The prefix of the route.
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * The suffix of the route.
         * Required: false
         * Array: false
         */
        this.routeSuffix = undefined;
        /**
         * The list of shipments assigned to the route.
         * Required: false
         * Array: true
         */
        this.shipmentsOnRoute = undefined;
        /**
         * The count of shipments that are remaining to be loaded on the route.
         * Required: false
         * Array: false
         */
        this.shipmentsRemainingCount = undefined;
        /**
         * The equipment prefix-suffix for the trailer assigned to the route.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The door number to which the trailer is currently assigned.
         * Required: false
         * Array: false
         */
        this.trailerDoorNbr = undefined;
        /**
         * The unique identifier of the trailer assigned to the route.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The current status of the trailer assigned to the route.
         * Required: false
         * Array: false
         */
        this.trailerStatus = undefined;
    }
}
/**
 *
 */
class GetSmartApiTokenResp {
    constructor() {
        /**
         * SMART API Token to be used in the query call.
         * Required: false
         * Array: false
         */
        this.smartApiToken = undefined;
    }
}
/**
 * Path parameters used to retrieve trailer details if one is present at a particular location and door.
 */
class GetTrailerDetailsByDoorPath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The door number that will be used to check if there is a trailer.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 * Response to the request to trailer details if one is present at a particular location and door.
 */
class GetTrailerDetailsByDoorResp {
    constructor() {
        /**
         * Details about the trailer that is at the location and door number provided.
         * Required: false
         * Array: false
         */
        this.trailerDetail = undefined;
    }
}
/**
 *
 */
class GetTrailerLoadByEquipmentIdPath {
    constructor() {
        /**
         * The unique identifier of the equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class GetTrailerLoadByEquipmentIdResp {
    constructor() {
        /**
         * The trailer load details for the equipment.
         * Required: false
         * Array: false
         */
        this.trailerLoad = undefined;
    }
}
/**
 * Request to list drivers' availability status from SMART if drivers have a job type of either 'Night Linehaul' or 'PM Flex'.
 */
class ListAvailabilityForDriversPath {
    constructor() {
        /**
         * The location associated with the driver.
         * Required: true
         * Array: false
         */
        this.siteCd = undefined;
    }
}
/**
 * Request to list drivers' availability status from SMART if drivers have a job type of either 'Night Linehaul' or 'PM Flex'.
 */
class ListAvailabilityForDriversQuery {
    constructor() {
        /**
         * The date when the driver will be available to work.
         * Required: true
         * Array: false
         */
        this.planDate = undefined;
    }
}
/**
 * The header which contains the SMART token.
 */
class ListAvailabilityForDriversHeader {
    constructor() {
        /**
         * The token that is used to make the SMART API call.
         * Required: true
         * Array: false
         */
        this.smartToken = undefined;
    }
}
/**
 * Response to the request to list drivers' availability status from SMART if drivers have a job type of either 'Night Linehaul' or 'PM Flex'.
 */
class ListAvailabilityForDriversResp {
    constructor() {
        /**
         * The list of drivers' availability status.
         * Required: false
         * Array: true
         */
        this.driverAvailabilities = undefined;
    }
}
/**
 * Path parameter which is used to return the list of routes for Cross Dock.
 */
class ListCrossDockRoutesPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Query parameters which are used to list the routes for Cross Dock.
 */
class ListCrossDockRoutesQuery {
    constructor() {
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list routes for Cross Dock.
 */
class ListCrossDockRoutesResp {
    constructor() {
        /**
         * The list of cross dock routes for the SIC.
         * Required: false
         * Array: true
         */
        this.routes = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListShipmentDockHistoryPath {
    constructor() {
        /**
         * The business identifier for the shipment.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 *
 */
class ListShipmentDockHistoryQuery {
    constructor() {
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The date the event took place.
         * Required: false
         * Array: false
         */
        this.eventDate = undefined;
    }
}
/**
 *
 */
class ListShipmentDockHistoryResp {
    constructor() {
        /**
         * The list of shipment dock histories.
         * Required: false
         * Array: true
         */
        this.shipmentDockHistories = undefined;
    }
}
/**
 * Path parameters used to load a PRO.
 */
class LoadProPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to load a PRO.
 */
class LoadProRqst {
    constructor() {
        /**
         * The date and time when the PRO was loaded.
         * Required: true
         * Array: false
         */
        this.loadDateTime = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user who is loading the PRO.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Indicates whether any warnings while loading the PRO will be ignored.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * The PRO number of the handling unit that is being loaded.
         * Required: false
         * Array: false
         */
        this.trackingProNbr = undefined;
        /**
         * The PRO number of the parent of the handling unit that is being loaded.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The door number on the dock where the PRO is being loaded.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The name of the dock location where the PRO is being loaded.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * The employee ID of the supervisor who is authorizing the loading in case of misload.
         * Required: false
         * Array: false
         */
        this.supervisorEmployeeId = undefined;
        /**
         * Indicates whether the PRO is being loaded as a headload.
         * Required: false
         * Array: false
         */
        this.headLoadInd = undefined;
        /**
         * The unique identifier of the route where the PRO is being
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Indicates whether the PRO has food or poison items.
         * Required: false
         * Array: false
         */
        this.foodPoisonCd = undefined;
        /**
         * Indicates whether the shipment has hazardous materials.
         * Required: false
         * Array: false
         */
        this.hazmatInd = undefined;
    }
}
/**
 * Response to the request to load a PRO.
 */
class LoadProResp {
    constructor() {
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The trailer number (equipment prefix-suffix) that needs inspection.
         * Required: false
         * Array: false
         */
        this.inspectionTrailerNbr = undefined;
        /**
         * The list of messages related to required placards.
         * Required: false
         * Array: true
         */
        this.placardMessages = undefined;
        /**
         * The list of error messages related to required placards.
         * Required: false
         * Array: true
         */
        this.placardErrorMessages = undefined;
        /**
         * The list of warning messages related to required placards.
         * Required: false
         * Array: true
         */
        this.placardWaningMessages = undefined;
        /**
         * Misload or Hazmat split Validation Errors
         * Required: false
         * Array: true
         */
        this.validationErrors = undefined;
    }
}
/**
 *
 */
class MaintainHeadloadsPath {
    constructor() {
        /**
         * The service center identification code associated with the trailer.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code associated with the trailer.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class MaintainHeadloadsRqst {
    constructor() {
        /**
         * The concatentation of the trailer prefix and suffix
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The surrogate identifier for the equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The plan date.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The list of shipments.
         * Required: false
         * Array: true
         */
        this.headloadShipments = undefined;
    }
}
/**
 *
 */
class MaintainHeadloadsResp {
    constructor() {
        /**
         * The concatentation of the trailer prefix and suffix to which the shipments belong.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The surrogate identifier for the equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The list of shipments that were upserted.
         * Required: false
         * Array: true
         */
        this.headloadShipments = undefined;
    }
}
/**
 * Path parameters used to submit the print dock copy.
 */
class PrintDockCopyPath {
    constructor() {
        /**
         * The location associated with the service center.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to submit the print dock copy.
 */
class PrintDockCopyRqst {
    constructor() {
        /**
         * The number assigned to the printer at the service center where the print request will be sent.
         * Required: true
         * Array: false
         */
        this.printerNbr = undefined;
        /**
         * The type of report: COPY or FBDS.
         * Required: true
         * Array: false
         */
        this.reportTypeCd = undefined;
        /**
         * The business identifier of the parent shipment.
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * The PRO number of the handling unit associated with the parent.
         * Required: false
         * Array: false
         */
        this.trackingProNbr = undefined;
        /**
         * The badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * The version of the app used in the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The employee ID of the user who is requesting the Print
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The type of Form requested to be printed. Eg. FBDS, CMAN or LABEL
         * Required: false
         * Array: false
         */
        this.formType = undefined;
    }
}
/**
 * Path parameters used to submit the print manifest reports.
 */
class PrintManifestReportsPath {
    constructor() {
        /**
         * The location associated with the service center.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to submit the print manifest reports.
 */
class PrintManifestReportsRqst {
    constructor() {
        /**
         * The number assigned to the printer at the service center where the print request will be sent.
         * Required: true
         * Array: false
         */
        this.printerNbr = undefined;
        /**
         * The type of Manifest report that needs to be printed.
         * Required: true
         * Array: false
         */
        this.manifestTypeCd = undefined;
        /**
         * The list of trailers or routes for which to submit the request.
         * Required: false
         * Array: true
         */
        this.manifestReports = undefined;
        /**
         * The version of the app used in the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The unique identifier of the dock location.
         * Required: false
         * Array: false
         */
        this.dockInstId = undefined;
        /**
         * The employee ID of the dock worker making the request.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * The location associated with the service center of the trailer's origin.
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The status of the trailer when submitting the request.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
    }
}
/**
 * Path parameter used to record user logon and logout to a device.
 */
class RecordDeviceLogonAndLogoutPath {
    constructor() {
        /**
         * The location associated with the service center.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Request to record user logon and logout to a device.
 */
class RecordDeviceLogonAndLogoutRqst {
    constructor() {
        /**
         * The code associated with the shift during which the logon and logoff was recorded. Permitted values: DayReship, Inbound, NightFAC, Outbound, and PickupAndDelivery.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The application to which the user is logging in to or logging out.
         * Required: false
         * Array: false
         */
        this.applicationCd = undefined;
        /**
         * The version of the app used in the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The phone number of the device making the request.
         * Required: false
         * Array: false
         */
        this.devicePhoneNbr = undefined;
        /**
         * The badge number of the dock worker making the request.
         * Required: false
         * Array: false
         */
        this.employeeBadgeNbr = undefined;
        /**
         * The employee ID of the dock worker making the request.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * If set to true, then the user is logging on to the device. If false then the user is logging out.
         * Required: false
         * Array: false
         */
        this.logonInd = undefined;
    }
}
/**
 * Response to the request to record user logon and logout to a device.
 */
class RecordDeviceLogonAndLogoutResp {
    constructor() {
        /**
         * The badge number of the employee.
         * Required: false
         * Array: false
         */
        this.employeeBadgeNbr = undefined;
        /**
         * The unique identifier of the employee.
         * Required: false
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * The full name of the employee.
         * Required: false
         * Array: false
         */
        this.employeeName = undefined;
        /**
         * If set to true, then the user has the supervisor role.
         * Required: false
         * Array: false
         */
        this.supervisorInd = undefined;
    }
}
/**
 *
 */
class RecordShipmentDockExceptionPath {
    constructor() {
        /**
         * The location associated with the service center where the exception occurred.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift during which the exception was recorded. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class RecordShipmentDockExceptionRqst {
    constructor() {
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used in the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the dockworker making the request.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The business identifier for the shipment.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The count of overage pieces.
         * Required: false
         * Array: false
         */
        this.overagePiecesCount = undefined;
        /**
         * The count of short pieces.
         * Required: false
         * Array: false
         */
        this.shortPiecesCount = undefined;
        /**
         * The count of damaged pieces.
         * Required: false
         * Array: false
         */
        this.damagedPiecesCount = undefined;
        /**
         * Indicates if all pieces are short.
         * Required: false
         * Array: false
         */
        this.allShortInd = undefined;
        /**
         * The comment associated with the exception.
         * Required: false
         * Array: false
         */
        this.commentText = undefined;
        /**
         * The dock location where the exception occurred.
         * Required: false
         * Array: false
         */
        this.dockLocationName = undefined;
        /**
         * The badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * The dock door where the exception occurred.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The date when the exception occurred.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * Indicates whether the freight is poorly packaged.
         * Required: false
         * Array: false
         */
        this.poorlyPackagedInd = undefined;
    }
}
/**
 *
 */
class RecordShipmentDockExceptionResp {
    constructor() {
        /**
         * The unique identifier of the shipment.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The sequence number of the Dock Exception record created in Shipment.
         * Required: false
         * Array: false
         */
        this.dockExceptionSequenceNbr = undefined;
        /**
         * The sequence number of the handling unit movement.
         * Required: false
         * Array: false
         */
        this.movementSequenceNbr = undefined;
    }
}
/**
 *
 */
class SplitNonLoadedHandlingUnitsRqst {
    constructor() {
        /**
         * The non-loaded handling units that need to be split.
         * Required: true
         * Array: true
         */
        this.nonLoadedHandlingUnits = undefined;
        /**
         * The user ID of the person who authorized the split of the handling units.
         * Required: true
         * Array: false
         */
        this.splitAuthorizedBy = undefined;
        /**
         * The date and time when the split of handling units was authorized.
         * Required: true
         * Array: false
         */
        this.splitAuthorizedDateTime = undefined;
        /**
         * The SIC Code that is requesting the split
         * Required: false
         * Array: false
         */
        this.requestingSicCd = undefined;
    }
}
/**
 *
 */
class SplitNonLoadedHandlingUnitsResp {
    constructor() {
        /**
         * The list of validation errors that occurred.
         * Required: false
         * Array: true
         */
        this.dataValidationErrors = undefined;
    }
}
/**
 *
 */
class UpdateHandlingUnitExemptionPath {
    constructor() {
        /**
         * The business identifier for the shipment.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 *
 */
class UpdateHandlingUnitExemptionRqst {
    constructor() {
        /**
         * Indicates whether the shipment should be handling unit exempt, which means that the PRO is exempted from being tracked via piece level.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionInd = undefined;
        /**
         * The reason why the shipment is handling unit exempt and therefore exempted from piece level tracking.
         * Required: false
         * Array: false
         */
        this.handlingUnitExemptionReason = undefined;
    }
}
/**
 * Path parameter which is used to update the shipment dimensions.
 */
class UpdateShipmentDimensionsFromDockPath {
    constructor() {
        /**
         * The business identifier, either child or parent, of the shipment for which the dimensions are recorded.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 * Request to update the shipment dimensions.
 */
class UpdateShipmentDimensionsFromDockRqst {
    constructor() {
        /**
         * The user ID of the employee who captured the dimensions.
         * Required: true
         * Array: false
         */
        this.capturedByUserId = undefined;
        /**
         * The location where the dimensions were captured.
         * Required: true
         * Array: false
         */
        this.requestingSicCd = undefined;
        /**
         * The type of dimensions captured.
         * Required: true
         * Array: false
         */
        this.dimensionTypeCd = undefined;
        /**
         * The list of dimensions of the child or parent PRO.
         * Required: true
         * Array: true
         */
        this.dimensions = undefined;
        /**
         * The total volume in cubic feet which is calculated based on the dimensions or shipper profile.
         * Required: false
         * Array: false
         */
        this.totalVolumeCubicFeet = undefined;
        /**
         * The pup volume percentage which is calculated based on the dimensions or shipper profile.
         * Required: false
         * Array: false
         */
        this.pupVolumePercentage = undefined;
        /**
         * The method used to calculate the volume of the freight (TOT_VOL_CFT).
         * Values:
         * ACTL - Actual dimensions captured by the driver (length x width x height)
         * DEST - Shipper profile for the shipment?s destination ZIP (average shipment volume when the shipper ships to that ZIP)
         * DFLT - Default shipper profile (average shipment volume for shipper regardless of ZIP)
         * SIC - Service center profile (average shipment volume across all shipments at that SIC)
         * SYS - System profile (average shipment volume across all shipments in LTL)
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileMthdCd = undefined;
        /**
         * If a default or destination shipper profile was used to calculate the volume of the freight, this field describes the type of shipper profile used.
         * Values:
         * FTPRNT - Footprint piece profile
         * VOLSHP - Volume-shipment
         * VOLPCE - Volume-piece
         * DNSITY - Density shipment
         * HEIGHT - Height piece
         * Required: false
         * Array: false
         */
        this.cubicFeetProfileTypeCd = undefined;
    }
}
/**
 * Request to create a shipment skeleton.
 */
class UpsertShipmentSkeletonFromDockRqst {
    constructor() {
        /**
         * Skeleton information about the shipment which will be used to create the record.
         * Required: true
         * Array: false
         */
        this.shipmentSkeleton = undefined;
    }
}
/**
 *
 */
class DeleteLoadedHandlingUnitAsAdminPath {
    constructor() {
        /**
         * The identifier of the handling unit currently loaded on a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.childProNbr = undefined;
    }
}
/**
 *
 */
class DeleteLoadedHandlingUnitAsAdminQuery {
    constructor() {
        /**
         * The unique identifier of the dock location at which the handling unit is currently staged.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The unique identifier of the equipment at which the shipment is currently loaded.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class DeleteLoadedShipmentAsAdminPath {
    constructor() {
        /**
         * The business identifier of the shipment currently loaded on a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 *
 */
class DeleteLoadedShipmentAsAdminQuery {
    constructor() {
        /**
         * The unique identifier of the dock location at which the shipment is currently staged.
         * Required: false
         * Array: false
         */
        this.dockInstanceId = undefined;
        /**
         * The unique identifier of the equipment at which the shipment is currently loaded.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class GetShipmentOnTrailerOrDockPath {
    constructor() {
        /**
         * The PRO that is loaded on a shipment or on a dock.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
    }
}
/**
 *
 */
class GetShipmentOnTrailerOrDockResp {
    constructor() {
        /**
         * The details of the shipment that is loaded on a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.shipmentOnTrailerOrDock = undefined;
    }
}
/**
 *
 */
class ListHandlingUnitsOnTrailerOrDockRqst {
    constructor() {
        /**
         * The list of child PRO numbers for which the handling units will be listed.
         * Required: true
         * Array: true
         */
        this.childProNbrs = undefined;
    }
}
/**
 *
 */
class ListHandlingUnitsOnTrailerOrDockResp {
    constructor() {
        /**
         * The list of handling units that are loaded on a dock location or a piece of equipment.
         * Required: false
         * Array: true
         */
        this.handlingUnitsOnTrailerOrDock = undefined;
    }
}
/**
 *
 */
class UpsertLoadedHandlingUnitAsAdminRqst {
    constructor() {
        /**
         * The details that will be used to perform the upsert of the handling unit to a dock location or a piece of equipment.
         * Required: true
         * Array: false
         */
        this.handlingUnitOnTrailerOrDock = undefined;
    }
}
/**
 *
 */
class UpsertLoadedShipmentAsAdminRqst {
    constructor() {
        /**
         * The details that will be used to perform the upsert of the shipment to a dock location or piece of equipment.
         * Required: true
         * Array: false
         */
        this.shipmentOnTrailerOrDock = undefined;
    }
}
/**
 *
 */
class AddTrailersToCrossDockPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The date for which the cross dock plan is being prepared.
         * Required: true
         * Array: false
         */
        this.planDate = undefined;
    }
}
/**
 *
 */
class AddTrailersToCrossDockPlanRqst {
    constructor() {
        /**
         * The list of trailer numbers to include in the cross dock plan.
         * Required: false
         * Array: true
         */
        this.trailerNbrs = undefined;
    }
}
/**
 * Path parameters used to assign a trailer to a dock door.
 */
class AssignTrailerToDoorPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Request to assign a trailer to a dock door.
 */
class AssignTrailerToDoorRqst {
    constructor() {
        /**
         * The code associated with the shift when the assignment was done. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The number assigned to the door.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the trailer equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The trailer equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The employee ID of the dock worker.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The unique identifier of the Cross Dock Plan.
         * Required: false
         * Array: false
         */
        this.xdockPlanInstId = undefined;
        /**
         * The seal number associated with the trailer at the time of close.
         * Required: false
         * Array: false
         */
        this.sealNbr = undefined;
        /**
         * The trailer load status. E.g. Arrive, City Arrive, Drop, Empty, Trap, etc.
         * Required: false
         * Array: false
         */
        this.newTrailerStatus = undefined;
        /**
         * The service center identification code for the Trailer Load Destination.
         * Required: false
         * Array: false
         */
        this.loadDestinationSic = undefined;
        /**
         * The Kronos badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * When set to true any warning messages will be ignored.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * The unique identifier of the route associated with the trailer.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * When set to true hazmat validatations will be performed.
         * Required: false
         * Array: false
         */
        this.applyHazmatEditsInd = undefined;
    }
}
/**
 * Response message to assign trailer to dock door
 */
class AssignTrailerToDoorResp {
    constructor() {
        /**
         * The updated trailer information.
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
        /**
         * When set to true then the trailer photo will be required.
         * Required: false
         * Array: false
         */
        this.photoReqdInd = undefined;
    }
}
/**
 *
 */
class AssignTrailerToDoorForDockManagerPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 *
 */
class AssignTrailerToDoorForDockManagerRqst {
    constructor() {
        /**
         * The code associated with the shift when the assignment was done. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The number assigned to the door.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the trailer equipment.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The trailer equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The employee ID of the dock worker.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The unique identifier of the Cross Dock Plan.
         * Required: false
         * Array: false
         */
        this.xdockPlanInstId = undefined;
        /**
         * The seal number associated with the trailer at the time of close.
         * Required: false
         * Array: false
         */
        this.sealNbr = undefined;
        /**
         * The trailer load status. E.g. Arrive, City Arrive, Drop, Empty, Trap, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The service center identification code for the Trailer Load Destination.
         * Required: false
         * Array: false
         */
        this.loadDestinationSic = undefined;
        /**
         * The Kronos badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * Indicates whether any warning messages will be ignored.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * The unique identifier of the route associated with the trailer.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Indicates whether hazmat validatations will be performed.
         * Required: false
         * Array: false
         */
        this.applyHazmatEditsInd = undefined;
    }
}
/**
 *
 */
class AssignTrailerToDoorForDockManagerResp {
    constructor() {
        /**
         * The updated Trailer Load information.
         * Required: false
         * Array: false
         */
        this.trailerLoad = undefined;
        /**
         * Indicates whether the trailer photo will be required.
         * Required: false
         * Array: false
         */
        this.photoRequiredInd = undefined;
    }
}
/**
 * Path parameter used to bulk update trailer load status, door, and remarks.
 */
class BulkUpdateTrailerLoadStatusDoorRemarksPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Request to bulk update trailer load status, door, and remarks.
 */
class BulkUpdateTrailerLoadStatusDoorRemarksRqst {
    constructor() {
        /**
         * The list of details about Trailer Load status, door, and remarks that is used to perform the bulk update.
         * Required: true
         * Array: true
         */
        this.trailerLoadStatusDoorRemarks = undefined;
    }
}
/**
 * Response to the request to bulk update trailer load status, door, and remarks.
 */
class BulkUpdateTrailerLoadStatusDoorRemarksResp {
    constructor() {
        /**
         * The list of details about Trailer Load status, door, and remarks that was used to perform the bulk update.
         * Required: false
         * Array: true
         */
        this.trailerLoadStatusDoorRemarks = undefined;
    }
}
/**
 * Path parameters which are used to close a city trailer.
 */
class CloseCityTrailerPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift when the city trailer is closed.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 * Request to close a city trailer.
 */
class CloseCityTrailerRqst {
    constructor() {
        /**
         * The door number at the dock to which the trailer is assigned.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The date and time when the close action was performed on the trailer.
         * Required: false
         * Array: false
         */
        this.closeDateTime = undefined;
        /**
         * The unique identifier of the handheld device that was used to close the city trailer.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * Indicates whether any warnings will be overriden during the close of the trailer.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * The list of handling units loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.loadedHandlingUnits = undefined;
        /**
         * The list of shipments loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.loadedShipments = undefined;
        /**
         * When set to true, then placards are required for the city trailer.
         * Required: false
         * Array: false
         */
        this.placardRequiredInd = undefined;
        /**
         * The list of placards loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.placards = undefined;
        /**
         * The ID of the printer at the SIC where the trailer contents will be printed at the time of close.
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
        /**
         * This will be set to true except when the trailer is closed for a zone route. When set to true the route planned door will be set to spaces.
         * Required: false
         * Array: false
         */
        this.resetRouteDoorInd = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * When set to true the route door will be reset to YARD for the city trailer.
         * Required: false
         * Array: false
         */
        this.sendToYardInd = undefined;
        /**
         * The Kronos badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * The employee ID of the user who performed the close action.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 * Response to the request to close a city trailer.
 */
class CloseCityTrailerResp {
    constructor() {
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The current status of the trailer at the door location.  E.g. Arrive, CityArrive, CityLoadingAtDock, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The date and time when the status was updated on the trailer.
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
    }
}
/**
 * Path parameters which are used to close a trailer.
 */
class CloseLinehaulTrailerPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift when the load deck count is updated.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The trailer number (equipment prefix - suffix) that is used to update the count.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 * Request to close a linehaul trailer.
 */
class CloseLinehaulTrailerRqst {
    constructor() {
        /**
         * Information about the trailer load.
         * Required: true
         * Array: false
         */
        this.trailerLoad = undefined;
        /**
         * The employee ID of the user who performed the close action.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The unique identifier of the handheld device that was used to close the linehaul trailer.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * Indicates whether any warnings will be overriden during the close of the trailer.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
        /**
         * The date and time when the close action was performed on the trailer.
         * Required: false
         * Array: false
         */
        this.closeDateTime = undefined;
        /**
         * The ID of the printer at the SIC where the trailer contents will be printed at the time of close.
         * Required: false
         * Array: false
         */
        this.printerId = undefined;
        /**
         * When set to true the route door will be reset to the input value in Trailer Load.
         * Required: false
         * Array: false
         */
        this.resetRouteDoorInd = undefined;
        /**
         * The Kronos badge number of the supervisor.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * When set to true the hazmat validations will be performed.
         * Required: false
         * Array: false
         */
        this.applyHazmatEditsInd = undefined;
        /**
         * When set to true, then placards are required for the linehaul trailer.
         * Required: false
         * Array: false
         */
        this.placardRequiredInd = undefined;
        /**
         * The list of placards loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.placards = undefined;
    }
}
/**
 * Response to the request to close a linehaul trailer.
 */
class CloseLinehaulTrailerResp {
    constructor() {
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The current status of the trailer at the door location.  E.g. Arrive, CityArrive, CityLoadingAtDock, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The date and time when the status was updated on the trailer.
         * Required: false
         * Array: false
         */
        this.statusUpdateDateTime = undefined;
        /**
         * The load release number generated when the trailer was closed.
         * Required: false
         * Array: false
         */
        this.loadReleaseNbr = undefined;
        /**
         * The seal number associated with the trailer when it was closed.
         * Required: false
         * Array: false
         */
        this.sealNbr = undefined;
    }
}
/**
 * Request to close a linehaul trailer photo analysis.
 */
class CloseLinehaulTrailerPhotoAnalysisRqst {
    constructor() {
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The service center identification code for the location where the trailer was closed.
         * Required: false
         * Array: false
         */
        this.closeSicCd = undefined;
        /**
         * The code associated witht the shift when the trailer was closed.
         * Required: false
         * Array: false
         */
        this.closeShiftCd = undefined;
        /**
         * The unique identifier of the close event.
         * Required: false
         * Array: false
         */
        this.closeEventId = undefined;
        /**
         * The unique identifier of the close trailer photo in the DMS system. The doc class in DMS is TLFO (Close Full Size).
         * Required: false
         * Array: false
         */
        this.dmsDocId = undefined;
    }
}
/**
 * Response to the request to close a linehaul trailer photo analysis.
 */
class CloseLinehaulTrailerPhotoAnalysisResp {
    constructor() {
        /**
         * Details about the close Event Photo Analysis.
         * Required: false
         * Array: false
         */
        this.trailerPhotoAnalysis = undefined;
    }
}
/**
 * Path parameters used to complete the trailer load update status.
 */
class CompleteTrailerLoadUnloadPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to complete the trailer load update status.
 */
class CompleteTrailerLoadUnloadRqst {
    constructor() {
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The door number on the dock to which the trailer is assigned.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The location that represents the destination of a head load.
         * Required: false
         * Array: false
         */
        this.headloadDestinationSic = undefined;
        /**
         * The plan date for which to get the trailers. If not supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * Usually set to the current date time when the request was sent by the handheld and if the update is recent or not at the time the request was made.
         * Required: false
         * Array: false
         */
        this.versionCheckTmst = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The unique identifier assigned to the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The current status of the trailer at the door location.  E.g. Arrive, CityArrive, CityLoadingAtDock, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * Must be set to true when the Complete action is performed.
         * Required: false
         * Array: false
         */
        this.completeInd = undefined;
    }
}
/**
 * Response to the request to complete the trailer load update status.
 */
class CompleteTrailerLoadUnloadResp {
    constructor() {
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The door number on the dock to which the trailer is assigned.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerInstId = undefined;
        /**
         * The current status of the trailer at the door location.  E.g. Arrive, CityArrive, CityLoadingAtDock, etc.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
    }
}
/**
 * Path parameters which are used to derive the trailer close options.
 */
class DeriveTrailerCloseOptionsPath {
    constructor() {
        /**
         * The location that is requesting the trailer close options.
         * Required: true
         * Array: false
         */
        this.requestingSicCd = undefined;
        /**
         * The code associated with the shift for which the trailer close option was requested. Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to derive the trailer close options.
 */
class DeriveTrailerCloseOptionsRqst {
    constructor() {
        /**
         * Indicates whether the trailer being closed is a supplemental trailer.
         * Required: false
         * Array: false
         */
        this.isSupplementalTrailerInd = undefined;
        /**
         * The date when the trailer close options are requested; defaults to today.
         * Required: false
         * Array: false
         */
        this.closeDate = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The shipments that are on the trailer.
         * Required: true
         * Array: true
         */
        this.shipments = undefined;
    }
}
/**
 * Response to the request to derive the trailer close options.
 */
class DeriveTrailerCloseOptionsResp {
    constructor() {
        /**
         * One or more trailer close options for the shipments on the trailer.
         * Required: false
         * Array: true
         */
        this.trailerCloseOptions = undefined;
    }
}
/**
 * Path parameters used to divert XDock plan shipments.
 */
class DivertShipmentsInDockPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to divert XDock plan shipments.
 */
class DivertShipmentsInDockPlanRqst {
    constructor() {
        /**
         * The plan date for which the shipments will be retrieved. If is isn't supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The list of shipments to be diverted.
         * Required: true
         * Array: true
         */
        this.dockShipments = undefined;
    }
}
/**
 * Response to the request to divert XDock plan shipments.
 */
class DivertShipmentsInDockPlanResp {
    constructor() {
        /**
         * The list of shipments in the XDOCK plan that were diverted.
         * Required: false
         * Array: true
         */
        this.dockShipments = undefined;
    }
}
/**
 * Path parameters which are used to retrieve the trailer's manifest.
 */
class GetTrailerManifestPath {
    constructor() {
        /**
         * The location that is requesting the trailer's manifest.
         * Required: true
         * Array: false
         */
        this.requestingSicCd = undefined;
    }
}
/**
 * Query parameters which are used to retrieve the trailer's manifest.
 */
class GetTrailerManifestQuery {
    constructor() {
        /**
         * The code associated with the shift for which the trailer's manifest was requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The door number at the dock.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * he unique Identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * VThe version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * If set to true return the trailer manifest for Trailer Close.
         * Required: false
         * Array: false
         */
        this.trailerCloseInd = undefined;
        /**
         * If set to true, return the route information in the response.
         * Required: false
         * Array: false
         */
        this.includeRouteInfoInd = undefined;
    }
}
/**
 * Response to the request to retrieve the trailer's manifest.
 */
class GetTrailerManifestResp {
    constructor() {
        /**
         * Information about the equipment.
         * Required: false
         * Array: false
         */
        this.equipment = undefined;
        /**
         * The list of equipment that is loaded on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedEquipment = undefined;
        /**
         * The list of Handling Units that are loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.loadedHandlingUnits = undefined;
        /**
         * The list of shipments that are loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.loadedShipments = undefined;
        /**
         * The list of placards loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.placards = undefined;
        /**
         * Details about the route.
         * Required: false
         * Array: false
         */
        this.route = undefined;
        /**
         * The concatenation of the equipment prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * Information about the trailer load associated with the trailer.
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
        /**
         * The type of trailer manifest: Strip or Load.
         * Required: false
         * Array: false
         */
        this.trailerManifestType = undefined;
        /**
         * If set to true, then there is at least one shipment that has the hazmatInd set to true but is missing hazmat details.
         * Required: false
         * Array: false
         */
        this.hazmatDetailsMissingInd = undefined;
        /**
         * The country code of the current SIC of the trailer.
         * Required: false
         * Array: false
         */
        this.trailerCountryCd = undefined;
        /**
         * The total weight of all the loaded equipment on the trailer.
         * Required: false
         * Array: false
         */
        this.loadedEquipmentWeight = undefined;
        /**
         * The list of trailer close options based on the FreightFlow network path.
         * Required: false
         * Array: true
         */
        this.trailerCloseOptions = undefined;
        /**
         * If set to true, then trailerCloseOptions were not found when the trailer was closed.
         * Required: false
         * Array: false
         */
        this.closeOptionErrorInd = undefined;
        /**
         * The total bill count of all the parent PROs.
         * Required: false
         * Array: false
         */
        this.billCount = undefined;
        /**
         * The total count of all the child PROs that are loaded.
         * Required: false
         * Array: false
         */
        this.childProCount = undefined;
        /**
         * The total count of parent PROs that are partially loaded.
         * Required: false
         * Array: false
         */
        this.partialParentProCount = undefined;
        /**
         * The total volume in cubic feet of the loaded shipments.
         * Required: false
         * Array: false
         */
        this.volumeCubicFeet = undefined;
        /**
         * The total weight of all the loaded shipments.
         * Required: false
         * Array: false
         */
        this.totalWeight = undefined;
        /**
         * The total count of all loose pieces of shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * The total count of all the hazmat shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.hazmatShipmentsCount = undefined;
        /**
         * The total count of all the guaranteed shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.guaranteedShipmentCount = undefined;
        /**
         * The total count of all the G12 Shipments loaded.
         * Required: false
         * Array: false
         */
        this.guaranteedNoonShipmentCount = undefined;
        /**
         * The total count of all the freezable shipments loaded.
         * Required: false
         * Array: false
         */
        this.freezableShipmentCount = undefined;
        /**
         * The total count of all the freezable shipments loaded.
         * Required: false
         * Array: false
         */
        this.totalMotorMovesLoadedCount = undefined;
        /**
         * The count of shipments remaining to be loaded/unloaded.
         * Required: false
         * Array: false
         */
        this.shipmentsRemainingCount = undefined;
        /**
         * The total cube of all the shipments that are remaining to be loaded.
         * Required: false
         * Array: false
         */
        this.remainingToLoadCube = undefined;
    }
}
/**
 * Path parameters used to list break trailers.
 */
class ListBreakTrailersPath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to list break trailers.
 */
class ListBreakTrailersQuery {
    constructor() {
        /**
         * The plan date for which to get the trailers. If not supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The sector ID which is used to filter the list of doors.
         * Required: false
         * Array: false
         */
        this.sectorNbr = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list break trailers.
 */
class ListBreakTrailersResp {
    constructor() {
        /**
         * The list of trailers to be worked on at the SIC and shift.
         * Required: false
         * Array: true
         */
        this.breakTrailers = undefined;
    }
}
/**
 *
 */
class ListCrossDockTrailersPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The date for which the cross dock plan is being prepared.
         * Required: true
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The code associated with the shift.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class ListCrossDockTrailersQuery {
    constructor() {
        /**
         * The client delegate value which is used to filter out the result set. When true only the trailers included in the plan are returned. When false only the trailers that are excluded from the plan are returned. When the indicator is not present, then all of the trailers are listed.
         * Required: false
         * Array: false
         */
        this.includedInd = undefined;
        /**
         * The unique identifier that is assigned to the selection profile.  It is used to reduce the dataset based on the configured inbound selection criteria found in SCO.
         * Required: false
         * Array: false
         */
        this.selectionProfileId = undefined;
        /**
         * The code which determines whether the information retrieved will include zones, only zones, or no zones.  This is used for searching unassigned deliveries.
         * Required: false
         * Array: false
         */
        this.zoneIndicatorCd = undefined;
    }
}
/**
 *
 */
class ListCrossDockTrailersResp {
    constructor() {
        /**
         * The summary of the loaded shipments, handling units, or pickup requests. These statistics are used to highlight the combined weight, cube, motor moves, loose pieces, hazmat count, and bill count.
         * Required: false
         * Array: false
         */
        this.statistics = undefined;
        /**
         * The list of cross dock trailers to evaluate for planning purposes. Each trailer will be included in or excluded from the cross dock plan.
         * Required: false
         * Array: true
         */
        this.crossDockTrailers = undefined;
    }
}
/**
 *
 */
class ListRemainingToLoadShipmentsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class ListRemainingToLoadShipmentsQuery {
    constructor() {
        /**
         * The service center identification code of the lane.
         * Required: false
         * Array: false
         */
        this.laneSicCd = undefined;
        /**
         * The service center identification code for the lane.
         * Required: false
         * Array: false
         */
        this.moveToSicCd = undefined;
        /**
         * The service center identification code of the trailer load destination.
         * Required: false
         * Array: false
         */
        this.closeToSicCd = undefined;
        /**
         * The door number on the dock.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListRemainingToLoadShipmentsResp {
    constructor() {
        /**
         * The list of remaining shipments to load.
         * Required: false
         * Array: true
         */
        this.remainingToLoadShipments = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
        /**
         * The route associated with the remaining to load shipments.
         * Required: false
         * Array: false
         */
        this.suggestedRoute = undefined;
        /**
         * The total bill count of all the parent PROs.
         * Required: false
         * Array: false
         */
        this.billCount = undefined;
        /**
         * The total count of all the child PROs that are loaded.
         * Required: false
         * Array: false
         */
        this.childProCount = undefined;
        /**
         * The total count of parent PROs that are partially loaded.
         * Required: false
         * Array: false
         */
        this.partialParentProCount = undefined;
        /**
         * The total volume in cubic feet of the loaded shipments.
         * Required: false
         * Array: false
         */
        this.volumeCubicFeet = undefined;
        /**
         * The total weight of all the loaded shipments.
         * Required: false
         * Array: false
         */
        this.totalWeight = undefined;
        /**
         * The total count of all loose pieces of shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.loosePiecesCount = undefined;
        /**
         * The total count of all the hazmat shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.hazmatShipmentsCount = undefined;
        /**
         * The total count of all the guaranteed shipments that are loaded.
         * Required: false
         * Array: false
         */
        this.guaranteedShipmentCount = undefined;
        /**
         * The total count of all the G12 Shipments loaded.
         * Required: false
         * Array: false
         */
        this.guaranteedNoonShipmentCount = undefined;
        /**
         * The total count of all the freezable shipments loaded.
         * Required: false
         * Array: false
         */
        this.freezableShipmentCount = undefined;
        /**
         * The total count of parent PROs that are partially loaded.
         * Required: false
         * Array: false
         */
        this.totalMotorMovesLoadedCount = undefined;
        /**
         * The number of parent PROs that are not loaded (at all) onto the trailer.  This does not include partially loaded parent PROs.
         * Required: false
         * Array: false
         */
        this.notLoadedParentProCount = undefined;
    }
}
/**
 * Path parameters used to list reship freight trailers.
 */
class ListReshipFreightTrailersPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to list reship freight trailers.
 */
class ListReshipFreightTrailersQuery {
    constructor() {
        /**
         * The plan date for which to retrieve the trailers. If is isn't supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * If set to true, then trailers from the next working day are also included.
         * Required: false
         * Array: false
         */
        this.nextWorkDayInd = undefined;
        /**
         * The unique identifier of the selection profile.
         * Required: false
         * Array: false
         */
        this.selectionProfileId = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list reship freight trailers.
 */
class ListReshipFreightTrailersResp {
    constructor() {
        /**
         * The list of trailers associated with the XDock plan.
         * Required: false
         * Array: true
         */
        this.plannedTrailers = undefined;
        /**
         * The list of trailers not associated with the XDock plan.
         * Required: false
         * Array: true
         */
        this.excludedTrailers = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Path parameters used to list XDock Plan shipments.
 */
class ListShipmentsInDockPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the door details are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters used to list XDock Plan shipments.
 */
class ListShipmentsInDockPlanQuery {
    constructor() {
        /**
         * The plan date for which the shipments will be retrieved. If is isn't supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The codes associated with the progress for the dock shipments.  Permitted values: NotStripped, Stripped, and TConned.
         * Required: false
         * Array: true
         */
        this.xdockProgressCds = undefined;
        /**
         * The type of dock shipment.  Permitted values:: Dock, Pickup, Reship, and Strand.
         * Required: false
         * Array: false
         */
        this.dockShipmentTypeCd = undefined;
        /**
         * The shipment's destination SIC.
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         * The SIC of the FAC for the plan.
         * Required: false
         * Array: false
         */
        this.facCd = undefined;
        /**
         * The sector number for the door.
         * Required: false
         * Array: false
         */
        this.doorSectorNbr = undefined;
        /**
         * The number assigned to the door.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The type of dock shipment list that will be returned.  Permitted values: Dirverted and Excluded.
         * Required: false
         * Array: false
         */
        this.dockShipmentListTypeCd = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to list XDock Plan shipments.
 */
class ListShipmentsInDockPlanResp {
    constructor() {
        /**
         * List of Shipments that are in the XDOCK Plan
         * Required: false
         * Array: true
         */
        this.dockShipments = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListShipmentsByTrailerNbrPath {
    constructor() {
        /**
         * The concatenation of the trailer prefix and suffix.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 *
 */
class ListShipmentsByTrailerNbrRqst {
    constructor() {
        /**
         * The list of codes associated with the client control delegates which are used to retrieve the additional loaded unit attributes based on the end client's use case.
         * Required: false
         * Array: true
         */
        this.trailerLoadedUnitDetailCds = undefined;
    }
}
/**
 *
 */
class ListShipmentsByTrailerNbrResp {
    constructor() {
        /**
         * The list of loaded units, which consist of Shipments, Handling Units, and Pickup Requests.
         * Required: false
         * Array: true
         */
        this.loadedUnits = undefined;
        /**
         * The summary of the loaded shipments, handling units, or pickup requests. These statistics are used to highlight the combined weight, cube, motor moves, loose pieces, hazmat count, and bill count.
         * Required: false
         * Array: false
         */
        this.statistics = undefined;
    }
}
/**
 * Path parameters which are used to list suggested doors.
 */
class ListSuggestedDoorsPath {
    constructor() {
        /**
         * The location associated with the door.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for which the doors are requested.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Query parameters which are used to list suggested doors.
 */
class ListSuggestedDoorsQuery {
    constructor() {
        /**
         * The unique identifier of the route.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The prefix of the route.
         * Required: false
         * Array: false
         */
        this.routePrefix = undefined;
        /**
         * The suggested trailer length.
         * Required: false
         * Array: false
         */
        this.trailerLengthFeet = undefined;
        /**
         * Indicates whether the suggested trailer has liftgate.
         * Required: false
         * Array: false
         */
        this.lifgateInd = undefined;
    }
}
/**
 * Response to the request to list suggested doors.
 */
class ListSuggestedDoorsResp {
    constructor() {
        /**
         * The list of suggested doors.
         * Required: false
         * Array: true
         */
        this.doors = undefined;
    }
}
/**
 * Path parameters used to update the accuracy check override for a trailer or shipment.
 */
class OverrideTrailerShipmentAccuracyCheckPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift for which the override will be performed.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to update the accuracy check override for a trailer or shipment.
 */
class OverrideTrailerShipmentAccuracyCheckRqst {
    constructor() {
        /**
         * The version of the app used in the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The badge number of the employee.
         * Required: false
         * Array: false
         */
        this.supervisorBadgeNbr = undefined;
        /**
         * The employee ID of the supervisor who is authorizing the request.
         * Required: false
         * Array: false
         */
        this.supervisorEmployeeId = undefined;
        /**
         * The unique identifier of the trailer equipment that is being overriden.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * If set to true, then the shipment will be overridden for the accuracy check.
         * Required: false
         * Array: false
         */
        this.shipmentOverrideInd = undefined;
        /**
         * If set to true, then the trailer will be overridden for the accuracy check.
         * Required: false
         * Array: false
         */
        this.trailerOverrideInd = undefined;
        /**
         * The business identifier of the parent shipment.
         * Required: false
         * Array: false
         */
        this.parentProNbr = undefined;
        /**
         * The business identifier of the handling unit.
         * Required: false
         * Array: false
         */
        this.trackingProNbr = undefined;
        /**
         * The concatentation of the trailer prefix and suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 * Response to the request to update the accuracy check override for a trailer or shipment.
 */
class OverrideTrailerShipmentAccuracyCheckResp {
    constructor() {
        /**
         * The Dimensions Check Trailer record that was updated.
         * Required: false
         * Array: false
         */
        this.dimensionsCheckTrailer = undefined;
    }
}
/**
 *
 */
class RemoveTrailersFromDockPlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code for the plan.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class RemoveTrailersFromDockPlanRqst {
    constructor() {
        /**
         * The plan date for the XDock Plan.  If not supplied, then the current date will be used.
         * Required: false
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The list of trailer numbers to exclude from the cross dock plan.
         * Required: true
         * Array: true
         */
        this.trailerNbrs = undefined;
    }
}
/**
 *
 */
class RemoveTrailersFromDockPlanResp {
    constructor() {
        /**
         * The list of trailers with errors that occurred while removing.
         * Required: true
         * Array: true
         */
        this.equipment = undefined;
        /**
         * The list of error messages associated with the trailers.
         * Required: false
         * Array: true
         */
        this.dataValidationErrors = undefined;
    }
}
/**
 *
 */
class RemoveTrailersFromRoutePlanPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The date for which the cross dock plan is being prepared.
         * Required: true
         * Array: false
         */
        this.planDate = undefined;
        /**
         * The code associated with the shift.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class RemoveTrailersFromRoutePlanRqst {
    constructor() {
        /**
         * The list of trailer numbers to exclude from the route plan.
         * Required: false
         * Array: true
         */
        this.trailerNbrs = undefined;
    }
}
/**
 * Path parameters used to transfer trailer contents from a trailer to a dock location or another trailer at a door.
 */
class TransferTrailerContentsPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 * Request to transfer trailer contents from a trailer to a dock location or another trailer at a door.
 */
class TransferTrailerContentsRqst {
    constructor() {
        /**
         * The trailer number - equipment prefix and suffix - from where the contents will be transferred.
         * Required: true
         * Array: false
         */
        this.fromTrailerNbr = undefined;
        /**
         * The door number to which the trailer contents will be transferred.
         * Required: false
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The name of the dock location to which the trailer contents will be be transferred.
         * Required: false
         * Array: false
         */
        this.dockName = undefined;
        /**
         * The date and time when the transfer was initiated.
         * Required: false
         * Array: false
         */
        this.transferDateTime = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user who is requesting the transfer.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * The employee ID of the supervisor who is authorizing the transfer.
         * Required: false
         * Array: false
         */
        this.supervisorEmployeeId = undefined;
        /**
         * If set to true, then Hazmat validations will be performed.
         * Required: false
         * Array: false
         */
        this.applyHazmatValidationInd = undefined;
        /**
         * Indicates whether any warnings, that occurred while transfering the contents, will be overriden.
         * Required: false
         * Array: false
         */
        this.errorOverrideInd = undefined;
    }
}
/**
 * Response to the request to transfer trailer contents from a trailer to a dock location or another trailer at a door.
 */
class TransferTrailerContentsResp {
    constructor() {
        /**
         * The list of error messages related to the transfer.
         * Required: false
         * Array: true
         */
        this.validationErrors = undefined;
    }
}
/**
 * Path parameters used to update a trailer and DSR assignment.
 */
class UpdateTrailerDsrAssignmentPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The unique identifier of the trailer.
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 * Request to update update a trailer and DSR assignment.
 */
class UpdateTrailerDsrAssignmentRqst {
    constructor() {
        /**
         * The employee ID of the DSR who is assigned to the trailer.
         * Required: true
         * Array: false
         */
        this.dsrEmployeeId = undefined;
        /**
         * The trailer suffix number.
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         * The trailer prefix number.
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         * The date and time when the DSR was assigned to the trailer.
         * Required: false
         * Array: false
         */
        this.startDateTime = undefined;
        /**
         * The date and time when the DSR was unassigned from the trailer.
         * Required: false
         * Array: false
         */
        this.endDateTime = undefined;
    }
}
/**
 * Response to the request to update a trailer and DSR assignment.
 */
class UpdateTrailerDsrAssignmentResp {
    constructor() {
        /**
         * The trailer DSR assignment that was updated.
         * Required: false
         * Array: false
         */
        this.trailerDsrAssignment = undefined;
    }
}
/**
 *
 */
class UpdateTrailerHeadloadShipmentsPath {
    constructor() {
        /**
         * The service center identification code associated with the trailer.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift code associated with the trailer.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The concatenation of the prefix and suffix for the trailer to which the shipments belong.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 *
 */
class UpdateTrailerHeadloadShipmentsRqst {
    constructor() {
        /**
         * The list of headload shipments that will be updated.
         * Required: true
         * Array: true
         */
        this.headloadShipments = undefined;
        /**
         * The code associated with whether the freight in the head of the trailer is loosely loaded or on skids.
         * Required: true
         * Array: false
         */
        this.headloadLooseOrSkidCd = undefined;
        /**
         * The total length of space occupied by headload shipments.
         * Required: true
         * Array: false
         */
        this.headloadNbrOfFeet = undefined;
        /**
         * The destination service center for shipments marked as headload.
         * Required: false
         * Array: false
         */
        this.headloadDestinationSic = undefined;
    }
}
/**
 *
 */
class UpdateTrailerHeadloadShipmentsResp {
    constructor() {
        /**
         * The concatenation of the prefix and suffix for the trailer to which the shipments belong.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The list of shipments that were upserted.
         * Required: false
         * Array: true
         */
        this.headloadShipments = undefined;
        /**
         * The Head Load Detail for the trailer that was updated.
         * Required: false
         * Array: false
         */
        this.headLoadDetail = undefined;
    }
}
/**
 *
 */
class UpdateTrailerLoadDeckCountPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The shift when the load deck count is updated.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: true
         * Array: false
         */
        this.shiftCd = undefined;
        /**
         * The door number associated with the trailer.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
    }
}
/**
 *
 */
class UpdateTrailerLoadDeckCountRqst {
    constructor() {
        /**
         * The count of load deck items.
         * Required: true
         * Array: false
         */
        this.loadDeckCount = undefined;
    }
}
/**
 *
 */
class UpdateTrailerLoadDeckCountResp {
    constructor() {
        /**
         * The updated load deck count.
         * Required: false
         * Array: false
         */
        this.loadDeckCount = undefined;
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
    }
}
/**
 * Request payload to add a new Foreign Equipment
 */
class AddForeignEquipmentRqst {
    constructor() {
        /**
         * The location that is requesting to add the foreign equipment.
         * Required: true
         * Array: false
         */
        this.responsibleSicCd = undefined;
        /**
         * The details about the Foreign Equipment which will be added.
         * Required: true
         * Array: true
         */
        this.foreignEquipment = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
class AddForeignEquipmentResp {
    constructor() {
        /**
         * The details about the Foreign Equipment which were added.
         * Required: false
         * Array: true
         */
        this.foreignEquipment = undefined;
    }
}
/**
 * Request to perform a bulk update for Status and Remarks for one or more Equipment records.
 */
class BulkUpdateEquipmentStatusRemarkRqst {
    constructor() {
        /**
         * The list of EquipmentStatusRemark which will be used to perform the bulk update.
         * Required: true
         * Array: true
         */
        this.equipmentStatusRemarks = undefined;
    }
}
/**
 * Response to the request to perform a bulk update for Status and Remarks for one or more Equipment records.
 */
class BulkUpdateEquipmentStatusRemarkResp {
    constructor() {
        /**
         * The list of EquipmentStatusRemark which was used to perform the bulk update.
         * Required: false
         * Array: true
         */
        this.equipmentStatusRemarks = undefined;
    }
}
/**
 *
 */
class CreateEquipmentEventRqst {
    constructor() {
        /**
         * Details about the Equipment Event to be created.
         * Required: true
         * Array: false
         */
        this.equipmentEvent = undefined;
        /**
         * The service center identification code.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The code associated with the shift.  Permitted values: DayReship, Inbound, NightFAC, and Outbound.
         * Required: false
         * Array: false
         */
        this.shiftCd = undefined;
    }
}
/**
 *
 */
class CreateEquipmentEventResp {
    constructor() {
        /**
         * Details about the Equipment Event that was created.
         * Required: false
         * Array: false
         */
        this.equipmentEvent = undefined;
    }
}
/**
 * Request to create an equipment-employee association.
 */
class CreateEquipmentScanRqst {
    constructor() {
        /**
         * The service center where the forklift is located.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The unique identifer for the employee who using the forklift.
         * Required: true
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * The equipment prefix-suffix.
         * Required: true
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The type of equipment that was scanned.  E.g. Dolly, Forklift, Hostlers, etc.
         * Required: false
         * Array: true
         */
        this.equipmentTypeCds = undefined;
    }
}
/**
 * Response to the request to create an equipment-employee association.
 */
class CreateEquipmentScanResp {
    constructor() {
        /**
         * The equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.equipmentNbr = undefined;
        /**
         * The equipment-employee association details.
         * Required: false
         * Array: false
         */
        this.equipmentOperator = undefined;
    }
}
/**
 * Request to associate Forklift with an Operator
 */
class CreateForkliftScanRqst {
    constructor() {
        /**
         * Sic where the forklift is located
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * Identifier for the employee using the forklift
         * Required: true
         * Array: false
         */
        this.employeeId = undefined;
        /**
         * Forklift Equipment Prefix - Suffix
         * Required: true
         * Array: false
         */
        this.forkliftNbr = undefined;
    }
}
/**
 * Response to associate Forklift with an Operator
 */
class CreateForkliftScanResp {
    constructor() {
        /**
         * Forklift equipment prefix-suffix
         * Required: false
         * Array: false
         */
        this.forkliftNbr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.forkliftOperator = undefined;
    }
}
/**
 * Path parameter used to retrieve the forklift associated with the employee.
 */
class GetForkliftScanByEmployeePath {
    constructor() {
        /**
         * The identifier for the employee using the forklift.
         * Required: true
         * Array: false
         */
        this.employeeId = undefined;
    }
}
/**
 * Response to the request to retrieve the most recent forklift and employee association.
 */
class GetForkliftScanByEmployeeResp {
    constructor() {
        /**
         * The ID associated with the forklift equipment.
         * Required: false
         * Array: false
         */
        this.forkliftNbr = undefined;
        /**
         * Forklift employee association details.
         * Required: false
         * Array: false
         */
        this.forkliftOperator = undefined;
    }
}
/**
 *
 */
class GetLoadedShipmentsByEquipmentIdPath {
    constructor() {
        /**
         * The unique identifier of the equipment.
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class GetLoadedShipmentsByEquipmentIdResp {
    constructor() {
        /**
         * The loaded shipments for the equipment.
         * Required: false
         * Array: true
         */
        this.loadedShipments = undefined;
    }
}
/**
 *
 */
class GetLoadedShipmentSnapshotsByEquipmentIdPath {
    constructor() {
        /**
         * The unique identifier of the equipment.
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class GetLoadedShipmentSnapshotsByEquipmentIdQuery {
    constructor() {
        /**
         * The date and time when the last event occurred for the equipment.
         * Required: false
         * Array: false
         */
        this.currentEventDateTime = undefined;
    }
}
/**
 *
 */
class GetLoadedShipmentSnapshotsByEquipmentIdResp {
    constructor() {
        /**
         * The list of snapshots for the shipments loaded on the trailer.
         * Required: false
         * Array: true
         */
        this.loadedShipmentSnapshots = undefined;
    }
}
/**
 * Path parameter used to retrieve a list of equipment at a given SIC.
 */
class ListEquipmentBySicPath {
    constructor() {
        /**
         * The service center identification code.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
    }
}
/**
 * Query parameters used to retrieve a list of equipment at a given SIC.
 */
class ListEquipmentBySicQuery {
    constructor() {
        /**
         * The current status of the trailer at the door location.
         * Required: false
         * Array: false
         */
        this.trailerStatusCd = undefined;
        /**
         * The list of types of Equipment. E.g. Dolly, Power, Trailer, etc.
         * Required: false
         * Array: true
         */
        this.equipmentTypeCds = undefined;
        /**
         * The current status of the equipment at the SIC.
         * Required: false
         * Array: false
         */
        this.currentStatus = undefined;
        /**
         * The door number at the dock.
         * Required: false
         * Array: false
         */
        this.fromDoorNbr = undefined;
        /**
         * The door number at the dock.
         * Required: false
         * Array: false
         */
        this.toDoorNbr = undefined;
        /**
         * A list of equipment prefix and suffix concatenations.
         * Required: false
         * Array: true
         */
        this.equipmentNbrs = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response to the request to retrieve a list of equipment at a given SIC.
 */
class ListEquipmentBySicResp {
    constructor() {
        /**
         * Details for the Equipment record which matches the input criteria.
         * Required: false
         * Array: true
         */
        this.equipment = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Mandatory parameters to request list of Equipment Events
 */
class ListEquipmentEventsPath {
    constructor() {
        /**
         * Unique Id of the Equipment
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * Load Release Number of the Trailer when the trailer is Closed
         * Required: true
         * Array: false
         */
        this.loadReleaseNbr = undefined;
    }
}
/**
 * Query parameters to request list of Equipment Events
 */
class ListEquipmentEventsQuery {
    constructor() {
        /**
         * Type of Event that Occured. For eg. OPEN, CLOSE or LOAD
         * Required: false
         * Array: false
         */
        this.eventTypeCd = undefined;
        /**
         * Desc: Further break down of type code into sub types.
         *
         * Values
         * TRLR - Trailer Event
         * PICF - Full Photo Event
         * PICT - Thumbnail Photo Event
         * Required: false
         * Array: false
         */
        this.eventSubTypeCd = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 * Response message
 */
class ListEquipmentEventsResp {
    constructor() {
        /**
         * List of Equipment Events
         * Required: false
         * Array: true
         */
        this.equipmentEvents = undefined;
        /**
         * Pagination information to retrieve the list.
         * Required: false
         * Array: false
         */
        this.listInfo = undefined;
    }
}
/**
 *
 */
class ListLoadedProsByEquipmentIdPath {
    constructor() {
        /**
         * The unique identifier of the equipment.
         * Required: true
         * Array: false
         */
        this.equipmentId = undefined;
    }
}
/**
 *
 */
class ListLoadedProsByEquipmentIdResp {
    constructor() {
        /**
         * The list of loaded parent PROs.
         * Required: false
         * Array: true
         */
        this.loadedShipments = undefined;
        /**
         * The list of loaded handling units for the given equipment ID.
         * Required: false
         * Array: true
         */
        this.loadedHandlingUnits = undefined;
    }
}
/**
 *
 */
class GetTrailerLoadQualityRatingQuery {
    constructor() {
        /**
         * The trailer number prefix. E.g. 311 or 0311 for 311-7356.
         * Required: true
         * Array: false
         */
        this.equipmentPrefix = undefined;
        /**
         * The trailer number suffix. E.g. 7356 for 311-7356. Unlike the prefix, this should never be 0-padded.
         * Required: true
         * Array: false
         */
        this.equipmentSuffixNbr = undefined;
        /**
         * The identification code for the service center at which the trailer is docked.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The number of the door at which the trailer is docked.
         * Required: true
         * Array: false
         */
        this.doorNbr = undefined;
        /**
         * The code associated with the type of equipment event for which the trailer rating is going to be retrieved. Permitted values: Open and Close.
         * Required: true
         * Array: false
         */
        this.equipmentEventTypeCd = undefined;
        /**
         * The RFC 3339 compliant timestamp that corresponds to when the picture of the trailer was taken, which is around the time of load quality rating.
         * Required: true
         * Array: false
         */
        this.pictureTakenDateTime = undefined;
    }
}
/**
 *
 */
class GetTrailerLoadQualityRatingResp {
    constructor() {
        /**
         * The load quality rating, 1 (lowest) to 3 (highest), of the trailer.
         * Required: false
         * Array: false
         */
        this.loadQualityRatingNbr = undefined;
        /**
         * The codes that are associated with the reason for the load quality rating.
         * Required: false
         * Array: true
         */
        this.reasonCds = undefined;
        /**
         * The RFC 3339 timestamp that corresponds to when the load quality rating event happened.
         * Required: false
         * Array: false
         */
        this.eventOccurredDateTime = undefined;
    }
}
/**
 * Path parameters used to get trailer specification.
 */
class GetTrailerSpecificationPath {
    constructor() {
        /**
         * The trailer specification type.
         * Required: false
         * Array: false
         */
        this.trailerTypeCd = undefined;
        /**
         * The trailer specification sub type.
         * Required: false
         * Array: false
         */
        this.trailerSubTypeCd = undefined;
    }
}
/**
 * Query parameters used to get trailer specification.
 */
class GetTrailerSpecificationQuery {
    constructor() {
        /**
         * The string representation of the trailer specification's effective date.
         * Required: false
         * Array: false
         */
        this.effectiveDt = undefined;
    }
}
/**
 * Response to the request to get trailer specification.
 */
class GetTrailerSpecificationResp {
    constructor() {
        /**
         * The trailer specification.
         * Required: false
         * Array: false
         */
        this.trailerSpecification = undefined;
    }
}
/**
 *
 */
class ListTrailerContentQuery {
    constructor() {
        /**
         * The unique identifier of a trailer.
         * Required: false
         * Array: false
         */
        this.equipmentId = undefined;
        /**
         * The trailer prefix identifier.
         * Required: false
         * Array: false
         */
        this.equipmentIdPrefix = undefined;
        /**
         * The trailer suffix number.
         * Required: false
         * Array: false
         */
        this.equipmentIdSuffixNbr = undefined;
        /**
         * The concatenation of the equipment prefix-suffix.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The unique identifier of the device making the request.
         * Required: false
         * Array: false
         */
        this.deviceId = undefined;
        /**
         * The version of the app used on the device.
         * Required: false
         * Array: false
         */
        this.appVersion = undefined;
        /**
         * The employee ID of the user that is requesting the information.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
    }
}
/**
 *
 */
class ListTrailerContentResp {
    constructor() {
        /**
         * The content of the trailer assciated with the equipment identifier provided.
         * Required: false
         * Array: false
         */
        this.trailerContent = undefined;
    }
}
/**
 * Enter comments
 */
class ListEnsembleConfigurationsResp {
    constructor() {
        /**
         * List of message queues - AQ and JMS
         * Required: false
         * Array: true
         */
        this.queues = undefined;
        /**
         * List of subscribers - Pub/Sub
         * Required: false
         * Array: true
         */
        this.subscriptions = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.apiChannels = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.timers = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.emails = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.files = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.jmsQueues = undefined;
    }
}
class TimerConfig {
    constructor() {
        /**
         * Name of the timer.
         * Required: true
         * Array: false
         */
        this.name = undefined;
        /**
         * Interval for timer. Specify in seconds. The value is set in Octopus using the property sym.timer.<name>.intervalInSeconds
         * Required: true
         * Array: false
         */
        this.intervalInSeconds = undefined;
        /**
         * Specify the timer behavior. If fixedRate is set to true, the timer will fire an ensemble once every interval regardless of whether previous tasks are executing.
         * 						If fixedRate is set to false, the timer will be scheduled to fire after the specified interval, once the current execution is complete.
         * 						For both settings, it does not matter whether the ensemble execution is successful or not for the next timer event to be fired.
         * Required: true
         * Array: false
         */
        this.fixedRate = undefined;
    }
}
class Timer {
    constructor() {
        /**
         * Configuration of the timer.
         * Required: true
         * Array: false
         */
        this.configuration = undefined;
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: true
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Path parameters for listTimerEnsembles
 */
class ListTimerEnsemblesPath {
    constructor() {
        /**
         * The name of the timer ensemble from which the list of timers is requested
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for listTimerEnsembles
 */
class ListTimerEnsemblesResp {
    constructor() {
        /**
         * List of timers defined in this ensemble.
         * Required: false
         * Array: true
         */
        this.timers = undefined;
    }
}
/**
 * Path parameters for startTimerEnsemble
 */
class StartTimerEnsemblePath {
    constructor() {
        /**
         * The name of the timer to start
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for startTimerEnsemble
 */
class StartTimerEnsembleResp {
    constructor() {
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: false
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Path parameters for stopTimerEnsemble
 */
class StopTimerEnsemblePath {
    constructor() {
        /**
         * The name of the timer to stop
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for stopTimerEnsemble
 */
class StopTimerEnsembleResp {
    constructor() {
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: false
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Request for startAsynchPrintChEnsemble
 */
class StartAsynchPrintChEnsembleRqst {
    constructor() {
        /**
         * The name of the ensemble to start
         * Required: false
         * Array: false
         */
        this.ensembleName = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The payload for the ensemble process
         * Required: false
         * Array: false
         */
        this.payload = undefined;
    }
}
/**
 * Path parameters for startAsynchPrintChEnsemble
 */
class StartAsynchPrintChEnsemblePath {
    constructor() {
        /**
         * The name of the channel in which this ensemble will be executed
         * Required: false
         * Array: false
         */
        this.channelName = undefined;
    }
}
/**
 * Query parameters for startAsynchPrintChEnsemble
 */
class StartAsynchPrintChEnsembleQuery {
    constructor() {
        /**
         * Send true if a synchronous response is required. Normally, channel execute asynchronously.
         * Required: false
         * Array: false
         */
        this.synchronous = undefined;
    }
}
/**
 * Response for startAsynchPrintChEnsemble
 */
class StartAsynchPrintChEnsembleResp {
    constructor() {
        /**
         * Instance ID of the ensemble that was started.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request for startPrintTrlrManifestChEnsemble
 */
class StartPrintTrlrManifestChEnsembleRqst {
    constructor() {
        /**
         * The name of the ensemble to start
         * Required: false
         * Array: false
         */
        this.ensembleName = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The payload for the ensemble process
         * Required: false
         * Array: false
         */
        this.payload = undefined;
    }
}
/**
 * Path parameters for startPrintTrlrManifestChEnsemble
 */
class StartPrintTrlrManifestChEnsemblePath {
    constructor() {
        /**
         * The name of the channel in which this ensemble will be executed
         * Required: false
         * Array: false
         */
        this.channelName = undefined;
    }
}
/**
 * Query parameters for startPrintTrlrManifestChEnsemble
 */
class StartPrintTrlrManifestChEnsembleQuery {
    constructor() {
        /**
         * Send true if a synchronous response is required. Normally, channel execute asynchronously.
         * Required: false
         * Array: false
         */
        this.synchronous = undefined;
    }
}
/**
 * Response for startPrintTrlrManifestChEnsemble
 */
class StartPrintTrlrManifestChEnsembleResp {
    constructor() {
        /**
         * Instance ID of the ensemble that was started.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Contains basic key information needed to search for equipment.
 */
class DockOperationsEventPayload extends PayloadType {
    constructor() {
        super(...arguments);
        /**
         * The history of all the movements of a PRO.
         * Required: false
         * Array: false
         */
        this.dockShipmentActivity = undefined;
        /**
         * The details for the Equipment.
         * Required: false
         * Array: false
         */
        this.equipment = undefined;
        /**
         * The details for what is loaded on a trailer.
         * Required: false
         * Array: false
         */
        this.trailerLoad = undefined;
        /**
         * The event snapshot details for DockOps equipment.
         * Required: false
         * Array: false
         */
        this.snapshot = undefined;
        /**
         * The Dock Location details for a given dock instance ID.
         * Required: false
         * Array: false
         */
        this.dockLocation = undefined;
    }
}
/**
 * This type will be used to publish documents targeted for Elastic Search on a Kafka topic. The type includes KafkaMessageHeader.
 */
class EnsembleStateSearchRecordMessage extends EnsembleStateSearchRecord {
    constructor() {
        super(...arguments);
        /**
         * Additional details about the document
         * Required: false
         * Array: false
         */
        this.messageHeader = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkDockOperationsModule, DockOperationsApiService, GetEnsembleStatusCountsPath, GetEnsembleStatusCountsResp, GetQueuePendingCountPath, GetQueuePendingCountResp, RestartEnsemblePath, RestartEnsembleRqst, RestartEnsembleResp, ResumeEnsemblePath, ResumeEnsembleRqst, ResumeEnsembleResp, StartMessageDrivenEnsembleRqst, StartMessageDrivenEnsembleResp, KillEnsembleRqst, KillEnsembleResp, StopQueuePath, StopQueueWebhookPath, StopQueueWebhookQuery, StartQueuePath, ListQueuesResp, ListExpiredMessagesPath, ListExpiredMessagesResp, DeleteExpiredMessagesPath, DeleteExpiredMessagesQuery, DeleteExpiredMessagesResp, ReplayMessagePath, GetPubSubStatusCountsPath, GetPubSubStatusCountsResp, StartSubscriptionPath, StopSubscriptionPath, GetUndeliveredMessagesPath, GetUndeliveredMessagesResp, ListSubscriptionsResp, GetSubscriptionPath, GetSubscriptionResp, MessageDrivenEnsemblePayload, DynamicMessageDrivenPayload, TransactionEventEnsemblePayload, DeleteExpiredMessageStatus, KillEnsembleStatus, EnsembleStateSearchRecord, Payload, EnsembleState, NestedEnsembleState, EnsembleExecutionContext, MinuetState, EnsembleMetrics, PubSubMetrics, QueueMetrics, AuxMessagePublishers, EnsembleConfiguration, Subscription, LTLEventDockOperations, BulkUpdateResp, BulkUpdateItemError, BulkApiRespItem, EsAggregationFieldRqst, EsDynamicPivotRqst, EsAggregationRqst, EsAggregationFieldResp, EsAggregationResp, EnsembleStateSearchFilterNot, EnsembleStateSearchFilterOr, EnsembleStateSearchFilterAnd, EnsembleStateSearchFilter, GetElasticDocumentEnsembleStatePath, GetElasticDocumentEnsembleStateQuery, GetElasticDocumentEnsembleStateResp, GetElasticDocumentEnsembleStateCountQuery, GetElasticDocumentEnsembleStateCountResp, UpdateElasticDocumentEnsembleStateRqst, UpdateElasticDocumentEnsembleStatePath, UpdateElasticDocumentEnsembleStateResp, BulkUpdateElasticDocumentEnsembleStateResp, DeleteElasticDocumentEnsembleStatePath, DeleteElasticDocumentEnsembleStateResp, SearchEnsembleStateUnfilteredRqst, SearchEnsembleStateUnfilteredResp, ExportEnsembleStateUnfilteredRqst, RegisterFilterEnsembleStateUnfilteredRqst, RegisterFilterEnsembleStateUnfilteredResp, UnregisterFilterEnsembleStateUnfilteredRqst, ChangesFeedEnsembleStateUnfilteredRqst, ListAggregationsEnsembleStateUnfilteredRqst, ListAggregationsEnsembleStateUnfilteredResp, Badgeassign, BadgeassignSnapshot, DeliveryNotification, DeliveryShipment, DeliveryShipmentSnapshot, DimensionsCheckDsrRecheck, DimensionsCheckLog, DimensionsCheckShipmentOverride, DimensionsCheckTrailer, DockActivity, DockLoadedHandlingUnit, DockLoadedHandlingUnitSnapshot, DockLoadedShipment, DockLoadedShipmentSnapshot, DockLocation, DockVisit, DockWorkAssignment, DoorAssignment, DoorPlanExtractStg, DoorPreference, EmployeeDevice, Equipment, EquipmentHist, EquipmentOperator, EquipmentSnapshot, Event, EventPhotoAnalysis, EventReason, EventReasonSnapshot, EventSnapshot, FloO2dFlowPlanDetailRo, HeadLoadDetail, InterfaceEmployee, InterfaceEmployeeSnapshot, KronosPerson, LoadDeck, LoadEquipmentHist, LoadHandlingUnitSnapshot, LoadReleaseNbr, LoadedEquipment, LoadedHandlingUnit, LoadedShipment, LoadedShipmentSnapshot, LocDoorPlanProfileRw, LocDoorPlanRw, LocDoorRw, LocLoadPlanRo, LocOperationsServiceCenterProfitabilityRo, LocStripDoorOverrideRw, LocationExceptionCtl, NotificationShipment, OperationsLoadEquipmentHazard, OperationsTrailerRoutingSnapshot, Placard, PlanningEvent, PlanningEventTrailer, PlanningTrailer, PlanningTrailerHist, ProMovementHist, ProMovementHistSnapshot, ProfileExcludeTrailer, ProfileSic, Projection, RefEquipmentIdXrefRo, RefScacCodeRo, RefStandardCodeRo, Route, RouteHandlingUnit, RouteShipment, RouteShipmentSnapshot, RouteSnapshot, RouteTrip, RouteTripSnapshot, Schedule, ScheduleHist, ScheduledDriver, ScoDoorPlan, ScoDoorPlanDestination, ScoDoorPlanProfile, ScoEvent, ScoEventSnapshot, SelectionProfile, ShmEventLogRw, ShmHandlingUnitMovementRw, ShmHandlingUnitRw, ShmMovementRw, ShmShipmentRw, ThruHandlingUnit, ThruShipment, TrailerDsrAssignment, TrailerInspection, TrailerLoad, TrailerLoadHist, TrailerRouting, TrailerSpecification, Trip, TripDriver, TripEquipment, TripNode, TripNodeActivity, TripNodeActivitySnapshot, TripNodeSnapshot, TripSnapshot, XdockHandlingUnit, XdockPlan, XdockShipment, EventWait, RetriggerEvent, SymphonyMessage, SymphonyQueue, TransactionEvent, TransactionEventDetail, AsynchReportPrintingPayload, BasicUnit, BreakTrailer, Consignee, CrossDockTrailer, CurrentPlanDoorAssignment, CustomerProfile, DeliveryTime, DockDoor, DockDoorPlan, DockDoorPlanDestination, DockDoorSetup, DockDoorTrailer, DockEmployee, DockPlanningTrailer, DockShipment, DockShipmentLoad, DoNotUse, DoorPlanRecommendation, DoorPlanShipment, DriverAvailability, EquipmentEvent, EquipmentMaintenanceIndicator, EquipmentStatusRemark, EvtDockOperationsSnapshot, ForeignEquipment, HandlingUnitOnTrailerOrDock, HeadloadDestination, HeadloadShipment, Leg, LoadedUnit, LoadLane, LoadLaneDestination, LoadLaneFreightFlow, LoadLeg, LoadToLocation, ManifestReport, NextBestLoadingAction, NonLoadedHandlingUnit, PrintTrailerManifestPayload, RoutedShipment, ShipmentDockHistory, ShipmentOnTrailerOrDock, ShipmentRoute, ShipmentSkeleton, ShipmentsOnTrailer, Shipper, SmartApiToken, Statistics, SuggestedDoor, SuggestedDoorRoute, SuggestedDoorTrailer, TargetDoorPlan, Trailer, TrailerCloseOption, TrailerCloseShipment, TrailerCompliance, TrailerContent, TrailerLoadStatusDoorRemark, TrailerSection, XdockShipmentLocation, ActivateDoorPlanProfileRqst, ActivateDoorPlanProfileResp, BacksynchDoorPlanProfileToDb2Rqst, BacksynchDoorPlanProfileToDb2Resp, CreateActiveDoorPlanForSicPath, CreateActiveDoorPlanForSicRqst, CreateActiveDoorPlanForSicResp, CreateDoorPlanPath, CreateDoorPlanRqst, CreateDoorPlanResp, CreateDoorPlanDestinationsPath, CreateDoorPlanDestinationsRqst, CreateDoorPlanDestinationsResp, CreateDoorPlanProfilePath, CreateDoorPlanProfileRqst, CreateDoorPlanProfileResp, CreateLoadLanesByDockPlanPath, CreateLoadLanesByDockPlanRqst, CreateWeeklyDefaultDoorPlanPath, CreateWeeklyDefaultDoorPlanRqst, CreateWeeklyDefaultDoorPlanResp, DeleteDoorPlanPath, DeleteDoorPlanQuery, DeleteDoorPlanResp, DeleteDoorPlanProfilePath, DeriveLoadLanesByDockPlanPath, DeriveLoadLanesByDockPlanQuery, DeriveLoadLanesByDockPlanResp, GetActiveDoorPlanPath, GetActiveDoorPlanResp, GetDestinationsByLoadLanePath, GetDestinationsByLoadLaneResp, GetDoorPlanByIdPath, GetDoorPlanByIdResp, GetDoorPlanMergeOptionsPath, GetDoorPlanMergeOptionsQuery, GetDoorPlanMergeOptionsResp, GetDoorPlanProfilePath, GetDoorPlanProfileResp, GetLoadLaneSummaryByPlanSicAndShiftPath, GetLoadLaneSummaryByPlanSicAndShiftQuery, GetLoadLaneSummaryByPlanSicAndShiftResp, ListDockShipmentSummariesPath, ListDockShipmentSummariesQuery, ListDockShipmentSummariesResp, ListDoorPlanHeadloadDestinationsPath, ListDoorPlanHeadloadDestinationsQuery, ListDoorPlanHeadloadDestinationsResp, ListDoorPlanProfilesPath, ListDoorPlanProfilesQuery, ListDoorPlanProfilesResp, ListDoorPlanRecommendationsPath, ListDoorPlanRecommendationsQuery, ListDoorPlanRecommendationsResp, ListHeadloadDestinationsByDoorPlanProfilePath, ListHeadloadDestinationsByDoorPlanProfileQuery, ListHeadloadDestinationsByDoorPlanProfileResp, ListHeadLoadShipmentsPath, ListHeadLoadShipmentsQuery, ListHeadLoadShipmentsResp, ListTargetDoorPlansForDestinationsPath, ListTargetDoorPlansForDestinationsQuery, ListTargetDoorPlansForDestinationsResp, RepairDoorPlanProfilePath, RepairDoorPlanProfileRqst, RevertDoorPlansPath, RevertDoorPlansRqst, RevertDoorPlansResp, UpdateDoorPlanPath, UpdateDoorPlanRqst, UpdateDoorPlanResp, UpdateDoorPlanHeadloadDestinationsPath, UpdateDoorPlanHeadloadDestinationsRqst, UpdateDoorPlansByActionPath, UpdateDoorPlansByActionRqst, UpdateDoorPlansByActionResp, GetDoorDetailsPath, GetDoorDetailsQuery, GetDoorDetailsResp, GetDoorSetupDetailsPath, GetDoorSetupDetailsQuery, GetDoorSetupDetailsResp, ListDockDoorPreferencesPath, ListDockDoorPreferencesQuery, ListDockDoorPreferencesResp, ListDoorsForDockWalkPath, ListDoorsForDockWalkQuery, ListDoorsForDockWalkResp, ListDoorsForLanePath, ListDoorsForLaneQuery, ListDoorsForLaneResp, MaintainDockDoorPreferencesRqst, MaintainDockDoorPreferencesResp, CreateDockLocationRqst, CreateDockLocationResp, DeleteDockLocationPath, GetDockLocationPath, GetDockLocationResp, ListDockLocationsQuery, ListDockLocationsResp, ListShipmentsInDockLocationPath, ListShipmentsInDockLocationQuery, ListShipmentsInDockLocationResp, UpdateDockLocationRemarksPath, UpdateDockLocationRemarksRqst, UpdateDockLocationRemarksResp, AssignShipmentsToRoutePath, AssignShipmentsToRouteRqst, AssignShipmentsToRouteResp, BulkUpsertHandlingUnitsFromDockRqst, GetCurrentDockEngineeredStandardPath, GetCurrentDockEngineeredStandardQuery, GetCurrentDockEngineeredStandardHeader, GetCurrentDockEngineeredStandardResp, GetCurrentMotorMovesPerHourHeader, GetCurrentMotorMovesPerHourPath, GetCurrentMotorMovesPerHourQuery, GetCurrentMotorMovesPerHourResp, GetDockShipmentDetailsPath, GetDockShipmentDetailsQuery, GetDockShipmentDetailsResp, GetDockShipmentLoadsQuery, GetDockShipmentLoadsResp, GetEmployeeDetailsByBadgeNbrPath, GetEmployeeDetailsByBadgeNbrResp, GetHandlingUnitProLoadPath, GetHandlingUnitProLoadQuery, GetHandlingUnitProLoadResp, GetNextBestLoadingActionForShipmentPath, GetNextBestLoadingActionForShipmentQuery, GetNextBestLoadingActionForShipmentResp, GetNextBestLoadingActionForTrailerPath, GetNextBestLoadingActionForTrailerQuery, GetNextBestLoadingActionForTrailerResp, GetPdfReportPath, GetPdfReportRqst, GetPdfReportResp, GetProFbdsDocWithCurrentLocationPath, GetProFbdsDocWithCurrentLocationResp, GetProLoadDetailsPath, GetProLoadDetailsQuery, GetProLoadDetailsResp, GetProXdockLocationsPath, GetProXdockLocationsQuery, GetProXdockLocationsResp, GetRouteManifestPath, GetRouteManifestQuery, GetRouteManifestResp, GetSmartApiTokenResp, GetTrailerDetailsByDoorPath, GetTrailerDetailsByDoorResp, GetTrailerLoadByEquipmentIdPath, GetTrailerLoadByEquipmentIdResp, ListAvailabilityForDriversPath, ListAvailabilityForDriversQuery, ListAvailabilityForDriversHeader, ListAvailabilityForDriversResp, ListCrossDockRoutesPath, ListCrossDockRoutesQuery, ListCrossDockRoutesResp, ListShipmentDockHistoryPath, ListShipmentDockHistoryQuery, ListShipmentDockHistoryResp, LoadProPath, LoadProRqst, LoadProResp, MaintainHeadloadsPath, MaintainHeadloadsRqst, MaintainHeadloadsResp, PrintDockCopyPath, PrintDockCopyRqst, PrintManifestReportsPath, PrintManifestReportsRqst, RecordDeviceLogonAndLogoutPath, RecordDeviceLogonAndLogoutRqst, RecordDeviceLogonAndLogoutResp, RecordShipmentDockExceptionPath, RecordShipmentDockExceptionRqst, RecordShipmentDockExceptionResp, SplitNonLoadedHandlingUnitsRqst, SplitNonLoadedHandlingUnitsResp, UpdateHandlingUnitExemptionPath, UpdateHandlingUnitExemptionRqst, UpdateShipmentDimensionsFromDockPath, UpdateShipmentDimensionsFromDockRqst, UpsertShipmentSkeletonFromDockRqst, DeleteLoadedHandlingUnitAsAdminPath, DeleteLoadedHandlingUnitAsAdminQuery, DeleteLoadedShipmentAsAdminPath, DeleteLoadedShipmentAsAdminQuery, GetShipmentOnTrailerOrDockPath, GetShipmentOnTrailerOrDockResp, ListHandlingUnitsOnTrailerOrDockRqst, ListHandlingUnitsOnTrailerOrDockResp, UpsertLoadedHandlingUnitAsAdminRqst, UpsertLoadedShipmentAsAdminRqst, AddTrailersToCrossDockPlanPath, AddTrailersToCrossDockPlanRqst, AssignTrailerToDoorPath, AssignTrailerToDoorRqst, AssignTrailerToDoorResp, AssignTrailerToDoorForDockManagerPath, AssignTrailerToDoorForDockManagerRqst, AssignTrailerToDoorForDockManagerResp, BulkUpdateTrailerLoadStatusDoorRemarksPath, BulkUpdateTrailerLoadStatusDoorRemarksRqst, BulkUpdateTrailerLoadStatusDoorRemarksResp, CloseCityTrailerPath, CloseCityTrailerRqst, CloseCityTrailerResp, CloseLinehaulTrailerPath, CloseLinehaulTrailerRqst, CloseLinehaulTrailerResp, CloseLinehaulTrailerPhotoAnalysisRqst, CloseLinehaulTrailerPhotoAnalysisResp, CompleteTrailerLoadUnloadPath, CompleteTrailerLoadUnloadRqst, CompleteTrailerLoadUnloadResp, DeriveTrailerCloseOptionsPath, DeriveTrailerCloseOptionsRqst, DeriveTrailerCloseOptionsResp, DivertShipmentsInDockPlanPath, DivertShipmentsInDockPlanRqst, DivertShipmentsInDockPlanResp, GetTrailerManifestPath, GetTrailerManifestQuery, GetTrailerManifestResp, ListBreakTrailersPath, ListBreakTrailersQuery, ListBreakTrailersResp, ListCrossDockTrailersPath, ListCrossDockTrailersQuery, ListCrossDockTrailersResp, ListRemainingToLoadShipmentsPath, ListRemainingToLoadShipmentsQuery, ListRemainingToLoadShipmentsResp, ListReshipFreightTrailersPath, ListReshipFreightTrailersQuery, ListReshipFreightTrailersResp, ListShipmentsInDockPlanPath, ListShipmentsInDockPlanQuery, ListShipmentsInDockPlanResp, ListShipmentsByTrailerNbrPath, ListShipmentsByTrailerNbrRqst, ListShipmentsByTrailerNbrResp, ListSuggestedDoorsPath, ListSuggestedDoorsQuery, ListSuggestedDoorsResp, OverrideTrailerShipmentAccuracyCheckPath, OverrideTrailerShipmentAccuracyCheckRqst, OverrideTrailerShipmentAccuracyCheckResp, RemoveTrailersFromDockPlanPath, RemoveTrailersFromDockPlanRqst, RemoveTrailersFromDockPlanResp, RemoveTrailersFromRoutePlanPath, RemoveTrailersFromRoutePlanRqst, TransferTrailerContentsPath, TransferTrailerContentsRqst, TransferTrailerContentsResp, UpdateTrailerDsrAssignmentPath, UpdateTrailerDsrAssignmentRqst, UpdateTrailerDsrAssignmentResp, UpdateTrailerHeadloadShipmentsPath, UpdateTrailerHeadloadShipmentsRqst, UpdateTrailerHeadloadShipmentsResp, UpdateTrailerLoadDeckCountPath, UpdateTrailerLoadDeckCountRqst, UpdateTrailerLoadDeckCountResp, AddForeignEquipmentRqst, AddForeignEquipmentResp, BulkUpdateEquipmentStatusRemarkRqst, BulkUpdateEquipmentStatusRemarkResp, CreateEquipmentEventRqst, CreateEquipmentEventResp, CreateEquipmentScanRqst, CreateEquipmentScanResp, CreateForkliftScanRqst, CreateForkliftScanResp, GetForkliftScanByEmployeePath, GetForkliftScanByEmployeeResp, GetLoadedShipmentsByEquipmentIdPath, GetLoadedShipmentsByEquipmentIdResp, GetLoadedShipmentSnapshotsByEquipmentIdPath, GetLoadedShipmentSnapshotsByEquipmentIdQuery, GetLoadedShipmentSnapshotsByEquipmentIdResp, ListEquipmentBySicPath, ListEquipmentBySicQuery, ListEquipmentBySicResp, ListEquipmentEventsPath, ListEquipmentEventsQuery, ListEquipmentEventsResp, ListLoadedProsByEquipmentIdPath, ListLoadedProsByEquipmentIdResp, GetTrailerLoadQualityRatingQuery, GetTrailerLoadQualityRatingResp, GetTrailerSpecificationPath, GetTrailerSpecificationQuery, GetTrailerSpecificationResp, ListTrailerContentQuery, ListTrailerContentResp, ListEnsembleConfigurationsResp, TimerConfig, Timer, ListTimerEnsemblesPath, ListTimerEnsemblesResp, StartTimerEnsemblePath, StartTimerEnsembleResp, StopTimerEnsemblePath, StopTimerEnsembleResp, StartAsynchPrintChEnsembleRqst, StartAsynchPrintChEnsemblePath, StartAsynchPrintChEnsembleQuery, StartAsynchPrintChEnsembleResp, StartPrintTrlrManifestChEnsembleRqst, StartPrintTrlrManifestChEnsemblePath, StartPrintTrlrManifestChEnsembleQuery, StartPrintTrlrManifestChEnsembleResp, DockOperationsEventPayload, EnsembleStateSearchRecordMessage };

